webpackJsonp([1],{

/***/ "./app/client/_data/actions.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addDataAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return removeDataAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return updateDataAction; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__("./node_modules/redux-actions/es/index.js");

var addDataAction = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('ADD_DATA');
var removeDataAction = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('REMOVE_DATA');
var updateDataAction = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('UPDATE_DATA');


/***/ }),

/***/ "./app/client/_data/middlewares.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = toggleLike;
/* harmony export (immutable) */ __webpack_exports__["b"] = toggleUserFollow;
/* harmony export (immutable) */ __webpack_exports__["c"] = toggleShopFollow;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__repositories_likeRepository__ = __webpack_require__("./app/client/_repositories/likeRepository.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_utils__ = __webpack_require__("./app/client/_helpers/utils.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__("./app/client/_data/actions.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__("./node_modules/lodash/lodash.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__repositories_userRepository__ = __webpack_require__("./app/client/_repositories/userRepository.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__selectors__ = __webpack_require__("./app/client/_data/selectors.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_data__ = __webpack_require__("./app/client/_helpers/data.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__user_selectors__ = __webpack_require__("./app/client/user/selectors.ts");








function toggleLike(model) {
    var resource = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_utils__["i" /* clientModelName */])(model);
    var likable = model;
    var like = !likable.isLiked;
    var count = like ? likable.likeCount + 1 : likable.likeCount - 1;
    return function (dispatch, getState) {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["b" /* updateDataAction */])({
            id: model.id,
            resource: resource,
            data: __WEBPACK_IMPORTED_MODULE_3_lodash__["chain"](likable).cloneDeep().set('isLiked', like).set('likeCount', count).value()
        }));
        __WEBPACK_IMPORTED_MODULE_0__repositories_likeRepository__["a" /* default */].toggle(model, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__user_selectors__["b" /* currentUserSelector */])(getState())).then(function () {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_utils__["k" /* toastSuccess */])("Successfully " + (like ? '' : 'un') + "liked " + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_utils__["l" /* apiModelNameToDisplayName */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_utils__["m" /* apiModelName */])(model)) + ".");
        });
    };
}
function toggleUserFollow(id, follower_id, is_followed) {
    return function (dispatch, getState) {
        var followed = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__selectors__["c" /* userByIdSelector */])(getState(), id);
        var follower = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__selectors__["c" /* userByIdSelector */])(getState(), follower_id);
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["b" /* updateDataAction */])({
            id: id,
            resource: __WEBPACK_IMPORTED_MODULE_6__helpers_data__["a" /* ResourceType */].user,
            data: __WEBPACK_IMPORTED_MODULE_3_lodash__["chain"](followed).cloneDeep()
                .set('isFollowed', !is_followed)
                .set('followersCount', !is_followed ? followed.followersCount + 1 : followed.followersCount - 1)
                .value()
        }));
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["b" /* updateDataAction */])({
            id: follower_id,
            resource: __WEBPACK_IMPORTED_MODULE_6__helpers_data__["a" /* ResourceType */].user,
            data: __WEBPACK_IMPORTED_MODULE_3_lodash__["chain"](follower).cloneDeep()
                .set('followingCount', !is_followed ? follower.followingCount + 1 : follower.followingCount - 1)
                .value()
        }));
        __WEBPACK_IMPORTED_MODULE_4__repositories_userRepository__["a" /* default */].toggleFollowUser(id, follower_id, is_followed).then(function () {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_utils__["k" /* toastSuccess */])("You've " + (is_followed ? 'un' : '') + "followed this user.");
        });
    };
}
function toggleShopFollow(id, follower_id, is_followed) {
    return function (dispatch, getState) {
        var followed = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__selectors__["g" /* shopByIdSelector */])(getState(), id);
        var follower = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__selectors__["c" /* userByIdSelector */])(getState(), follower_id);
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["b" /* updateDataAction */])({
            id: id,
            resource: __WEBPACK_IMPORTED_MODULE_6__helpers_data__["a" /* ResourceType */].shop,
            data: __WEBPACK_IMPORTED_MODULE_3_lodash__["chain"](followed).cloneDeep()
                .set('isFollowed', !is_followed)
                .set('likeCount', !is_followed ? followed.likeCount + 1 : followed.likeCount - 1)
                .value()
        }));
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["b" /* updateDataAction */])({
            id: follower_id,
            resource: __WEBPACK_IMPORTED_MODULE_6__helpers_data__["a" /* ResourceType */].user,
            data: __WEBPACK_IMPORTED_MODULE_3_lodash__["chain"](follower).cloneDeep()
                .set('followingCount', !is_followed ? follower.followingCount + 1 : follower.followingCount - 1)
                .value()
        }));
        __WEBPACK_IMPORTED_MODULE_4__repositories_userRepository__["a" /* default */].toggleFollowShop(id, follower_id, is_followed).then(function () {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_utils__["k" /* toastSuccess */])("You've " + (is_followed ? 'un' : '') + "followed this shop.");
        });
    };
}


/***/ }),

/***/ "./app/client/_data/models/Address.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Model__ = __webpack_require__("./app/client/_data/models/Model.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_utils__ = __webpack_require__("./app/client/_helpers/utils.tsx");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var Address = (function (_super) {
    __extends(Address, _super);
    function Address() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Address.prototype.completeAddress = function () {
        if (!this.street2 || this.street2 == 'undefined') {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_utils__["e" /* strict_join */])([this.street1, this.city, this.state, this.zip], ', ');
        }
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_utils__["e" /* strict_join */])([this.street1, this.street2, this.city, this.state, this.zip], ', ');
    };
    return Address;
}(__WEBPACK_IMPORTED_MODULE_0__Model__["a" /* default */]));
/* harmony default export */ __webpack_exports__["a"] = (Address);


/***/ }),

/***/ "./app/client/_data/models/Attachment.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_class_transformer__ = __webpack_require__("./node_modules/class-transformer/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_class_transformer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_class_transformer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Model__ = __webpack_require__("./app/client/_data/models/Model.ts");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};


var Attachment = (function (_super) {
    __extends(Attachment, _super);
    function Attachment() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Attachment;
}(__WEBPACK_IMPORTED_MODULE_1__Model__["a" /* default */]));
/* harmony default export */ __webpack_exports__["a"] = (Attachment);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_class_transformer__["Expose"])({ name: "width" }),
    __metadata("design:type", Number)
], Attachment.prototype, "width", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_class_transformer__["Expose"])({ name: "height" }),
    __metadata("design:type", Number)
], Attachment.prototype, "height", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_class_transformer__["Expose"])({ name: "url" }),
    __metadata("design:type", String)
], Attachment.prototype, "url", void 0);


/***/ }),

/***/ "./app/client/_data/models/Booth.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return BoothTerms; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return BoothPaymentMethods; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return initializeNewBoothShop; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return boothToApiDict; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_class_transformer__ = __webpack_require__("./node_modules/class-transformer/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_class_transformer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_class_transformer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Shop__ = __webpack_require__("./app/client/_data/models/Shop.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Address__ = __webpack_require__("./app/client/_data/models/Address.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Attachment__ = __webpack_require__("./app/client/_data/models/Attachment.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_pluralize__ = __webpack_require__("./node_modules/pluralize/pluralize.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_pluralize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_pluralize__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};





var Booth = (function (_super) {
    __extends(Booth, _super);
    function Booth() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Booth.prototype.toString = function () {
        return this.workstationCount + " " + __WEBPACK_IMPORTED_MODULE_4_pluralize__("Booth", this.workstationCount) + " Available";
    };
    Booth.prototype.paymentMethods = function () {
        var methods = [];
        if (this.isCommissioned) {
            methods.push("Commissioned");
        }
        if (this.isNegotiable) {
            methods.push("Negotiable");
        }
        return methods;
    };
    Booth.prototype.imageable = function () {
        if (this.primaryPictureUrl)
            return this;
        else
            return this.shop;
    };
    Booth.prototype.isNew = function () {
        return this.id != 0;
    };
    return Booth;
}(__WEBPACK_IMPORTED_MODULE_2__Address__["a" /* default */]));
/* harmony default export */ __webpack_exports__["a"] = (Booth);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_class_transformer__["Type"])(function () { return __WEBPACK_IMPORTED_MODULE_3__Attachment__["a" /* default */]; }),
    __metadata("design:type", Array)
], Booth.prototype, "images", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_class_transformer__["Expose"])({ name: "workstation_count" }),
    __metadata("design:type", Number)
], Booth.prototype, "workstationCount", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_class_transformer__["Expose"])({ name: "terms" }),
    __metadata("design:type", String)
], Booth.prototype, "terms", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_class_transformer__["Expose"])({ name: "is_negotiable" }),
    __metadata("design:type", Boolean)
], Booth.prototype, "isNegotiable", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_class_transformer__["Expose"])({ name: "is_commissioned" }),
    __metadata("design:type", Boolean)
], Booth.prototype, "isCommissioned", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_class_transformer__["Expose"])({ name: "primary_picture_url" }),
    __metadata("design:type", String)
], Booth.prototype, "primaryPictureUrl", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_class_transformer__["Expose"])({ name: "salon_id" }),
    __metadata("design:type", Number)
], Booth.prototype, "shopId", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_class_transformer__["Type"])(function () { return __WEBPACK_IMPORTED_MODULE_1__Shop__["a" /* default */]; }),
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_class_transformer__["Expose"])({ name: "salon" }),
    __metadata("design:type", __WEBPACK_IMPORTED_MODULE_1__Shop__["a" /* default */])
], Booth.prototype, "shop", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_class_transformer__["Expose"])({ name: "like_count" }),
    __metadata("design:type", Number)
], Booth.prototype, "likeCount", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_class_transformer__["Expose"])({ name: "is_liked" }),
    __metadata("design:type", Boolean)
], Booth.prototype, "isLiked", void 0);
;
var BoothTerms = {
    PER_HOUR: "Per Hour",
    PER_DAY: "Per Day",
    PER_WEEK: "Per Week",
    PER_MONTH: "Per Month"
};
var BoothPaymentMethods = {
    NEGOTIABLE: "Negotiable",
    COMMISSION: "Commission"
};
var initializeNewBoothShop = function (shop) {
    var booth = new Booth();
    if (shop) {
        booth.shop = shop;
        booth.shopId = shop.id;
    }
    booth.terms = BoothTerms.PER_DAY;
    booth.isNegotiable = false;
    booth.isCommissioned = false;
    booth.price = 0;
    booth.workstationCount = 0;
    return booth;
};
var boothToApiDict = function (booth) {
    var data = {
        salon_id: booth.shopId,
        workstation_count: booth.workstationCount,
        price: booth.price,
        terms: booth.terms,
        // extra check since redux forms checkbox sets "" for false booleans
        is_negotiable: booth.isNegotiable === true,
        is_commissioned: booth.isCommissioned === true
    };
    if (booth.id && booth.id > 0) {
        data["id"] = booth.id;
    }
    return data;
};


/***/ }),

/***/ "./app/client/_data/models/Comment.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_class_transformer__ = __webpack_require__("./node_modules/class-transformer/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_class_transformer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_class_transformer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Model__ = __webpack_require__("./app/client/_data/models/Model.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__User__ = __webpack_require__("./app/client/_data/models/User.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Style__ = __webpack_require__("./app/client/_data/models/Style.ts");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};




var Comment = (function (_super) {
    __extends(Comment, _super);
    function Comment() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Comment;
}(__WEBPACK_IMPORTED_MODULE_1__Model__["a" /* default */]));
/* harmony default export */ __webpack_exports__["a"] = (Comment);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_class_transformer__["Type"])(function () { return __WEBPACK_IMPORTED_MODULE_2__User__["a" /* default */]; }),
    __metadata("design:type", __WEBPACK_IMPORTED_MODULE_2__User__["a" /* default */])
], Comment.prototype, "user", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_class_transformer__["Type"])(function () { return __WEBPACK_IMPORTED_MODULE_3__Style__["a" /* default */]; }),
    __metadata("design:type", __WEBPACK_IMPORTED_MODULE_3__Style__["a" /* default */])
], Comment.prototype, "style", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_class_transformer__["Type"])(function () { return Date; }),
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_class_transformer__["Expose"])({ name: "created_at" }),
    __metadata("design:type", Date)
], Comment.prototype, "createdAt", void 0);


/***/ }),

/***/ "./app/client/_data/models/Conversation.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_class_transformer__ = __webpack_require__("./node_modules/class-transformer/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_class_transformer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_class_transformer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Model__ = __webpack_require__("./app/client/_data/models/Model.ts");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};


var Conversation = (function (_super) {
    __extends(Conversation, _super);
    function Conversation() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Conversation;
}(__WEBPACK_IMPORTED_MODULE_1__Model__["a" /* default */]));
/* harmony default export */ __webpack_exports__["a"] = (Conversation);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_class_transformer__["Expose"])({ name: 'unread_count' }),
    __metadata("design:type", Number)
], Conversation.prototype, "unreadCount", void 0);


/***/ }),

/***/ "./app/client/_data/models/Feed.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Model__ = __webpack_require__("./app/client/_data/models/Model.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_class_transformer__ = __webpack_require__("./node_modules/class-transformer/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_class_transformer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_class_transformer__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};


var Feed = (function (_super) {
    __extends(Feed, _super);
    function Feed() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Feed;
}(__WEBPACK_IMPORTED_MODULE_0__Model__["a" /* default */]));
/* harmony default export */ __webpack_exports__["a"] = (Feed);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_class_transformer__["Type"])(function () { return Date; }),
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_class_transformer__["Expose"])({ name: "created_at" }),
    __metadata("design:type", Date)
], Feed.prototype, "createdAt", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_class_transformer__["Expose"])({ name: "trackable_id" }),
    __metadata("design:type", Number)
], Feed.prototype, "trackableId", void 0);


/***/ }),

/***/ "./app/client/_data/models/Message.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_class_transformer__ = __webpack_require__("./node_modules/class-transformer/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_class_transformer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_class_transformer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Model__ = __webpack_require__("./app/client/_data/models/Model.ts");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};


var Message = (function (_super) {
    __extends(Message, _super);
    function Message() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Message;
}(__WEBPACK_IMPORTED_MODULE_1__Model__["a" /* default */]));
/* harmony default export */ __webpack_exports__["a"] = (Message);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_class_transformer__["Expose"])({ name: 'conversation_id' }),
    __metadata("design:type", Number)
], Message.prototype, "conversationId", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_class_transformer__["Type"])(function () { return Date; }),
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_class_transformer__["Expose"])({ name: "created_at" }),
    __metadata("design:type", Date)
], Message.prototype, "createdAt", void 0);


/***/ }),

/***/ "./app/client/_data/models/Meta.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_class_transformer__ = __webpack_require__("./node_modules/class-transformer/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_class_transformer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_class_transformer__);
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var Meta = (function () {
    function Meta() {
    }
    Meta.prototype.hasNext = function () {
        return this.currentPage < this.totalPages;
    };
    return Meta;
}());
/* harmony default export */ __webpack_exports__["a"] = (Meta);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_class_transformer__["Expose"])({ name: "current_page" }),
    __metadata("design:type", Number)
], Meta.prototype, "currentPage", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_class_transformer__["Expose"])({ name: "next_page" }),
    __metadata("design:type", Number)
], Meta.prototype, "nextPage", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_class_transformer__["Expose"])({ name: "prev_page" }),
    __metadata("design:type", Number)
], Meta.prototype, "prevPage", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_class_transformer__["Expose"])({ name: "total_count" }),
    __metadata("design:type", Number)
], Meta.prototype, "totalCount", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_class_transformer__["Expose"])({ name: "total_pages" }),
    __metadata("design:type", Number)
], Meta.prototype, "totalPages", void 0);


/***/ }),

/***/ "./app/client/_data/models/Model.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var Model = (function () {
    function Model() {
    }
    return Model;
}());
/* harmony default export */ __webpack_exports__["a"] = (Model);


/***/ }),

/***/ "./app/client/_data/models/ResponseError.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var ResponseError = (function (_super) {
    __extends(ResponseError, _super);
    function ResponseError() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ResponseError;
}(Error));
/* harmony default export */ __webpack_exports__["a"] = (ResponseError);


/***/ }),

/***/ "./app/client/_data/models/SearchResult.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Model__ = __webpack_require__("./app/client/_data/models/Model.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_class_transformer__ = __webpack_require__("./node_modules/class-transformer/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_class_transformer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_class_transformer__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};


var SearchResult = (function (_super) {
    __extends(SearchResult, _super);
    function SearchResult() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SearchResult.prototype.distanceInMiles = function () {
        return Math.round(this.distance * 0.621371 * 100) / 100;
    };
    return SearchResult;
}(__WEBPACK_IMPORTED_MODULE_0__Model__["a" /* default */]));
/* harmony default export */ __webpack_exports__["a"] = (SearchResult);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_class_transformer__["Expose"])({ name: "model_id" }),
    __metadata("design:type", Number)
], SearchResult.prototype, "modelId", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_class_transformer__["Expose"])({ name: "image_url" }),
    __metadata("design:type", String)
], SearchResult.prototype, "imageUrl", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_class_transformer__["Expose"])({ name: "primary_text" }),
    __metadata("design:type", String)
], SearchResult.prototype, "primaryText", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_class_transformer__["Expose"])({ name: "entity_properties" }),
    __metadata("design:type", Object)
], SearchResult.prototype, "entityProperties", void 0);


/***/ }),

/***/ "./app/client/_data/models/Shop.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_class_transformer__ = __webpack_require__("./node_modules/class-transformer/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_class_transformer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_class_transformer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Attachment__ = __webpack_require__("./app/client/_data/models/Attachment.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_utils__ = __webpack_require__("./app/client/_helpers/utils.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Address__ = __webpack_require__("./app/client/_data/models/Address.ts");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};




var Shop = (function (_super) {
    __extends(Shop, _super);
    function Shop() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Shop.prototype.toString = function () {
        return this.name;
    };
    ;
    Shop.prototype.address = function () {
        var parts = [this.street1, this.street2, this.city, this.state]
            .filter(function (each) {
            return each && each.trim().length > 0;
        });
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__helpers_utils__["e" /* strict_join */])(parts, ', ') + ' ' + this.zip;
    };
    Shop.prototype.isOwnedBy = function (userId) {
        return this.userId == userId;
    };
    Shop.prototype.imageUrl = function () {
        return this.primaryPictureUrl || window.Styleteq.images.userDefault;
    };
    return Shop;
}(__WEBPACK_IMPORTED_MODULE_3__Address__["a" /* default */]));
/* harmony default export */ __webpack_exports__["a"] = (Shop);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_class_transformer__["Expose"])({ name: "primary_picture_url" }),
    __metadata("design:type", String)
], Shop.prototype, "primaryPictureUrl", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_class_transformer__["Expose"])({ name: "is_liked" }),
    __metadata("design:type", Boolean)
], Shop.prototype, "isFollowed", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_class_transformer__["Type"])(function () { return __WEBPACK_IMPORTED_MODULE_1__Attachment__["a" /* default */]; }),
    __metadata("design:type", Array)
], Shop.prototype, "images", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_class_transformer__["Expose"])({ name: "like_count" }),
    __metadata("design:type", Number)
], Shop.prototype, "likeCount", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_class_transformer__["Expose"])({ name: "user_id" }),
    __metadata("design:type", Number)
], Shop.prototype, "userId", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_class_transformer__["Expose"])({ name: "address_1" }),
    __metadata("design:type", String)
], Shop.prototype, "street1", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_class_transformer__["Expose"])({ name: "address_2" }),
    __metadata("design:type", String)
], Shop.prototype, "street2", void 0);


/***/ }),

/***/ "./app/client/_data/models/Special.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_class_transformer__ = __webpack_require__("./node_modules/class-transformer/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_class_transformer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_class_transformer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__User__ = __webpack_require__("./app/client/_data/models/User.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Model__ = __webpack_require__("./app/client/_data/models/Model.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__("./node_modules/moment/moment.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};




var Special = (function (_super) {
    __extends(Special, _super);
    function Special() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Special.prototype.prettyStartDate = function () {
        return this.prettyDate(this.startDate, '12:00');
    };
    Special.prototype.prettyEndDate = function () {
        return this.prettyDate(this.endDate, '11:59');
    };
    Special.prototype.prettyEndDateString = function () {
        var prefix = this.endDate >= new Date() ? 'Ends on' : 'Expired';
        return prefix + " " + this.prettyEndDate();
    };
    Special.prototype.prettyDate = function (date, match) {
        var strDate = __WEBPACK_IMPORTED_MODULE_3_moment__(date).format('hh:mm');
        if (strDate == match)
            return __WEBPACK_IMPORTED_MODULE_3_moment__(date).format('MMMM D, YYYY');
        else
            return __WEBPACK_IMPORTED_MODULE_3_moment__(date).format('MMMM D, YYYY hh:mm A');
    };
    return Special;
}(__WEBPACK_IMPORTED_MODULE_2__Model__["a" /* default */]));
/* harmony default export */ __webpack_exports__["a"] = (Special);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_class_transformer__["Type"])(function () { return __WEBPACK_IMPORTED_MODULE_1__User__["a" /* default */]; }),
    __metadata("design:type", __WEBPACK_IMPORTED_MODULE_1__User__["a" /* default */])
], Special.prototype, "user", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_class_transformer__["Expose"])({ name: "user_id" }),
    __metadata("design:type", Number)
], Special.prototype, "userId", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_class_transformer__["Type"])(function () { return Date; }),
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_class_transformer__["Expose"])({ name: "start_date" }),
    __metadata("design:type", Date)
], Special.prototype, "startDate", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_class_transformer__["Type"])(function () { return Date; }),
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_class_transformer__["Expose"])({ name: "end_date" }),
    __metadata("design:type", Date)
], Special.prototype, "endDate", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_class_transformer__["Expose"])({ name: "like_count" }),
    __metadata("design:type", Number)
], Special.prototype, "likeCount", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_class_transformer__["Expose"])({ name: "is_liked" }),
    __metadata("design:type", Boolean)
], Special.prototype, "isLiked", void 0);


/***/ }),

/***/ "./app/client/_data/models/Style.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_class_transformer__ = __webpack_require__("./node_modules/class-transformer/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_class_transformer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_class_transformer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__User__ = __webpack_require__("./app/client/_data/models/User.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Model__ = __webpack_require__("./app/client/_data/models/Model.ts");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};



var Style = (function (_super) {
    __extends(Style, _super);
    function Style() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Style;
}(__WEBPACK_IMPORTED_MODULE_2__Model__["a" /* default */]));
/* harmony default export */ __webpack_exports__["a"] = (Style);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_class_transformer__["Type"])(function () { return __WEBPACK_IMPORTED_MODULE_1__User__["a" /* default */]; }),
    __metadata("design:type", __WEBPACK_IMPORTED_MODULE_1__User__["a" /* default */])
], Style.prototype, "user", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_class_transformer__["Expose"])({ name: "user_id" }),
    __metadata("design:type", Number)
], Style.prototype, "userId", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_class_transformer__["Expose"])({ name: "primary_picture_url" }),
    __metadata("design:type", String)
], Style.prototype, "primaryPictureUrl", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_class_transformer__["Expose"])({ name: "comment_count" }),
    __metadata("design:type", Number)
], Style.prototype, "commentCount", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_class_transformer__["Expose"])({ name: "like_count" }),
    __metadata("design:type", Number)
], Style.prototype, "likeCount", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_class_transformer__["Expose"])({ name: "is_liked" }),
    __metadata("design:type", Boolean)
], Style.prototype, "isLiked", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_class_transformer__["Expose"])({ name: "tag_list" }),
    __metadata("design:type", Array)
], Style.prototype, "tags", void 0);


/***/ }),

/***/ "./app/client/_data/models/User.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Address__ = __webpack_require__("./app/client/_data/models/Address.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_class_transformer__ = __webpack_require__("./node_modules/class-transformer/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_class_transformer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_class_transformer__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};


var User = (function (_super) {
    __extends(User, _super);
    function User() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    User.prototype.username = function () {
        return '@' + this.name;
    };
    User.prototype.gender = function () {
        if (this.sex == 'male')
            return 'Male';
        else if (this.sex == 'female')
            return 'Female';
        return '';
    };
    User.prototype.displayProfession = function () {
        if (this.profession === undefined || this.profession === " ")
            return "Styleteq User";
        return this.profession;
    };
    User.prototype.profilePicture = function () {
        if (this.profilePictureUrl == 'user_default.jpg')
            return window.Styleteq.images.userDefault;
        else
            return this.profilePictureUrl;
    };
    User.prototype.phoneNumber = function () {
        return this.phone && this.countryCode ? this.countryCode + ' ' + this.phone : '';
    };
    return User;
}(__WEBPACK_IMPORTED_MODULE_0__Address__["a" /* default */]));
/* harmony default export */ __webpack_exports__["a"] = (User);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_class_transformer__["Expose"])({ name: "sign_in_count" }),
    __metadata("design:type", Number)
], User.prototype, "signInCount", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_class_transformer__["Expose"])({ name: "first_name" }),
    __metadata("design:type", String)
], User.prototype, "firstName", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_class_transformer__["Expose"])({ name: "last_name" }),
    __metadata("design:type", String)
], User.prototype, "lastName", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_class_transformer__["Expose"])({ name: "full_name" }),
    __metadata("design:type", String)
], User.prototype, "fullName", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_class_transformer__["Expose"])({ name: "is_professional" }),
    __metadata("design:type", Boolean)
], User.prototype, "isProfessional", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_class_transformer__["Expose"])({ name: "is_owner" }),
    __metadata("design:type", Boolean)
], User.prototype, "isOwner", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_class_transformer__["Expose"])({ name: "country_code" }),
    __metadata("design:type", String)
], User.prototype, "countryCode", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_class_transformer__["Expose"])({ name: "profile_picture_url" }),
    __metadata("design:type", String)
], User.prototype, "profilePictureUrl", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_class_transformer__["Expose"])({ name: "is_followed" }),
    __metadata("design:type", Boolean)
], User.prototype, "isFollowed", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_class_transformer__["Expose"])({ name: "followers_count" }),
    __metadata("design:type", Number)
], User.prototype, "followersCount", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_class_transformer__["Expose"])({ name: "following_count" }),
    __metadata("design:type", Number)
], User.prototype, "followingCount", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_class_transformer__["Expose"])({ name: "users_followed_count" }),
    __metadata("design:type", Number)
], User.prototype, "usersfollowingCount", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_class_transformer__["Expose"])({ name: "default_followable" }),
    __metadata("design:type", Boolean)
], User.prototype, "defaultFollowable", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_class_transformer__["Expose"])({ name: "address_1" }),
    __metadata("design:type", Object)
], User.prototype, "street1", void 0);
__decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_class_transformer__["Expose"])({ name: "address_2" }),
    __metadata("design:type", Object)
], User.prototype, "street2", void 0);


/***/ }),

/***/ "./app/client/_data/reducers.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__("./app/client/_data/actions.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__("./node_modules/immutable/dist/immutable.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_utils__ = __webpack_require__("./app/client/_helpers/utils.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__("./node_modules/redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__("./node_modules/lodash/lodash.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_data__ = __webpack_require__("./app/client/_helpers/data.ts");






// REDUCERS
var dataReducer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux__["b" /* combineReducers */])({
    users: users,
    shops: shops,
    booths: booths,
    specials: specials,
    styles: styles,
    conversations: conversations,
    messages: messages
});
/* harmony default export */ __webpack_exports__["a"] = (dataReducer);
function users(state, action) {
    if (state === void 0) { state = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])(); }
    var _resource = __WEBPACK_IMPORTED_MODULE_5__helpers_data__["a" /* ResourceType */].user;
    if (action.payload) {
        var _a = action.payload, resource = _a.resource, data = _a.data, id = _a.id;
        if (action.type == __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* addDataAction */].toString()) {
            if (resource == _resource)
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__helpers_data__["b" /* addData */])(_resource, data, state);
            else {
                var userProperty = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__helpers_utils__["v" /* userReference */])(resource);
                var _data = addDataViaProperty(_resource, userProperty, data, state);
                if (resource == __WEBPACK_IMPORTED_MODULE_5__helpers_data__["a" /* ResourceType */].conversation)
                    return addDataViaProperty(_resource, 'user2', data, _data);
                return _data;
            }
        }
        else if (action.type == __WEBPACK_IMPORTED_MODULE_0__actions__["c" /* removeDataAction */].toString()) {
            if (resource == _resource)
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__helpers_data__["c" /* removeData */])(id, state);
        }
        else if (action.type == __WEBPACK_IMPORTED_MODULE_0__actions__["b" /* updateDataAction */].toString()) {
            if (resource == _resource)
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__helpers_data__["d" /* updateData */])(id, data, state);
        }
    }
    return state;
}
function shops(state, action) {
    if (state === void 0) { state = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])(); }
    var _resource = __WEBPACK_IMPORTED_MODULE_5__helpers_data__["a" /* ResourceType */].shop;
    if (action.payload) {
        var _a = action.payload, resource = _a.resource, data = _a.data, id = _a.id;
        if (action.type == __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* addDataAction */].toString()) {
            if (resource == _resource)
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__helpers_data__["b" /* addData */])(_resource, data, state);
            else if (resource == __WEBPACK_IMPORTED_MODULE_5__helpers_data__["a" /* ResourceType */].booth) {
                var _data = void 0;
                if (Array.isArray(data))
                    _data = data.map(function (d) { return d.salon; });
                else
                    _data = data.salon;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__helpers_data__["b" /* addData */])(_resource, _data, state);
            }
        }
        else if (action.type == __WEBPACK_IMPORTED_MODULE_0__actions__["c" /* removeDataAction */].toString()) {
            if (resource == _resource)
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__helpers_data__["c" /* removeData */])(id, state);
        }
        else if (action.type == __WEBPACK_IMPORTED_MODULE_0__actions__["b" /* updateDataAction */].toString()) {
            if (resource == _resource)
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__helpers_data__["d" /* updateData */])(id, data, state);
        }
    }
    return state;
}
function booths(state, action) {
    if (state === void 0) { state = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])(); }
    return _commonDataReducer(__WEBPACK_IMPORTED_MODULE_5__helpers_data__["a" /* ResourceType */].booth, state, action);
}
function specials(state, action) {
    if (state === void 0) { state = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])(); }
    return _commonDataReducer(__WEBPACK_IMPORTED_MODULE_5__helpers_data__["a" /* ResourceType */].special, state, action);
}
function styles(state, action) {
    if (state === void 0) { state = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])(); }
    return _commonDataReducer(__WEBPACK_IMPORTED_MODULE_5__helpers_data__["a" /* ResourceType */].style, state, action);
}
function conversations(state, action) {
    if (state === void 0) { state = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])(); }
    return _commonDataReducer(__WEBPACK_IMPORTED_MODULE_5__helpers_data__["a" /* ResourceType */].conversation, state, action);
}
function messages(state, action) {
    if (state === void 0) { state = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])(); }
    var _resource = __WEBPACK_IMPORTED_MODULE_5__helpers_data__["a" /* ResourceType */].message;
    if (action.payload) {
        var _a = action.payload, resource = _a.resource, data = _a.data, id = _a.id;
        if (action.type == __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* addDataAction */].toString()) {
            if (resource == _resource) {
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__helpers_data__["b" /* addData */])(_resource, data, state);
            }
            else if (resource == __WEBPACK_IMPORTED_MODULE_5__helpers_data__["a" /* ResourceType */].conversation) {
                return addDataViaProperty(_resource, 'last_message', data, state);
            }
        }
        else if (action.type == __WEBPACK_IMPORTED_MODULE_0__actions__["c" /* removeDataAction */].toString()) {
            if (resource == _resource)
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__helpers_data__["c" /* removeData */])(id, state);
        }
        else if (action.type == __WEBPACK_IMPORTED_MODULE_0__actions__["b" /* updateDataAction */].toString()) {
            if (resource == _resource)
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__helpers_data__["d" /* updateData */])(id, data, state);
        }
    }
    return state;
}
//HELPERS
function _commonDataReducer(_resource, state, action) {
    if (action.payload) {
        var _a = action.payload, resource = _a.resource, data = _a.data, id = _a.id;
        if (action.type == __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* addDataAction */].toString()) {
            if (resource == _resource)
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__helpers_data__["b" /* addData */])(_resource, data, state);
        }
        else if (action.type == __WEBPACK_IMPORTED_MODULE_0__actions__["c" /* removeDataAction */].toString()) {
            if (resource == _resource)
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__helpers_data__["c" /* removeData */])(id, state);
        }
        else if (action.type == __WEBPACK_IMPORTED_MODULE_0__actions__["b" /* updateDataAction */].toString()) {
            if (resource == _resource)
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__helpers_data__["d" /* updateData */])(id, data, state);
        }
    }
    return state;
}
function addDataViaProperty(resourceType, userProperty, data, state) {
    if (userProperty) {
        var _data = void 0;
        if (Array.isArray(data))
            _data = data.map(function (d) { return __WEBPACK_IMPORTED_MODULE_4_lodash__["get"](d, userProperty); });
        else
            _data = __WEBPACK_IMPORTED_MODULE_4_lodash__["get"](data, userProperty);
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__helpers_data__["b" /* addData */])(resourceType, _data, state);
    }
    return state;
}


/***/ }),

/***/ "./app/client/_data/selectors.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export dataSelector */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return dataByResourceNameSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return usersSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return userByIdSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return shopsSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return shopByIdSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return boothsSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return boothByIdSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return stylesSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return styleByIdSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return specialsSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return specialByIdSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return conversationsSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return conversationByIdSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return conversationByIdsSelector; });
/* unused harmony export messagesSelector */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return messageByIdSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return messageByIdsSelector; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__("./node_modules/reselect/lib/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_pluralize__ = __webpack_require__("./node_modules/pluralize/pluralize.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_pluralize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_pluralize__);


var dataSelector = function (state) { return state.data; };
var dataByResourceNameSelector = function (state, resource) {
    return state.data[__WEBPACK_IMPORTED_MODULE_1_pluralize__(resource)];
};
//Users
var usersSelector = function (state) { return dataSelector(state).users; };
var userByIdSelector = function (state, id) { return dataByIdSelector(state, id, usersSelector); };
//Shops
var shopsSelector = function (state) { return dataSelector(state).shops; };
var shopByIdSelector = function (state, id) { return dataByIdSelector(state, id, shopsSelector); };
//Booths
var boothsSelector = function (state) { return dataSelector(state).booths; };
var boothByIdSelector = function (state, id) { return dataByIdSelector(state, id, boothsSelector); };
//Styles
var stylesSelector = function (state) { return dataSelector(state).styles; };
var styleByIdSelector = function (state, id) { return dataByIdSelector(state, id, stylesSelector); };
//Specials
var specialsSelector = function (state) { return dataSelector(state).specials; };
var specialByIdSelector = function (state, id) { return dataByIdSelector(state, id, specialsSelector); };
//Conversations
var conversationsSelector = function (state) { return dataSelector(state).conversations; };
var conversationByIdSelector = function (state, id) { return dataByIdSelector(state, id, conversationsSelector); };
var conversationByIdsSelector = function (state, ids) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(conversationsSelector, function (specials) { return ids.map(function (id) { return specials.get(id); }); })(state); };
//Messages
var messagesSelector = function (state) { return dataSelector(state).messages; };
var messageByIdSelector = function (state, id) { return dataByIdSelector(state, id, messagesSelector); };
var messageByIdsSelector = function (state, ids) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(messagesSelector, function (specials) { return ids.map(function (id) { return specials.get(id); }); })(state); };
//Helpers
function dataByIdSelector(state, id, selector) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(selector, function (specials) { return specials.get(id); })(state);
}


/***/ }),

/***/ "./app/client/_helpers/api.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CrudRouteUsages */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SimpleRoute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Api; });
/* harmony export (immutable) */ __webpack_exports__["b"] = apiFetch;
/* unused harmony export checkStatus */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_models_ResponseError__ = __webpack_require__("./app/client/_data/models/ResponseError.ts");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};

var CrudRouteUsages;
(function (CrudRouteUsages) {
    CrudRouteUsages[CrudRouteUsages["CLIENT"] = 0] = "CLIENT";
    CrudRouteUsages[CrudRouteUsages["API"] = 1] = "API";
})(CrudRouteUsages || (CrudRouteUsages = {}));
var SimpleRoute = (function () {
    function SimpleRoute() {
    }
    SimpleRoute.usage = function () {
        return CrudRouteUsages.CLIENT;
    };
    SimpleRoute.baseUrl = function () {
        return this.usage() == CrudRouteUsages.CLIENT ? Api.baseUrl : Api.apiBaseUrl;
    };
    SimpleRoute.root = function () {
        return null;
    };
    SimpleRoute.index = function () {
        return [this.baseUrl(), this.root()].join('/');
    };
    ;
    return SimpleRoute;
}());

var CrudRoutes = (function (_super) {
    __extends(CrudRoutes, _super);
    function CrudRoutes() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CrudRoutes.show = function (id) {
        return [this.index(), id].join('/');
    };
    ;
    CrudRoutes.new = function () {
        return [this.index(), 'new'].join('/');
    };
    ;
    CrudRoutes.edit = function (id) {
        return [this.index(), id, 'edit'].join('/');
    };
    ;
    CrudRoutes.create = function () {
        return this.index();
    };
    CrudRoutes.update = function (id) {
        return this.show(id);
    };
    return CrudRoutes;
}(SimpleRoute));
/* harmony default export */ __webpack_exports__["c"] = (CrudRoutes);
var Api = {
    baseUrl: '/client',
    apiBaseUrl: '/v1'
};
function apiFetch(url, params) {
    if (params === void 0) { params = {}; }
    return fetch(url, __assign({ credentials: "same-origin", headers: {
            "ACCEPT": "application/json"
        } }, params)).then(checkStatus);
}
function checkStatus(response) {
    if (response.status >= 200 && response.status < 300) {
        return response;
    }
    else {
        var error = new __WEBPACK_IMPORTED_MODULE_0__data_models_ResponseError__["a" /* default */](response.statusText);
        error.response = response;
        throw error;
    }
}


/***/ }),

/***/ "./app/client/_helpers/data.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ResourceType; });
/* unused harmony export plainToClassFromResourceName */
/* harmony export (immutable) */ __webpack_exports__["b"] = addData;
/* harmony export (immutable) */ __webpack_exports__["c"] = removeData;
/* harmony export (immutable) */ __webpack_exports__["d"] = updateData;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__("./node_modules/immutable/dist/immutable.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_class_transformer__ = __webpack_require__("./node_modules/class-transformer/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_class_transformer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_class_transformer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_models_User__ = __webpack_require__("./app/client/_data/models/User.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data_models_Style__ = __webpack_require__("./app/client/_data/models/Style.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__data_models_Special__ = __webpack_require__("./app/client/_data/models/Special.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__data_models_Shop__ = __webpack_require__("./app/client/_data/models/Shop.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__data_models_Booth__ = __webpack_require__("./app/client/_data/models/Booth.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__data_models_SearchResult__ = __webpack_require__("./app/client/_data/models/SearchResult.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__data_models_Conversation__ = __webpack_require__("./app/client/_data/models/Conversation.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__data_models_Message__ = __webpack_require__("./app/client/_data/models/Message.ts");










var ResourceType = {
    user: 'user',
    shop: 'shop',
    special: 'special',
    style: 'style',
    booth: 'booth',
    search: 'search',
    conversation: 'conversation',
    message: 'message',
};
function plainToClassFromResourceName(resource, data) {
    switch (resource.toLowerCase()) {
        case 'user':
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_class_transformer__["plainToClass"])(__WEBPACK_IMPORTED_MODULE_2__data_models_User__["a" /* default */], data);
        case 'style':
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_class_transformer__["plainToClass"])(__WEBPACK_IMPORTED_MODULE_3__data_models_Style__["a" /* default */], data);
        case 'special':
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_class_transformer__["plainToClass"])(__WEBPACK_IMPORTED_MODULE_4__data_models_Special__["a" /* default */], data);
        case 'shop':
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_class_transformer__["plainToClass"])(__WEBPACK_IMPORTED_MODULE_5__data_models_Shop__["a" /* default */], data);
        case 'booth':
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_class_transformer__["plainToClass"])(__WEBPACK_IMPORTED_MODULE_6__data_models_Booth__["a" /* default */], data);
        case 'search':
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_class_transformer__["plainToClass"])(__WEBPACK_IMPORTED_MODULE_7__data_models_SearchResult__["a" /* default */], data);
        case 'conversation':
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_class_transformer__["plainToClass"])(__WEBPACK_IMPORTED_MODULE_8__data_models_Conversation__["a" /* default */], data);
        case 'message':
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_class_transformer__["plainToClass"])(__WEBPACK_IMPORTED_MODULE_9__data_models_Message__["a" /* default */], data);
    }
}
function addData(resource, data, map) {
    if (Array.isArray(data)) {
        var _map = data.map(function (i) {
            var obj = plainToClassFromResourceName(resource, i);
            return [obj.id, obj];
        });
        return map.mergeDeep(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_immutable__["OrderedMap"])(_map));
    }
    else {
        var obj = plainToClassFromResourceName(resource, data);
        return map.mergeDeep(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_immutable__["OrderedMap"])([[obj.id, obj]]));
    }
}
function removeData(id, map) {
    return map.delete(id);
}
function updateData(id, item, map) {
    return map.set(id, item);
}


/***/ }),

/***/ "./app/client/_helpers/imageHelpers.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return imageAspectSizeForMaxHeight; });
var imageAspectSizeForMaxHeight = function (image, maxSize) {
    var currentSize = {
        height: image.height,
        width: image.width
    };
    var adjustedSize = maxSize;
    adjustedSize.height = maxSize.height;
    adjustedSize.width = (adjustedSize.height * currentSize.width) / currentSize.height;
    return adjustedSize;
};


/***/ }),

/***/ "./app/client/_helpers/routerSelectors.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return currentPathSelector; });
var currentPathSelector = function (state) { return state.router.location.pathname; };


/***/ }),

/***/ "./app/client/_helpers/utils.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["e"] = strict_join;
/* harmony export (immutable) */ __webpack_exports__["c"] = to_url;
/* harmony export (immutable) */ __webpack_exports__["d"] = createQueryParameters;
/* harmony export (immutable) */ __webpack_exports__["o"] = formatWithTags;
/* harmony export (immutable) */ __webpack_exports__["f"] = getCurrentUser;
/* harmony export (immutable) */ __webpack_exports__["b"] = currentUserIsLoggedIn;
/* harmony export (immutable) */ __webpack_exports__["j"] = prettyPrintLike;
/* harmony export (immutable) */ __webpack_exports__["p"] = prettyPrintComment;
/* harmony export (immutable) */ __webpack_exports__["t"] = prettyPrintFollower;
/* harmony export (immutable) */ __webpack_exports__["m"] = apiModelName;
/* harmony export (immutable) */ __webpack_exports__["i"] = clientModelName;
/* harmony export (immutable) */ __webpack_exports__["h"] = apiModelNameToClientModelName;
/* harmony export (immutable) */ __webpack_exports__["l"] = apiModelNameToDisplayName;
/* unused harmony export properNameToRealModelName */
/* unused harmony export toast */
/* harmony export (immutable) */ __webpack_exports__["k"] = toastSuccess;
/* harmony export (immutable) */ __webpack_exports__["r"] = toastError;
/* unused harmony export formatDate */
/* unused harmony export formatDateTime */
/* harmony export (immutable) */ __webpack_exports__["v"] = userReference;
/* harmony export (immutable) */ __webpack_exports__["q"] = getOwnerFromModel;
/* harmony export (immutable) */ __webpack_exports__["u"] = collectionToKeyValue;
/* harmony export (immutable) */ __webpack_exports__["n"] = getLocation;
/* harmony export (immutable) */ __webpack_exports__["g"] = getSiteUrl;
/* harmony export (immutable) */ __webpack_exports__["s"] = createOrderedMapfromIDs;
/* harmony export (immutable) */ __webpack_exports__["a"] = toggleBodyScroll;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/react.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__("./node_modules/lodash/lodash.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_query_string__ = __webpack_require__("./node_modules/query-string/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_string_replace__ = __webpack_require__("./node_modules/react-string-replace/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_string_replace___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_string_replace__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_class_transformer__ = __webpack_require__("./node_modules/class-transformer/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_class_transformer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_class_transformer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__data_models_User__ = __webpack_require__("./app/client/_data/models/User.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_pluralize__ = __webpack_require__("./node_modules/pluralize/pluralize.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_pluralize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_pluralize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__data_models_Style__ = __webpack_require__("./app/client/_data/models/Style.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__data_models_Shop__ = __webpack_require__("./app/client/_data/models/Shop.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__data_models_Special__ = __webpack_require__("./app/client/_data/models/Special.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__data_models_Booth__ = __webpack_require__("./app/client/_data/models/Booth.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_alertify_js__ = __webpack_require__("./node_modules/alertify.js/dist/js/alertify.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_alertify_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_alertify_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_immutable__ = __webpack_require__("./node_modules/immutable/dist/immutable.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__data__ = __webpack_require__("./app/client/_helpers/data.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_jquery__ = __webpack_require__("./node_modules/jquery/dist/jquery.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_jquery__);















function strict_join(array, separator) {
    if (separator === void 0) { separator = ' '; }
    return __WEBPACK_IMPORTED_MODULE_1_lodash__["without"](array, ['']).join(separator);
}
function to_url() {
    var array = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        array[_i] = arguments[_i];
    }
    return strict_join(array, '/');
}
function createQueryParameters(parameters, prefixed) {
    if (prefixed === void 0) { prefixed = true; }
    return (prefixed ? '?' : '') + __WEBPACK_IMPORTED_MODULE_2_query_string__["stringify"](__WEBPACK_IMPORTED_MODULE_1_lodash__["pickBy"](parameters, __WEBPACK_IMPORTED_MODULE_1_lodash__["identity"]), { arrayFormat: 'bracket' });
}
function formatWithTags(text) {
    return __WEBPACK_IMPORTED_MODULE_3_react_string_replace__(text, new RegExp(/#(\w+)/g), function (match, i) { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "tag", key: i },
        " #",
        match)); });
}
;
function getCurrentUser() {
    if (window.Styleteq.currentUser)
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_class_transformer__["plainToClass"])(__WEBPACK_IMPORTED_MODULE_5__data_models_User__["a" /* default */], window.Styleteq.currentUser);
    return null;
}
function currentUserIsLoggedIn() {
    return window.Styleteq.currentUser != null;
}
function prettyPrintLike(likable) {
    return likable.likeCount + " " + __WEBPACK_IMPORTED_MODULE_6_pluralize__("Like", likable.likeCount);
}
function prettyPrintComment(commentable) {
    return commentable.commentCount + " " + __WEBPACK_IMPORTED_MODULE_6_pluralize__("Comment", commentable.commentCount);
}
function prettyPrintFollower(count) {
    return "" + __WEBPACK_IMPORTED_MODULE_6_pluralize__("Follower", count);
}
function apiModelName(model) {
    if (model instanceof __WEBPACK_IMPORTED_MODULE_7__data_models_Style__["a" /* default */])
        return 'style';
    else if (model instanceof __WEBPACK_IMPORTED_MODULE_8__data_models_Shop__["a" /* default */])
        return 'salon';
    else if (model instanceof __WEBPACK_IMPORTED_MODULE_9__data_models_Special__["a" /* default */])
        return 'special';
    else if (model instanceof __WEBPACK_IMPORTED_MODULE_10__data_models_Booth__["a" /* default */])
        return 'booth';
    else if (model instanceof __WEBPACK_IMPORTED_MODULE_5__data_models_User__["a" /* default */])
        return 'user';
    else
        return null;
}
function clientModelName(model) {
    if (model instanceof __WEBPACK_IMPORTED_MODULE_7__data_models_Style__["a" /* default */])
        return 'style';
    else if (model instanceof __WEBPACK_IMPORTED_MODULE_8__data_models_Shop__["a" /* default */])
        return 'shop';
    else if (model instanceof __WEBPACK_IMPORTED_MODULE_9__data_models_Special__["a" /* default */])
        return 'special';
    else if (model instanceof __WEBPACK_IMPORTED_MODULE_10__data_models_Booth__["a" /* default */])
        return 'booth';
    else if (model instanceof __WEBPACK_IMPORTED_MODULE_5__data_models_User__["a" /* default */])
        return 'user';
    else
        return null;
}
function apiModelNameToClientModelName(modelName) {
    switch (modelName) {
        case 'salon':
            return 'shop';
        case 'Salon':
            return 'Shop';
        default:
            return modelName;
    }
}
function apiModelNameToDisplayName(modelName) {
    switch (modelName) {
        case 'salon':
            return 'shop';
        case 'Salon':
            return 'Shop';
        case 'style':
            return 'image';
        case 'Style':
            return 'Image';
        default:
            return modelName;
    }
}
function properNameToRealModelName(properName) {
    switch (properName) {
        case 'shop':
            return 'salon';
        case 'Shop':
            return 'Salon';
        case 'image':
            return 'style';
        case 'Image':
            return 'Style';
        default:
            return properName;
    }
}
function toast(message, position) {
    if (position === void 0) { position = "bottom right"; }
    __WEBPACK_IMPORTED_MODULE_11_alertify_js__["logPosition"](position);
    __WEBPACK_IMPORTED_MODULE_11_alertify_js__["log"](message);
}
function toastSuccess(message, position) {
    if (position === void 0) { position = "bottom right"; }
    __WEBPACK_IMPORTED_MODULE_11_alertify_js__["logPosition"](position);
    __WEBPACK_IMPORTED_MODULE_11_alertify_js__["success"](message);
}
function toastError(message, position) {
    if (position === void 0) { position = "bottom right"; }
    __WEBPACK_IMPORTED_MODULE_11_alertify_js__["logPosition"](position);
    __WEBPACK_IMPORTED_MODULE_11_alertify_js__["error"](message);
}
function formatDate(date) {
    var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    return months[date.getMonth()] + ", " + date.getDate() + " " + date.getFullYear();
}
function formatDateTime(date) {
    var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    return months[date.getMonth()] + " " + date.getDate() + ", " + date.getFullYear() + "  " + date.toLocaleTimeString();
}
function userReference(resource) {
    switch (resource) {
        case __WEBPACK_IMPORTED_MODULE_13__data__["a" /* ResourceType */].shop:
            return 'owner';
        case __WEBPACK_IMPORTED_MODULE_13__data__["a" /* ResourceType */].booth:
            return 'salon.owner';
        case __WEBPACK_IMPORTED_MODULE_13__data__["a" /* ResourceType */].special:
        case __WEBPACK_IMPORTED_MODULE_13__data__["a" /* ResourceType */].style:
            return 'user';
        case __WEBPACK_IMPORTED_MODULE_13__data__["a" /* ResourceType */].conversation:
            return 'user1';
        case __WEBPACK_IMPORTED_MODULE_13__data__["a" /* ResourceType */].message:
            return 'sender';
        default:
            return null;
    }
}
function getOwnerFromModel(model) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_class_transformer__["plainToClass"])(__WEBPACK_IMPORTED_MODULE_5__data_models_User__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1_lodash__["get"](__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_class_transformer__["classToPlain"])(model), userReference(apiModelName(model))));
}
function collectionToKeyValue(collection) {
    return collection.map(function (i) {
        return [i.id, i];
    });
}
function getLocation(successCallback, errorCallback) {
    if (errorCallback === void 0) { errorCallback = null; }
    if (navigator.geolocation) {
        return navigator.geolocation.getCurrentPosition(successCallback, errorCallback);
    }
    else {
        toastError("Geolocation is not supported by this browser.");
        return null;
    }
}
;
function getSiteUrl() {
    var strArr = window.location.href.split('/');
    return strArr[0] + '//' + strArr[2];
}
function createOrderedMapfromIDs(idsArr, map) {
    var x = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_immutable__["OrderedMap"])();
    var arr = [];
    idsArr.forEach(function (value) {
        arr.push(__WEBPACK_IMPORTED_MODULE_1_lodash__["chain"](map.get(value)).cloneDeep().value());
    });
    var _map = arr.map(function (i, index) {
        return [index, i];
    });
    return x.mergeDeep(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_immutable__["OrderedMap"])(_map));
}
function toggleBodyScroll(show) {
    __WEBPACK_IMPORTED_MODULE_14_jquery__('body').css('overflow-y', show ? 'auto' : 'hidden');
}


/***/ }),

/***/ "./app/client/_packs/client.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflect_metadata__ = __webpack_require__("./node_modules/reflect-metadata/Reflect.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflect_metadata___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reflect_metadata__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("./node_modules/react/react.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__("./node_modules/react-dom/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__("./node_modules/redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__("./node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_history_createBrowserHistory__ = __webpack_require__("./node_modules/history/createBrowserHistory.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_history_createBrowserHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_history_createBrowserHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router_redux__ = __webpack_require__("./node_modules/react-router-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_redux_thunk__ = __webpack_require__("./node_modules/redux-thunk/lib/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_redux_thunk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_redux_thunk__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__activityFeeds_reducers__ = __webpack_require__("./app/client/activityFeeds/reducers.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__user_reducers__ = __webpack_require__("./app/client/user/reducers.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__style_reducers__ = __webpack_require__("./app/client/style/reducers.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__shop_reducers__ = __webpack_require__("./app/client/shop/reducers.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__special_reducers__ = __webpack_require__("./app/client/special/reducers.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__dashboard_containers_RouterContainer__ = __webpack_require__("./app/client/dashboard/containers/RouterContainer.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_router__ = __webpack_require__("./node_modules/react-router/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__data_reducers__ = __webpack_require__("./app/client/_data/reducers.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_redux_form__ = __webpack_require__("./node_modules/redux-form/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__search_reducers__ = __webpack_require__("./app/client/search/reducers.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__data_actions__ = __webpack_require__("./app/client/_data/actions.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__helpers_data__ = __webpack_require__("./app/client/_helpers/data.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_class_transformer__ = __webpack_require__("./node_modules/class-transformer/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_class_transformer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_class_transformer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__data_models_User__ = __webpack_require__("./app/client/_data/models/User.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__user_actions__ = __webpack_require__("./app/client/user/actions.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__message_reducers__ = __webpack_require__("./app/client/message/reducers.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__dashboard_components_DashboardComponent__ = __webpack_require__("./app/client/dashboard/components/DashboardComponent.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__message_middlewares__ = __webpack_require__("./app/client/message/middlewares.ts");
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};


























var history = __WEBPACK_IMPORTED_MODULE_5_history_createBrowserHistory___default()();
var middleware = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_router_redux__["a" /* routerMiddleware */])(history);
var store = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux__["a" /* createStore */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux__["b" /* combineReducers */])({
    data: __WEBPACK_IMPORTED_MODULE_15__data_reducers__["a" /* default */],
    feeds: __WEBPACK_IMPORTED_MODULE_8__activityFeeds_reducers__["a" /* default */],
    user: __WEBPACK_IMPORTED_MODULE_9__user_reducers__["a" /* default */],
    style: __WEBPACK_IMPORTED_MODULE_10__style_reducers__["a" /* default */],
    form: __WEBPACK_IMPORTED_MODULE_16_redux_form__["a" /* reducer */],
    router: __WEBPACK_IMPORTED_MODULE_6_react_router_redux__["b" /* routerReducer */],
    myStyles: __WEBPACK_IMPORTED_MODULE_10__style_reducers__["b" /* myStylesReducer */],
    myShops: __WEBPACK_IMPORTED_MODULE_11__shop_reducers__["a" /* myShopsReducer */],
    shopProfile: __WEBPACK_IMPORTED_MODULE_11__shop_reducers__["b" /* shopProfileReducer */],
    mySpecials: __WEBPACK_IMPORTED_MODULE_12__special_reducers__["a" /* default */],
    special: __WEBPACK_IMPORTED_MODULE_12__special_reducers__["b" /* specialReducer */],
    search: __WEBPACK_IMPORTED_MODULE_17__search_reducers__["a" /* default */],
    conversations: __WEBPACK_IMPORTED_MODULE_23__message_reducers__["a" /* conversations */],
    messages: __WEBPACK_IMPORTED_MODULE_23__message_reducers__["b" /* messages */]
}), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux__["c" /* applyMiddleware */])(middleware, __WEBPACK_IMPORTED_MODULE_7_redux_thunk___default.a));
if (window.Styleteq.currentUser) {
    store.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__user_actions__["a" /* addCurrentUserAction */])({
        id: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20_class_transformer__["plainToClass"])(__WEBPACK_IMPORTED_MODULE_21__data_models_User__["a" /* default */], window.Styleteq.currentUser).id
    }));
    store.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__data_actions__["a" /* addDataAction */])({
        resource: __WEBPACK_IMPORTED_MODULE_19__helpers_data__["a" /* ResourceType */].user,
        data: window.Styleteq.currentUser
    }));
    store.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25__message_middlewares__["a" /* fetchConversations */])());
}
__WEBPACK_IMPORTED_MODULE_2_react_dom__["render"](__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_react_redux__["a" /* Provider */], { store: store },
    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_react_router_redux__["c" /* ConnectedRouter */], { history: history },
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_24__dashboard_components_DashboardComponent__["a" /* default */], null,
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14_react_router__["a" /* Route */], { render: function (props) {
                    return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13__dashboard_containers_RouterContainer__["a" /* default */], __assign({}, props));
                } })))), document.getElementById('root'));


/***/ }),

/***/ "./app/client/_repositories/boothRepository.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_api__ = __webpack_require__("./app/client/_helpers/api.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_utils__ = __webpack_require__("./app/client/_helpers/utils.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_models_Booth__ = __webpack_require__("./app/client/_data/models/Booth.ts");



var BoothRepository = {
    listByShop: function (shopId, cursor, page, perPage) {
        if (cursor === void 0) { cursor = null; }
        if (page === void 0) { page = null; }
        if (perPage === void 0) { perPage = 5; }
        var query = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_utils__["d" /* createQueryParameters */])({ cursor: cursor, page: page, per_page: perPage, is_cursor: true });
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_api__["b" /* apiFetch */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_utils__["c" /* to_url */])(__WEBPACK_IMPORTED_MODULE_0__helpers_api__["a" /* Api */].apiBaseUrl, 'salons', shopId, "booths") + query)
            .then(function (response) {
            if (response.status >= 200 && response.status < 300) {
                return response.json();
            }
            else {
                return {
                    error: true,
                    response: response
                };
            }
        });
    },
    // TODO: booth here is form data not Booth model
    saveBooth: function (booth) {
        var isNew = !(booth.id && booth.id != 0);
        var url = isNew
            ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_utils__["c" /* to_url */])(__WEBPACK_IMPORTED_MODULE_0__helpers_api__["a" /* Api */].apiBaseUrl, 'booths')
            : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_utils__["c" /* to_url */])(__WEBPACK_IMPORTED_MODULE_0__helpers_api__["a" /* Api */].apiBaseUrl, 'booths', booth.id);
        return fetch(url, {
            credentials: "same-origin",
            method: isNew ? "POST" : "PUT",
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json",
                'Cache': 'no-cache'
            },
            body: JSON.stringify({
                booth: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__data_models_Booth__["b" /* boothToApiDict */])(booth)
            })
        }).then(function (response) {
            return response.json();
        });
    }
};
/* harmony default export */ __webpack_exports__["a"] = (BoothRepository);


/***/ }),

/***/ "./app/client/_repositories/commentRepository.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_api__ = __webpack_require__("./app/client/_helpers/api.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_utils__ = __webpack_require__("./app/client/_helpers/utils.tsx");


var CommentRepository = {
    getByStyleId: function (id) {
        if (id === void 0) { id = null; }
        return fetch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_utils__["c" /* to_url */])(__WEBPACK_IMPORTED_MODULE_0__helpers_api__["a" /* Api */].apiBaseUrl, "styles/" + id + "/comments"), {
            credentials: "same-origin",
            headers: {
                "Accept": "application/json"
            },
        }).then(function (response) {
            return response.json();
        });
    },
    getByStyleId2: function (id, page, perPage) {
        if (page === void 0) { page = null; }
        if (perPage === void 0) { perPage = 10; }
        var query = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_utils__["d" /* createQueryParameters */])({ page: page, per_page: perPage });
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_api__["b" /* apiFetch */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_utils__["c" /* to_url */])(__WEBPACK_IMPORTED_MODULE_0__helpers_api__["a" /* Api */].apiBaseUrl, "styles/" + id + "/comments") + query)
            .then(function (response) {
            return response.json();
        });
    }
};
/* harmony default export */ __webpack_exports__["a"] = (CommentRepository);


/***/ }),

/***/ "./app/client/_repositories/commonRepository.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_api__ = __webpack_require__("./app/client/_helpers/api.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_utils__ = __webpack_require__("./app/client/_helpers/utils.tsx");


var CommonRepository = {
    getStates: function () {
        return fetch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_utils__["c" /* to_url */])(__WEBPACK_IMPORTED_MODULE_0__helpers_api__["a" /* Api */].apiBaseUrl, 'states'), {
            credentials: "same-origin",
            headers: {
                "Accept": "application/json"
            },
        }).then(function (response) {
            return response.json();
        });
    },
    getCities: function (state) {
        return fetch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_utils__["c" /* to_url */])(__WEBPACK_IMPORTED_MODULE_0__helpers_api__["a" /* Api */].apiBaseUrl, 'cities', state), {
            credentials: "same-origin",
            headers: {
                "Accept": "application/json"
            },
        }).then(function (response) {
            return response.json();
        });
    }
};
/* harmony default export */ __webpack_exports__["a"] = (CommonRepository);


/***/ }),

/***/ "./app/client/_repositories/conversationRepository.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_utils__ = __webpack_require__("./app/client/_helpers/utils.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_api__ = __webpack_require__("./app/client/_helpers/api.ts");


var ConversationRepository = {
    get: function (page, perPage) {
        if (page === void 0) { page = null; }
        if (perPage === void 0) { perPage = 5; }
        var query = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_utils__["d" /* createQueryParameters */])({ page: page, per_page: perPage });
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_api__["b" /* apiFetch */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_utils__["c" /* to_url */])(__WEBPACK_IMPORTED_MODULE_1__helpers_api__["a" /* Api */].apiBaseUrl, 'conversations') + query)
            .then(function (response) {
            return response.json();
        });
    },
    getMessages: function (conversationId, page, perPage) {
        if (page === void 0) { page = null; }
        if (perPage === void 0) { perPage = 10; }
        var query = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_utils__["d" /* createQueryParameters */])({ page: page, per_page: perPage });
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_api__["b" /* apiFetch */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_utils__["c" /* to_url */])(__WEBPACK_IMPORTED_MODULE_1__helpers_api__["a" /* Api */].apiBaseUrl, "conversations/" + conversationId + "/messages") + query)
            .then(function (response) {
            return response.json();
        });
    },
    getMessagesByRecipientId: function (recipientId, page, perPage) {
        if (page === void 0) { page = null; }
        if (perPage === void 0) { perPage = 5; }
        var query = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_utils__["d" /* createQueryParameters */])({ recipient_id: recipientId, page: page, per_page: perPage });
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_api__["b" /* apiFetch */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_utils__["c" /* to_url */])(__WEBPACK_IMPORTED_MODULE_1__helpers_api__["a" /* Api */].apiBaseUrl, "conversations/find_by_recipient") + query)
            .then(function (response) {
            return response.json();
        });
    },
    sendMessage: function (userId, conversationId, content, isNew) {
        var data = new FormData();
        data.append('message[recipient_id]', '' + userId);
        data.append('message[content]', '' + content);
        var url = isNew ? 'messages' : "conversations/" + conversationId + "/reply";
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_api__["b" /* apiFetch */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_utils__["c" /* to_url */])(__WEBPACK_IMPORTED_MODULE_1__helpers_api__["a" /* Api */].apiBaseUrl, url), { method: 'POST', body: data }).then(function (response) {
            return response.json();
        });
    },
    readMessage: function (conversationId) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_api__["b" /* apiFetch */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_utils__["c" /* to_url */])(__WEBPACK_IMPORTED_MODULE_1__helpers_api__["a" /* Api */].apiBaseUrl, "conversations/" + conversationId + "/read"), { method: 'POST', data: {} }).then(function (response) {
            if (response.status >= 200 && response.status < 300) {
                return response;
            }
            else {
                return {
                    error: true,
                    response: response
                };
            }
        });
    },
};
/* harmony default export */ __webpack_exports__["a"] = (ConversationRepository);


/***/ }),

/***/ "./app/client/_repositories/feedRepository.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_api__ = __webpack_require__("./app/client/_helpers/api.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_utils__ = __webpack_require__("./app/client/_helpers/utils.tsx");


var FeedsRepository = {
    get: function (cursor, page, perPage) {
        if (cursor === void 0) { cursor = null; }
        if (page === void 0) { page = null; }
        if (perPage === void 0) { perPage = 5; }
        var query = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_utils__["d" /* createQueryParameters */])({ cursor: cursor, page: page, per_page: perPage, is_cursor: true });
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_api__["b" /* apiFetch */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_utils__["c" /* to_url */])(__WEBPACK_IMPORTED_MODULE_0__helpers_api__["a" /* Api */].apiBaseUrl, 'feeds') + query)
            .then(function (response) {
            return response.json();
        });
    }
};
/* harmony default export */ __webpack_exports__["a"] = (FeedsRepository);


/***/ }),

/***/ "./app/client/_repositories/likeRepository.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_api__ = __webpack_require__("./app/client/_helpers/api.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_utils__ = __webpack_require__("./app/client/_helpers/utils.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pluralize__ = __webpack_require__("./node_modules/pluralize/pluralize.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pluralize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_pluralize__);



var LikeRepository = {
    toggle: function (model, user) {
        var resource = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_utils__["m" /* apiModelName */])(model);
        var likable = model;
        var data = new FormData();
        data.append(resource + '[user_id]', '' + user.id);
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_api__["b" /* apiFetch */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_utils__["c" /* to_url */])(__WEBPACK_IMPORTED_MODULE_0__helpers_api__["a" /* Api */].apiBaseUrl, __WEBPACK_IMPORTED_MODULE_2_pluralize__(resource), likable.id, likable.isLiked ? 'unlike' : 'like'), { method: 'POST', body: data }).catch(function (error) {
            console.log(error.message);
        });
    }
};
/* harmony default export */ __webpack_exports__["a"] = (LikeRepository);


/***/ }),

/***/ "./app/client/_repositories/searchRepository.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_utils__ = __webpack_require__("./app/client/_helpers/utils.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_api__ = __webpack_require__("./app/client/_helpers/api.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__routes__ = __webpack_require__("./app/client/routes.ts");



var SearchRepository = {
    search: function (q, geo, typeFilter, secondaryFilters, page, perPage) {
        if (perPage === void 0) { perPage = 25; }
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_api__["b" /* apiFetch */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_utils__["c" /* to_url */])(__WEBPACK_IMPORTED_MODULE_1__helpers_api__["a" /* Api */].apiBaseUrl, 'search') + __WEBPACK_IMPORTED_MODULE_2__routes__["c" /* SearchRoutes */].queryUrl(q, geo, typeFilter, secondaryFilters, page, perPage))
            .then(function (response) {
            return response.json();
        });
    },
    searchTrendingCategory: function (typeFilter, geo, perPage, secondaryFilters) {
        return SearchRepository.search(null, geo, typeFilter, secondaryFilters, null, perPage);
    },
};
/* harmony default export */ __webpack_exports__["a"] = (SearchRepository);


/***/ }),

/***/ "./app/client/_repositories/shopRepository.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_api__ = __webpack_require__("./app/client/_helpers/api.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_utils__ = __webpack_require__("./app/client/_helpers/utils.tsx");


var ShopRepository = {
    listByUser: function (user, cursor, page, perPage) {
        if (cursor === void 0) { cursor = null; }
        if (page === void 0) { page = null; }
        if (perPage === void 0) { perPage = 5; }
        var query = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_utils__["d" /* createQueryParameters */])({ user: user.id, cursor: cursor, page: page, per_page: perPage, is_cursor: true });
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_api__["b" /* apiFetch */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_utils__["c" /* to_url */])(__WEBPACK_IMPORTED_MODULE_0__helpers_api__["a" /* Api */].apiBaseUrl, 'salons') + query)
            .then(function (response) {
            if (response.status >= 200 && response.status < 300) {
                return response.json();
            }
            else {
                return {
                    error: true,
                    response: response
                };
            }
        });
    },
    getShopProfessionals: function (shopId, cursor, page, perPage) {
        if (cursor === void 0) { cursor = null; }
        if (page === void 0) { page = null; }
        if (perPage === void 0) { perPage = 5; }
        var query = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_utils__["d" /* createQueryParameters */])({ cursor: cursor, page: page, per_page: perPage, is_cursor: true });
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_api__["b" /* apiFetch */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_utils__["c" /* to_url */])(__WEBPACK_IMPORTED_MODULE_0__helpers_api__["a" /* Api */].apiBaseUrl, 'salons', shopId, "professionals") + query)
            .then(function (response) {
            if (response.status >= 200 && response.status < 300) {
                return response.json();
            }
            else {
                return {
                    error: true,
                    response: response
                };
            }
        });
    }
};
/* harmony default export */ __webpack_exports__["a"] = (ShopRepository);


/***/ }),

/***/ "./app/client/_repositories/specialRepository.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_api__ = __webpack_require__("./app/client/_helpers/api.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_utils__ = __webpack_require__("./app/client/_helpers/utils.tsx");


var SpecialRepository = {
    getById: function (id) {
        if (id === void 0) { id = null; }
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_api__["b" /* apiFetch */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_utils__["c" /* to_url */])(__WEBPACK_IMPORTED_MODULE_0__helpers_api__["a" /* Api */].apiBaseUrl, "specials/" + id)).then(function (response) {
            return response.json();
        });
    },
    getByUserId: function (user, cursor, page, perPage) {
        if (cursor === void 0) { cursor = null; }
        if (page === void 0) { page = null; }
        if (perPage === void 0) { perPage = 5; }
        var query = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_utils__["d" /* createQueryParameters */])({ page: page, per_page: perPage });
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_api__["b" /* apiFetch */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_utils__["c" /* to_url */])(__WEBPACK_IMPORTED_MODULE_0__helpers_api__["a" /* Api */].apiBaseUrl, "users/" + user.id + "/specials") + query).
            then(function (response) {
            if (response.status >= 200 && response.status < 300) {
                return response.json();
            }
            else {
                return {
                    error: true,
                    response: response
                };
            }
        });
    },
    getExpiredSpecialsByUserId: function (user, cursor, page, perPage) {
        if (cursor === void 0) { cursor = null; }
        if (page === void 0) { page = null; }
        if (perPage === void 0) { perPage = 5; }
        var query = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_utils__["d" /* createQueryParameters */])({ page: page, per_page: perPage });
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_api__["b" /* apiFetch */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_utils__["c" /* to_url */])(__WEBPACK_IMPORTED_MODULE_0__helpers_api__["a" /* Api */].apiBaseUrl, "users/" + user.id + "/expired_specials") + query).
            then(function (response) {
            if (response.status >= 200 && response.status < 300) {
                return response.json();
            }
            else {
                return {
                    error: true,
                    response: response
                };
            }
        });
    },
    getLikedSpecialsByUserId: function (user, cursor, page, perPage) {
        if (cursor === void 0) { cursor = null; }
        if (page === void 0) { page = null; }
        if (perPage === void 0) { perPage = 5; }
        var query = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_utils__["d" /* createQueryParameters */])({ page: page, per_page: perPage });
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_api__["b" /* apiFetch */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_utils__["c" /* to_url */])(__WEBPACK_IMPORTED_MODULE_0__helpers_api__["a" /* Api */].apiBaseUrl, "users/" + user.id + "/liked_specials") + query).
            then(function (response) {
            if (response.status >= 200 && response.status < 300) {
                return response.json();
            }
            else {
                return {
                    error: true,
                    response: response
                };
            }
        });
    }
};
/* harmony default export */ __webpack_exports__["a"] = (SpecialRepository);


/***/ }),

/***/ "./app/client/_repositories/styleRepository.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_api__ = __webpack_require__("./app/client/_helpers/api.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_utils__ = __webpack_require__("./app/client/_helpers/utils.tsx");


var StyleRepository = {
    get: function (offsetId) {
        if (offsetId === void 0) { offsetId = null; }
        return fetch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_utils__["c" /* to_url */])(__WEBPACK_IMPORTED_MODULE_0__helpers_api__["a" /* Api */].apiBaseUrl, 'styles'), {
            credentials: "same-origin",
            headers: {
                "Content-Type": "application/json",
            },
        }).then(function (response) {
            return response.json();
        });
    },
    getById: function (id) {
        if (id === void 0) { id = null; }
        return fetch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_utils__["c" /* to_url */])(__WEBPACK_IMPORTED_MODULE_0__helpers_api__["a" /* Api */].apiBaseUrl, 'styles/' + id), {
            credentials: "same-origin",
            headers: {
                "Accept": "application/json"
            },
        }).then(function (response) {
            if (response.ok) {
                return response.json();
            }
            else {
                return null;
            }
        });
    },
    getByUserId: function (user, cursor, page, perPage) {
        if (cursor === void 0) { cursor = null; }
        if (page === void 0) { page = null; }
        if (perPage === void 0) { perPage = 10; }
        var query = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_utils__["d" /* createQueryParameters */])({ page: page, per_page: perPage });
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_api__["b" /* apiFetch */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_utils__["c" /* to_url */])(__WEBPACK_IMPORTED_MODULE_0__helpers_api__["a" /* Api */].apiBaseUrl, "users/" + user.id + "/styles") + query).
            then(function (response) {
            if (response.status >= 200 && response.status < 300) {
                return response.json();
            }
            else {
                return {
                    error: true,
                    response: response
                };
            }
        });
    }
};
/* harmony default export */ __webpack_exports__["a"] = (StyleRepository);


/***/ }),

/***/ "./app/client/_repositories/userRepository.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_api__ = __webpack_require__("./app/client/_helpers/api.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_utils__ = __webpack_require__("./app/client/_helpers/utils.tsx");


var UsersRepository = {
    get: function (id) {
        if (!id)
            return null;
        var _id = null;
        if (typeof id === 'number')
            _id = id.toString();
        else if (typeof id === 'string')
            _id = id;
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_api__["b" /* apiFetch */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_utils__["c" /* to_url */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_utils__["c" /* to_url */])(__WEBPACK_IMPORTED_MODULE_0__helpers_api__["a" /* Api */].apiBaseUrl, 'users', _id)))
            .then(function (response) {
            return response.json();
        })
            .catch(function (error) {
            console.log(error.message);
            return {
                error: true,
                response: null
            };
        });
    },
    getStylesById: function (id, page, perPage) {
        if (id === void 0) { id = null; }
        if (page === void 0) { page = null; }
        if (perPage === void 0) { perPage = 10; }
        var query = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_utils__["d" /* createQueryParameters */])({ page: page, per_page: perPage });
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_api__["b" /* apiFetch */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_utils__["c" /* to_url */])(__WEBPACK_IMPORTED_MODULE_0__helpers_api__["a" /* Api */].apiBaseUrl, 'users/' + id + '/styles') + query)
            .then(function (response) {
            return response.json();
        });
    },
    getLikedStylesById: function (id, page, perPage) {
        if (id === void 0) { id = null; }
        if (page === void 0) { page = null; }
        if (perPage === void 0) { perPage = 10; }
        var query = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_utils__["d" /* createQueryParameters */])({ page: page, per_page: perPage });
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_api__["b" /* apiFetch */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_utils__["c" /* to_url */])(__WEBPACK_IMPORTED_MODULE_0__helpers_api__["a" /* Api */].apiBaseUrl, 'users/' + id + '/liked_styles') + query)
            .then(function (response) {
            return response.json();
        });
    },
    getSpecialsById: function (id, page, perPage) {
        if (id === void 0) { id = null; }
        if (page === void 0) { page = null; }
        if (perPage === void 0) { perPage = 10; }
        var query = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_utils__["d" /* createQueryParameters */])({ page: page, per_page: perPage });
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_api__["b" /* apiFetch */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_utils__["c" /* to_url */])(__WEBPACK_IMPORTED_MODULE_0__helpers_api__["a" /* Api */].apiBaseUrl, 'users/' + id + '/specials') + query)
            .then(function (response) {
            return response.json();
        });
    },
    getFollowingUsersById: function (id, page, perPage) {
        if (id === void 0) { id = null; }
        if (page === void 0) { page = null; }
        if (perPage === void 0) { perPage = 10; }
        var query = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_utils__["d" /* createQueryParameters */])({ page: page, per_page: perPage });
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_api__["b" /* apiFetch */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_utils__["c" /* to_url */])(__WEBPACK_IMPORTED_MODULE_0__helpers_api__["a" /* Api */].apiBaseUrl, 'users/' + id + '/users_followed') + query)
            .then(function (response) {
            return response.json();
        });
    },
    getFollowingShopsById: function (id, page, perPage) {
        if (id === void 0) { id = null; }
        if (page === void 0) { page = null; }
        if (perPage === void 0) { perPage = 10; }
        var query = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_utils__["d" /* createQueryParameters */])({ page: page, per_page: perPage });
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_api__["b" /* apiFetch */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_utils__["c" /* to_url */])(__WEBPACK_IMPORTED_MODULE_0__helpers_api__["a" /* Api */].apiBaseUrl, 'users/' + id + '/liked_salons') + query)
            .then(function (response) {
            return response.json();
        });
    },
    getFollowersById: function (id, page, perPage) {
        if (id === void 0) { id = null; }
        if (page === void 0) { page = null; }
        if (perPage === void 0) { perPage = 10; }
        var query = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_utils__["d" /* createQueryParameters */])({ page: page, per_page: perPage, });
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_api__["b" /* apiFetch */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_utils__["c" /* to_url */])(__WEBPACK_IMPORTED_MODULE_0__helpers_api__["a" /* Api */].apiBaseUrl, 'users/' + id + '/followers') + query)
            .then(function (response) {
            return response.json();
        });
    },
    toggleFollowUser: function (id, follower_id, is_followed) {
        if (id === void 0) { id = null; }
        if (follower_id === void 0) { follower_id = null; }
        var data = new FormData();
        data.append('user[follower_id]', '' + follower_id);
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_api__["b" /* apiFetch */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_utils__["c" /* to_url */])(__WEBPACK_IMPORTED_MODULE_0__helpers_api__["a" /* Api */].apiBaseUrl, 'users', id, is_followed ? 'unfollow' : 'follow'), {
            method: is_followed ? 'DELETE' : 'PUT', body: data
        })
            .catch(function (error) {
            console.log(error.message);
        });
    },
    toggleFollowShop: function (id, follower_id, is_followed) {
        if (id === void 0) { id = null; }
        if (follower_id === void 0) { follower_id = null; }
        var data = new FormData();
        data.append('salon[user_id]', '' + follower_id);
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_api__["b" /* apiFetch */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_utils__["c" /* to_url */])(__WEBPACK_IMPORTED_MODULE_0__helpers_api__["a" /* Api */].apiBaseUrl, 'salons', id, is_followed ? 'unlike' : 'like'), {
            method: 'POST', body: data
        })
            .catch(function (error) {
            console.log(error.message);
        });
    },
    //TODO: If have edit
    saveProfile: function (profile) {
        return fetch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_utils__["c" /* to_url */])(__WEBPACK_IMPORTED_MODULE_0__helpers_api__["a" /* Api */].apiBaseUrl, 'users/' + profile.id), {
            credentials: "same-origin",
            method: 'PUT',
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json",
                'Cache': 'no-cache'
            },
            body: JSON.stringify({
                user: profile
            })
        }).then(function (response) {
            return response.json();
        }).catch(function (error) {
            console.log(error.message);
        });
    }
};
/* harmony default export */ __webpack_exports__["a"] = (UsersRepository);


/***/ }),

/***/ "./app/client/_widgets/breadcrumbs/BreadcrumbsComponent.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/react.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var BreadcrumbsComponent = function (props) {
    var children = props.children;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "medium-6 column" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("nav", { "aria-label": "You are here:", role: "navigation", className: "mt-1 mb-1" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("ul", { className: "breadcrumbs" }, children))));
};
/* harmony default export */ __webpack_exports__["a"] = (BreadcrumbsComponent);


/***/ }),

/***/ "./app/client/_widgets/carousel/CarouselComponent.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/react.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_owl_carousel__ = __webpack_require__("./node_modules/react-owl-carousel/lib/OwlCarousel.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_owl_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_owl_carousel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_imageHelpers__ = __webpack_require__("./app/client/_helpers/imageHelpers.ts");



var CarouselComponent = function (props) {
    var images = props.images;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_owl_carousel___default.a, { className: "owl-theme", loop: images.length > 1, margin: 0, autoWidth: true, items: 1, nav: false, dots: true, center: true }, images.map(function (each) {
        var width = each.width * .4;
        var adjustedSize = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__helpers_imageHelpers__["a" /* imageAspectSizeForMaxHeight */])(each, { height: 360, width: 480 });
        // console.log("Original size: "+each.width+"x"+each.height);
        // console.log("Adjusted size: "+adjustedSize.width+"x"+adjustedSize.height);
        // console.log("================================");
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { style: { width: adjustedSize.width, height: adjustedSize.height }, key: "carousel_item_" + each.id },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: each.url })));
    })));
};
/* harmony default export */ __webpack_exports__["a"] = (CarouselComponent);


/***/ }),

/***/ "./app/client/_widgets/follow/FollowComponent.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/react.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__("./node_modules/classnames/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_data__ = __webpack_require__("./app/client/_helpers/data.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data_models_Shop__ = __webpack_require__("./app/client/_data/models/Shop.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__data_models_User__ = __webpack_require__("./app/client/_data/models/User.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__routes__ = __webpack_require__("./app/client/routes.ts");






var FollowComponent = function (props) {
    var toggleFollow = props.toggleFollow, model = props.model, currentUserID = props.currentUserID, className = props.className;
    var m = '';
    var check = false;
    var modelObj = null;
    if (model instanceof __WEBPACK_IMPORTED_MODULE_4__data_models_User__["a" /* default */]) {
        modelObj = model;
        m = __WEBPACK_IMPORTED_MODULE_2__helpers_data__["a" /* ResourceType */].user;
        check = currentUserID && currentUserID != modelObj.id && !modelObj.defaultFollowable;
    }
    else if (model instanceof __WEBPACK_IMPORTED_MODULE_3__data_models_Shop__["a" /* default */]) {
        m = __WEBPACK_IMPORTED_MODULE_2__helpers_data__["a" /* ResourceType */].shop;
        modelObj = model;
        check = currentUserID && currentUserID != modelObj.userId;
    }
    if (!currentUserID) {
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { href: __WEBPACK_IMPORTED_MODULE_5__routes__["g" /* UsersRoutes */].sign_in(), className: __WEBPACK_IMPORTED_MODULE_1_classnames__("button", className, "hollow") },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("i", { className: "fa fa-plus fa-fw" }),
            "\u00A0 Follow");
    }
    return (check && (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { onClick: function () { return toggleFollow(modelObj.id, currentUserID, modelObj.isFollowed, m); }, className: __WEBPACK_IMPORTED_MODULE_1_classnames__("button", className, { "hollow": !modelObj.isFollowed }) },
        modelObj.isFollowed && 'Following',
        !modelObj.isFollowed && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("i", { className: "fa fa-plus fa-fw" }),
            "\u00A0 Follow"))));
};
/* harmony default export */ __webpack_exports__["a"] = (FollowComponent);


/***/ }),

/***/ "./app/client/_widgets/follow/FollowContainer.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FollowComponent__ = __webpack_require__("./app/client/_widgets/follow/FollowComponent.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__("./node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_middlewares__ = __webpack_require__("./app/client/_data/middlewares.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_data__ = __webpack_require__("./app/client/_helpers/data.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__user_selectors__ = __webpack_require__("./app/client/user/selectors.ts");





var mapStateToProps = function (state, props) {
    return {
        model: props.model,
        className: props.className,
        currentUserID: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__user_selectors__["a" /* currentUserIdSelector */])(state)
    };
};
var mapDispatchToProps = function (dispatch) {
    return {
        toggleFollow: function (id, follower_id, is_followed, model_type) {
            if (model_type === __WEBPACK_IMPORTED_MODULE_3__helpers_data__["a" /* ResourceType */].user) {
                dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__data_middlewares__["b" /* toggleUserFollow */])(id, follower_id, is_followed));
            }
            else if (model_type === __WEBPACK_IMPORTED_MODULE_3__helpers_data__["a" /* ResourceType */].shop) {
                dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__data_middlewares__["c" /* toggleShopFollow */])(id, follower_id, is_followed));
            }
        }
    };
};
var FollowContainer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_0__FollowComponent__["a" /* default */]);
/* harmony default export */ __webpack_exports__["a"] = (FollowContainer);


/***/ }),

/***/ "./app/client/_widgets/form/InputComponent.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/react.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};

var InputComponent = function (_a) {
    var input = _a.input, label = _a.label, type = _a.type, _b = _a.meta, touched = _b.touched, error = _b.error;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "medium-6 columns" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("label", { className: touched && error && "has-error" },
                label,
                touched && error &&
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("small", { className: "error" },
                        "\u00A0",
                        error),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("input", __assign({}, input, { placeholder: label, type: type }))))));
};
/* harmony default export */ __webpack_exports__["a"] = (InputComponent);


/***/ }),

/***/ "./app/client/_widgets/form/validators.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return positive_number; });
var positive_number = function (value) {
    return (value && value > 0) ? undefined : "This should be greater than zero.";
};
/* unused harmony default export */ var _unused_webpack_default_export = (positive_number);


/***/ }),

/***/ "./app/client/_widgets/like/LikeComponent.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/react.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_utils__ = __webpack_require__("./app/client/_helpers/utils.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__("./node_modules/classnames/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);



var LikeComponent = function (props) {
    var likable = props.likable, toggleLike = props.toggleLike, isGalleryView = props.isGalleryView, currentUserID = props.currentUserID;
    var liked = likable.isLiked;
    var clickableLike = (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { onClick: function (e) { return toggleLike(e, currentUserID); }, className: __WEBPACK_IMPORTED_MODULE_2_classnames__({ active: liked }) },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("i", { className: __WEBPACK_IMPORTED_MODULE_2_classnames__("fa fa-fw", { "fa-heart": liked, "fa-heart-o": !liked }) }),
        "\u00A0",
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_utils__["j" /* prettyPrintLike */])(likable)));
    if (isGalleryView)
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "text-center featured-image-block-title" }, clickableLike));
    else
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", { className: "mr-2" }, clickableLike));
};
/* harmony default export */ __webpack_exports__["a"] = (LikeComponent);


/***/ }),

/***/ "./app/client/_widgets/like/LikeContainer.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__("./node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__LikeComponent__ = __webpack_require__("./app/client/_widgets/like/LikeComponent.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_middlewares__ = __webpack_require__("./app/client/_data/middlewares.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__user_selectors__ = __webpack_require__("./app/client/user/selectors.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__routes__ = __webpack_require__("./app/client/routes.ts");





var mapStateToProps = function (state, props) {
    var model = props.model, isGalleryView = props.isGalleryView;
    return {
        likable: model,
        isGalleryView: isGalleryView,
        currentUserID: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__user_selectors__["a" /* currentUserIdSelector */])(state)
    };
};
var mapDispatchToProps = function (dispatch, props) {
    var model = props.model;
    return {
        toggleLike: function (e, id) {
            e.stopPropagation();
            if (!id)
                return window.location.href = __WEBPACK_IMPORTED_MODULE_4__routes__["g" /* UsersRoutes */].sign_in();
            return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__data_middlewares__["a" /* toggleLike */])(model));
        }
    };
};
var LikeContainer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__LikeComponent__["a" /* default */]);
/* harmony default export */ __webpack_exports__["a"] = (LikeContainer);


/***/ }),

/***/ "./app/client/_widgets/loadingIndicator/LoadingIndicatorComponent.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/react.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var LoadingIndicatorComponent = function (props) {
    var message = props.message;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "text-center loading-indicator" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: window.Styleteq.images.ajaxLoader, alt: "loading" }),
        message &&
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null, message)));
};
/* harmony default export */ __webpack_exports__["a"] = (LoadingIndicatorComponent);


/***/ }),

/***/ "./app/client/_widgets/modal/ModalComponent.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ModalSizes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/react.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__("./node_modules/classnames/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_utils__ = __webpack_require__("./app/client/_helpers/utils.tsx");



var ModalSizes = {
    TINY: 'tiny',
    SMALL: 'small',
    MEDIUM: 'medium',
    MEDIUMLARGE: 'medium-large',
    LARGE: 'large',
    FULL: 'full'
};
var ModalComponent = function (_a) {
    var show = _a.show, children = _a.children, className = _a.className, size = _a.size, onExit = _a.onExit;
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__helpers_utils__["a" /* toggleBodyScroll */])(!show);
    if (!show)
        return null;
    var modalClass = __WEBPACK_IMPORTED_MODULE_1_classnames__('reveal paddingless', className, size);
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "reveal-overlay react-reveal", onClick: onExit },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "wrapper" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: modalClass, role: "dialog", onClick: function (e) { return e.stopPropagation(); } }, children))));
};
/* harmony default export */ __webpack_exports__["a"] = (ModalComponent);


/***/ }),

/***/ "./app/client/_widgets/modal/actions.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return toggleActiveModal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__("./node_modules/redux-actions/es/index.js");

var toggleActiveModal = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])("TOGGLE_ACTIVE_MODAL");


/***/ }),

/***/ "./app/client/_widgets/modal/reducer.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__("./node_modules/redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__("./app/client/_widgets/modal/actions.ts");


function activeModalKey(state, action) {
    if (state === void 0) { state = null; }
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* toggleActiveModal */].toString():
            return action.payload.key;
    }
    return state;
}
function activeModalFlag(state, action) {
    if (state === void 0) { state = false; }
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* toggleActiveModal */].toString():
            return action.payload.active;
    }
    return state;
}
var activeModalReducer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux__["b" /* combineReducers */])({
    key: activeModalKey,
    active: activeModalFlag
});
/* harmony default export */ __webpack_exports__["a"] = (activeModalReducer);


/***/ }),

/***/ "./app/client/_widgets/sidebarLink/LinkComponent.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/react.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__("./node_modules/react-router-dom/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__("./node_modules/classnames/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);



var LinkComponent = function (props) {
    var to = props.to, onClick = props.onClick, active = props.active, children = props.children;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", { className: __WEBPACK_IMPORTED_MODULE_2_classnames__({ active: active }) },
        !onClick &&
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */], { to: to }, children),
        onClick &&
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { onClick: onClick }, children)));
};
/* harmony default export */ __webpack_exports__["a"] = (LinkComponent);


/***/ }),

/***/ "./app/client/_widgets/sidebarLink/LinkContainer.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__LinkComponent__ = __webpack_require__("./app/client/_widgets/sidebarLink/LinkComponent.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__("./node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_routerSelectors__ = __webpack_require__("./app/client/_helpers/routerSelectors.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__("./node_modules/lodash/lodash.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);




var mapStateToProps = function (state, props) {
    var currentPath = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__helpers_routerSelectors__["a" /* currentPathSelector */])(state);
    return {
        active: props.exact ? __WEBPACK_IMPORTED_MODULE_3_lodash__["eq"](currentPath, props.to) : __WEBPACK_IMPORTED_MODULE_3_lodash__["startsWith"](currentPath, props.to)
    };
};
var LinkContainer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_0__LinkComponent__["a" /* default */]);
/* harmony default export */ __webpack_exports__["a"] = (LinkContainer);


/***/ }),

/***/ "./app/client/_widgets/user/UserProfileHeaderComponent.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/react.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__widgets_user_UserRedirectContainer__ = __webpack_require__("./app/client/_widgets/user/UserRedirectContainer.tsx");


;
var UserProfileHeaderComponent = function (props) {
    var user = props.user;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "large-12 columns" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "flex-container" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "media-object" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "media-object-section logo middle" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "img-wrapper circle small-img-fit" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null,
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { width: "60", src: user.profilePicture() })))),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "media-object-section middle" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "h4" }, user.username()),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "subheader" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("small", null, user.displayProfession())))),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__widgets_user_UserRedirectContainer__["a" /* default */], { id: user.id, element: "a", className: "button primary hollow small pull-right" }, "View Profile")))));
};
/* harmony default export */ __webpack_exports__["a"] = (UserProfileHeaderComponent);


/***/ }),

/***/ "./app/client/_widgets/user/UserRedirectComponent.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/react.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_data__ = __webpack_require__("./app/client/_helpers/data.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__("./node_modules/classnames/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);



var UserRedirectComponent = function (props) {
    var children = props.children, click = props.click, className = props.className, id = props.id, element = props.element, type = props.type;
    var t = !type ? __WEBPACK_IMPORTED_MODULE_1__helpers_data__["a" /* ResourceType */].user : type;
    if (element == 'a') {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { onClick: function (e) { return click(id, e, t); }, className: className }, children));
    }
    else if (element == 'div') {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { onClick: function (e) { return click(id, e, t); }, className: __WEBPACK_IMPORTED_MODULE_2_classnames__('link-cursor', className) }, children));
    }
    else if (element == 'b') {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("b", { onClick: function (e) { return click(id, e, t); }, className: __WEBPACK_IMPORTED_MODULE_2_classnames__('link-cursor', className) }, children));
    }
    return null;
};
/* harmony default export */ __webpack_exports__["a"] = (UserRedirectComponent);


/***/ }),

/***/ "./app/client/_widgets/user/UserRedirectContainer.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__("./node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__UserRedirectComponent__ = __webpack_require__("./app/client/_widgets/user/UserRedirectComponent.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_redux__ = __webpack_require__("./node_modules/react-router-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__routes__ = __webpack_require__("./app/client/routes.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_data__ = __webpack_require__("./app/client/_helpers/data.ts");





var mapStateToProps = function (state, props) {
    return {
        id: props.id,
        className: props.className,
        element: props.element,
        type: props.type
    };
};
var mapDispatchToProps = function (dispatch) {
    return {
        click: function (id, e, type) {
            e.stopPropagation();
            if (type == __WEBPACK_IMPORTED_MODULE_4__helpers_data__["a" /* ResourceType */].user)
                dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_router_redux__["d" /* push */])(__WEBPACK_IMPORTED_MODULE_3__routes__["g" /* UsersRoutes */].show(id), { state: { refresh: true } }));
            else if (type == __WEBPACK_IMPORTED_MODULE_4__helpers_data__["a" /* ResourceType */].shop)
                dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_router_redux__["d" /* push */])(__WEBPACK_IMPORTED_MODULE_3__routes__["d" /* ShopsRoutes */].view(id), { state: { refresh: true } }));
            else if (type == __WEBPACK_IMPORTED_MODULE_4__helpers_data__["a" /* ResourceType */].style)
                dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_router_redux__["d" /* push */])(__WEBPACK_IMPORTED_MODULE_3__routes__["a" /* StylesRoutes */].show(id), { state: { refresh: true } }));
            else if (type == __WEBPACK_IMPORTED_MODULE_4__helpers_data__["a" /* ResourceType */].special)
                dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_router_redux__["d" /* push */])(__WEBPACK_IMPORTED_MODULE_3__routes__["e" /* SpecialsRoutes */].show(id), { state: { refresh: true } }));
            else if (type == __WEBPACK_IMPORTED_MODULE_4__helpers_data__["a" /* ResourceType */].message)
                dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_router_redux__["d" /* push */])(__WEBPACK_IMPORTED_MODULE_3__routes__["f" /* ConversationsRoutes */].new(id), { state: { refresh: true } }));
        }
    };
};
var UserRedirectContainer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__UserRedirectComponent__["a" /* default */]);
/* harmony default export */ __webpack_exports__["a"] = (UserRedirectContainer);


/***/ }),

/***/ "./app/client/activityFeeds/actions.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return requestFeedsAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return receiveFeedsAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return clearFeedsAction; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__("./node_modules/redux-actions/es/index.js");

var requestFeedsAction = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_FEEDS');
var receiveFeedsAction = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('RECEIVE_FEEDS');
var clearFeedsAction = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('CLEAR_FEEDS');


/***/ }),

/***/ "./app/client/activityFeeds/components/ActivityFeedBoothItemComponent.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/react.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_pluralize__ = __webpack_require__("./node_modules/pluralize/pluralize.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_pluralize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_pluralize__);


var ActivityFeedBoothItemComponent = function (props) {
    var booth = props.booth, shop = props.shop, viewBooth = props.viewBooth;
    var count = booth.workstationCount;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row", onClick: viewBooth },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "large-12 columns" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "post-img v-align-center" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: booth.primaryPictureUrl || shop.primaryPictureUrl, alt: shop.name })),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "text-wrapper" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h5", null, shop.name),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h6", { className: "subheader" }, shop.address()),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h6", { className: "subheader" },
                        count,
                        " ",
                        __WEBPACK_IMPORTED_MODULE_1_pluralize__('Booth', count),
                        " For Rent - $",
                        booth.price,
                        "/",
                        booth.terms))))));
};
/* harmony default export */ __webpack_exports__["a"] = (ActivityFeedBoothItemComponent);


/***/ }),

/***/ "./app/client/activityFeeds/components/ActivityFeedComponent.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/react.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_infinite_scroll__ = __webpack_require__("./node_modules/redux-infinite-scroll/lib/ReduxInfiniteScroll.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_infinite_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_infinite_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_ActivityFeedModalContainer__ = __webpack_require__("./app/client/activityFeeds/containers/ActivityFeedModalContainer.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_ActivityFeedItemContainer__ = __webpack_require__("./app/client/activityFeeds/containers/ActivityFeedItemContainer.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__widgets_loadingIndicator_LoadingIndicatorComponent__ = __webpack_require__("./app/client/_widgets/loadingIndicator/LoadingIndicatorComponent.tsx");





var ActivityFeedComponent = function (props) {
    var feeds = props.feeds, loading = props.loading, loadMore = props.loadMore, meta = props.meta, openModal = props.openModal, selectedFeedId = props.selectedFeedId, history = props.history, currentUserID = props.currentUserID;
    var showModal = openModal && feeds.get(selectedFeedId);
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row expanded" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "medium-12 columns" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_redux_infinite_scroll___default.a, { loadMore: function () { return loadMore(meta); }, elementIsScrollable: false, loadingMore: loading, loader: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__widgets_loadingIndicator_LoadingIndicatorComponent__["a" /* default */], null), threshold: 200 }, feeds.toArray().map(function (feed) { return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__containers_ActivityFeedItemContainer__["a" /* default */], { feed: feed, key: feed.id, currentUserID: currentUserID }); })),
            showModal &&
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__containers_ActivityFeedModalContainer__["a" /* default */], { history: history, id: selectedFeedId, currentUserID: currentUserID }))));
};
/* harmony default export */ __webpack_exports__["a"] = (ActivityFeedComponent);


/***/ }),

/***/ "./app/client/activityFeeds/components/ActivityFeedItemComponent.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/react.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__("./node_modules/moment/moment.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_utils__ = __webpack_require__("./app/client/_helpers/utils.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__widgets_user_UserRedirectContainer__ = __webpack_require__("./app/client/_widgets/user/UserRedirectContainer.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__containers_ActivityFeedBoothItemContainer__ = __webpack_require__("./app/client/activityFeeds/containers/ActivityFeedBoothItemContainer.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ActivityFeedStyleItemComponent__ = __webpack_require__("./app/client/activityFeeds/components/ActivityFeedStyleItemComponent.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__containers_ActivityFeedSpecialItemContainer__ = __webpack_require__("./app/client/activityFeeds/containers/ActivityFeedSpecialItemContainer.tsx");







var ActivityFeedItemComponent = function (props) {
    var feed = props.feed, model = props.model, viewFeed = props.viewFeed, toggleLike = props.toggleLike;
    var owner = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__helpers_utils__["q" /* getOwnerFromModel */])(model);
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "newsfeed-panel callout paddingless mb-half" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row p1 pb-0" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "large-12 columns" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("ul", { className: "list-inline marginless" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null,
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__widgets_user_UserRedirectContainer__["a" /* default */], { id: owner.id, element: "a" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: owner.profilePicture(), className: "img-wrapper circle" }))),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null,
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__widgets_user_UserRedirectContainer__["a" /* default */], { id: owner.id, element: "a" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h5", { className: "inline" },
                                "\u00A0",
                                owner.username())),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("label", { className: "inline" },
                            "\u00A0posted a new ",
                            feed.resource)),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", { className: "float-right " },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("label", { className: "inline post-time v-align-center" }, __WEBPACK_IMPORTED_MODULE_1_moment__(feed.createdAt).fromNow()))))),
        feed.resource == 'style' &&
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__ActivityFeedStyleItemComponent__["a" /* default */], { style: model, toggleLike: toggleLike, viewFeed: viewFeed }),
        feed.resource == 'booth' &&
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__containers_ActivityFeedBoothItemContainer__["a" /* default */], { booth: model }),
        feed.resource == 'special' &&
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__containers_ActivityFeedSpecialItemContainer__["a" /* default */], { special: model, toggleLike: toggleLike })));
};
/* harmony default export */ __webpack_exports__["a"] = (ActivityFeedItemComponent);


/***/ }),

/***/ "./app/client/activityFeeds/components/ActivityFeedSpecialItemComponent.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/react.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__widgets_like_LikeComponent__ = __webpack_require__("./app/client/_widgets/like/LikeComponent.tsx");


var ActivityFeedSpecialItemComponent = function (props) {
    var special = props.special, toggleLike = props.toggleLike, viewSpecial = props.viewSpecial;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row pr-1 pl-1", onClick: viewSpecial },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "large-12 columns paddingless bt-1 bb-1 p2 specials" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "text-center" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", null, special.title.toUpperCase()),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "word-wrap-break" }, special.description),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("small", null,
                        "Starts on ",
                        special.prettyStartDate(),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("br", null),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null, special.prettyEndDateString()))))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row p1 special-like-section" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "large-12 columns" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("ul", { className: "list-inline marginless newsfeed-lgfont" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__widgets_like_LikeComponent__["a" /* default */], { toggleLike: toggleLike, likable: special }))))));
};
/* harmony default export */ __webpack_exports__["a"] = (ActivityFeedSpecialItemComponent);


/***/ }),

/***/ "./app/client/activityFeeds/components/ActivityFeedStyleItemComponent.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/react.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__widgets_like_LikeComponent__ = __webpack_require__("./app/client/_widgets/like/LikeComponent.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_utils__ = __webpack_require__("./app/client/_helpers/utils.tsx");



var ActivityFeedStyleItemComponent = function (props) {
    var style = props.style, toggleLike = props.toggleLike, viewFeed = props.viewFeed;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "large-12 columns", onClick: viewFeed },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "post-img v-align-center" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { "data-open": "postmodal" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: style.primaryPictureUrl }))))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row p1" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "large-12 columns" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("ul", { className: "list-inline marginless newsfeed-lgfont" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__widgets_like_LikeComponent__["a" /* default */], { toggleLike: toggleLike, likable: style }),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null,
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { onClick: viewFeed },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("i", { className: "fa fa-comment-o fa-fw" }),
                            " ",
                            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__helpers_utils__["p" /* prettyPrintComment */])(style))))),
            style.description.trim().length > 0 &&
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "large-12 columns mt-1" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "word-wrap-break" }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__helpers_utils__["o" /* formatWithTags */])(style.description))))));
};
/* harmony default export */ __webpack_exports__["a"] = (ActivityFeedStyleItemComponent);


/***/ }),

/***/ "./app/client/activityFeeds/containers/ActivityFeedBoothItemContainer.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__("./node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data_selectors__ = __webpack_require__("./app/client/_data/selectors.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ActivityFeedBoothItemComponent__ = __webpack_require__("./app/client/activityFeeds/components/ActivityFeedBoothItemComponent.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_redux__ = __webpack_require__("./node_modules/react-router-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__routes__ = __webpack_require__("./app/client/routes.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shop_middlewares__ = __webpack_require__("./app/client/shop/middlewares.ts");






var mapStateToProps = function (state, props) {
    var booth = props.booth;
    return {
        shop: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__data_selectors__["g" /* shopByIdSelector */])(state, booth.shopId)
    };
};
var mapDispatchToProps = function (dispatch, props) {
    var booth = props.booth;
    return {
        viewBooth: function () {
            dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__shop_middlewares__["b" /* initializeShopProfile */])(booth.shopId));
            dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_router_redux__["d" /* push */])(__WEBPACK_IMPORTED_MODULE_4__routes__["d" /* ShopsRoutes */].viewBooth(booth.shopId, booth.id)));
        }
    };
};
var ActivityFeedBoothItemContainer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2__components_ActivityFeedBoothItemComponent__["a" /* default */]);
/* harmony default export */ __webpack_exports__["a"] = (ActivityFeedBoothItemContainer);


/***/ }),

/***/ "./app/client/activityFeeds/containers/ActivityFeedContainer.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__("./node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ActivityFeedComponent__ = __webpack_require__("./app/client/activityFeeds/components/ActivityFeedComponent.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__selectors__ = __webpack_require__("./app/client/activityFeeds/selectors.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__middlewares__ = __webpack_require__("./app/client/activityFeeds/middlewares.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__user_selectors__ = __webpack_require__("./app/client/user/selectors.ts");





var mapStateToProps = function (state, props) {
    var openModal = props.openModal, selectedFeedId = props.selectedFeedId;
    return {
        feeds: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__selectors__["a" /* feedsSelector */])(state).sortBy(function (f) { return f.id; }).reverse(),
        meta: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__selectors__["b" /* feedsMetaSelector */])(state),
        loading: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__selectors__["c" /* loadingFeedsSelector */])(state),
        openModal: openModal,
        selectedFeedId: selectedFeedId,
        currentUserID: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__user_selectors__["a" /* currentUserIdSelector */])(state)
    };
};
var mapDispatchToProps = function (dispatch) {
    return {
        loadMore: function (meta) {
            if (meta && meta.hasNext()) {
                dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__middlewares__["b" /* fetchFeeds */])(meta.cursor, meta.nextPage));
            }
        }
    };
};
var ActivityFeedContainer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__components_ActivityFeedComponent__["a" /* default */]);
/* harmony default export */ __webpack_exports__["a"] = (ActivityFeedContainer);


/***/ }),

/***/ "./app/client/activityFeeds/containers/ActivityFeedItemContainer.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__("./node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__routes__ = __webpack_require__("./app/client/routes.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ActivityFeedItemComponent__ = __webpack_require__("./app/client/activityFeeds/components/ActivityFeedItemComponent.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_redux__ = __webpack_require__("./node_modules/react-router-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__middlewares__ = __webpack_require__("./app/client/activityFeeds/middlewares.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__data_selectors__ = __webpack_require__("./app/client/_data/selectors.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__selectors__ = __webpack_require__("./app/client/activityFeeds/selectors.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__comment_actions__ = __webpack_require__("./app/client/comment/actions.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__data_models_Booth__ = __webpack_require__("./app/client/_data/models/Booth.ts");









var mapStateToProps = function (state, props) {
    var feed = props.feed;
    var model = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__selectors__["e" /* feedModelSelector */])(state, feed);
    var user;
    if (model instanceof __WEBPACK_IMPORTED_MODULE_8__data_models_Booth__["a" /* default */]) {
        var shop = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__data_selectors__["g" /* shopByIdSelector */])(state, model.shopId);
        user = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__data_selectors__["c" /* userByIdSelector */])(state, shop.userId);
    }
    else
        user = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__data_selectors__["c" /* userByIdSelector */])(state, model.userId);
    return {
        model: model,
        user: user
    };
};
var mapDispatchToProps = function (dispatch, props) {
    var feed = props.feed, currentUserID = props.currentUserID;
    return {
        viewFeed: function () {
            if (feed.resource == 'style') {
                dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__comment_actions__["a" /* clearComments */])());
                dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_router_redux__["d" /* push */])(__WEBPACK_IMPORTED_MODULE_1__routes__["b" /* FeedsRoutes */].preview(feed.id), { refresh: false }));
            }
        },
        toggleLike: function (e) {
            e.stopPropagation();
            if (!currentUserID)
                return window.location.replace(__WEBPACK_IMPORTED_MODULE_1__routes__["g" /* UsersRoutes */].sign_in());
            dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__middlewares__["c" /* toggleLikeFeed */])(feed));
        },
    };
};
var ActivityFeedItemContainer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2__components_ActivityFeedItemComponent__["a" /* default */]);
/* harmony default export */ __webpack_exports__["a"] = (ActivityFeedItemContainer);


/***/ }),

/***/ "./app/client/activityFeeds/containers/ActivityFeedModalContainer.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__("./node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modal_components_ActivityFeedModalComponent__ = __webpack_require__("./app/client/activityFeeds/modal/components/ActivityFeedModalComponent.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__selectors__ = __webpack_require__("./app/client/activityFeeds/selectors.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data_middlewares__ = __webpack_require__("./app/client/_data/middlewares.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__routes__ = __webpack_require__("./app/client/routes.ts");





var mapStateToProps = function (state, props) {
    var feed = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__selectors__["d" /* feedSelector */])(state, props.id);
    return {
        model: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__selectors__["e" /* feedModelSelector */])(state, feed)
    };
};
var mapDispatchToProps = function (dispatch, _a) {
    var currentUserID = _a.currentUserID;
    return {
        toggleLike: function (e, model) {
            e.stopPropagation();
            if (!currentUserID)
                return window.location.replace(__WEBPACK_IMPORTED_MODULE_4__routes__["g" /* UsersRoutes */].sign_in());
            dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__data_middlewares__["a" /* toggleLike */])(model));
        }
    };
};
var ActivityFeedModalContainer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__modal_components_ActivityFeedModalComponent__["a" /* default */]);
/* harmony default export */ __webpack_exports__["a"] = (ActivityFeedModalContainer);


/***/ }),

/***/ "./app/client/activityFeeds/containers/ActivityFeedSpecialItemContainer.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__("./node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_redux__ = __webpack_require__("./node_modules/react-router-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__routes__ = __webpack_require__("./app/client/routes.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ActivityFeedSpecialItemComponent__ = __webpack_require__("./app/client/activityFeeds/components/ActivityFeedSpecialItemComponent.tsx");




var mapStateToProps = function (state, props) {
    return {};
};
var mapDispatchToProps = function (dispatch, props) {
    var special = props.special;
    return {
        viewSpecial: function () {
            dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_router_redux__["d" /* push */])(__WEBPACK_IMPORTED_MODULE_2__routes__["e" /* SpecialsRoutes */].show(special.id)));
        }
    };
};
var ActivityFeedSpecialItemContainer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3__components_ActivityFeedSpecialItemComponent__["a" /* default */]);
/* harmony default export */ __webpack_exports__["a"] = (ActivityFeedSpecialItemContainer);


/***/ }),

/***/ "./app/client/activityFeeds/middlewares.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = initializeFeeds;
/* harmony export (immutable) */ __webpack_exports__["b"] = fetchFeeds;
/* harmony export (immutable) */ __webpack_exports__["c"] = toggleLikeFeed;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__("./app/client/activityFeeds/actions.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__repositories_feedRepository__ = __webpack_require__("./app/client/_repositories/feedRepository.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_actions__ = __webpack_require__("./app/client/_data/actions.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__("./node_modules/lodash/lodash.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__data_selectors__ = __webpack_require__("./app/client/_data/selectors.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__data_middlewares__ = __webpack_require__("./app/client/_data/middlewares.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__selectors__ = __webpack_require__("./app/client/activityFeeds/selectors.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router_redux__ = __webpack_require__("./node_modules/react-router-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__routes__ = __webpack_require__("./app/client/routes.ts");









function initializeFeeds(openModal, selectedFeedId) {
    return function (dispatch, getState) {
        if (openModal && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__selectors__["a" /* feedsSelector */])(getState()).get(selectedFeedId))
            dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react_router_redux__["d" /* push */])(__WEBPACK_IMPORTED_MODULE_8__routes__["b" /* FeedsRoutes */].index()));
        else
            dispatch(fetchFeeds());
    };
}
function fetchFeeds(cursor, page, perPage) {
    if (cursor === void 0) { cursor = null; }
    if (page === void 0) { page = null; }
    if (perPage === void 0) { perPage = 5; }
    return function (dispatch) {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__actions__["a" /* requestFeedsAction */])());
        __WEBPACK_IMPORTED_MODULE_1__repositories_feedRepository__["a" /* default */].get(cursor, page, perPage).then(function (data) {
            var feeds = data.feeds, meta = data.meta;
            __WEBPACK_IMPORTED_MODULE_3_lodash__["chain"](feeds)
                .groupBy(function (f) { return f.resource; })
                .map(function (value, key) {
                return { resource: key, value: value.map(function (v) { return v.resource_reference; }) };
            })
                .forEach(function (map) {
                dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__data_actions__["a" /* addDataAction */])({
                    resource: map.resource,
                    data: map.value
                }));
            }).value();
            return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__actions__["b" /* receiveFeedsAction */])({
                meta: meta,
                feeds: feeds
            }));
        });
    };
}
function toggleLikeFeed(feed) {
    return function (dispatch, getState) {
        var model = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__data_selectors__["f" /* dataByResourceNameSelector */])(getState(), feed.resource).get(feed.trackableId);
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__data_middlewares__["a" /* toggleLike */])(model));
    };
}


/***/ }),

/***/ "./app/client/activityFeeds/modal/components/ActivityFeedModalComponent.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/react.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__widgets_modal_ModalComponent__ = __webpack_require__("./app/client/_widgets/modal/ModalComponent.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_models_Style__ = __webpack_require__("./app/client/_data/models/Style.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_ModalStyleContainer__ = __webpack_require__("./app/client/activityFeeds/modal/containers/ModalStyleContainer.tsx");




function getModalContent(model, toggleLike) {
    var toggleLikeWrapper = function (e) {
        return toggleLike(e, model);
    };
    if (model instanceof __WEBPACK_IMPORTED_MODULE_2__data_models_Style__["a" /* default */])
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__containers_ModalStyleContainer__["a" /* default */], { style: model, toggleLike: toggleLikeWrapper });
}
var ActivityFeedModalComponent = function (props) {
    var history = props.history, model = props.model, toggleLike = props.toggleLike;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__widgets_modal_ModalComponent__["a" /* default */], { show: true, onExit: function () { return history.goBack(); }, size: __WEBPACK_IMPORTED_MODULE_1__widgets_modal_ModalComponent__["b" /* ModalSizes */].MEDIUMLARGE, className: "newsfeed-modal" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "newsfeed-panel callout paddingless marginless borderless", style: { maxWidth: '100%' } }, getModalContent(model, toggleLike))));
};
/* harmony default export */ __webpack_exports__["a"] = (ActivityFeedModalComponent);


/***/ }),

/***/ "./app/client/activityFeeds/modal/components/ModalStyleComponent.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/react.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_utils__ = __webpack_require__("./app/client/_helpers/utils.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__widgets_like_LikeComponent__ = __webpack_require__("./app/client/_widgets/like/LikeComponent.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__comment_containers_CommentsContainer__ = __webpack_require__("./app/client/comment/containers/CommentsContainer.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__widgets_user_UserRedirectContainer__ = __webpack_require__("./app/client/_widgets/user/UserRedirectContainer.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_data__ = __webpack_require__("./app/client/_helpers/data.ts");






var ModalStyleComponent = function (props) {
    var style = props.style, toggleLike = props.toggleLike, loadMoreComments = props.loadMoreComments, comments = props.comments;
    var user = style.user;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row", style: { margin: 0 } },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "large-8 medium-8 columns" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row p1" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "large-12 columns paddingless" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("ul", { className: "list-inline marginless" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null,
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__widgets_user_UserRedirectContainer__["a" /* default */], { id: user.id, element: "a" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: user.profilePicture(), className: "img-wrapper circle" }))),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null,
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__widgets_user_UserRedirectContainer__["a" /* default */], { id: user.id, element: "a" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h5", { className: "inline" }, user.username()))),
                        user.isProfessional &&
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", { className: "float-right" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__widgets_user_UserRedirectContainer__["a" /* default */], { className: "button mb-0", id: user.id, element: "a", type: __WEBPACK_IMPORTED_MODULE_5__helpers_data__["a" /* ResourceType */].message },
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("i", { className: "fa fa-envelope-o fa-fw" }),
                                    "\u00A0 Message"))))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row mb-1" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "large-12 columns" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "post-img v-align-center", style: { lineHeight: "30rem" } },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { "data-open": "postmodal", "aria-controls": "postmodal", id: "q36vqn-reveal", "aria-haspopup": "true", tabIndex: 0 },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: style.primaryPictureUrl, alt: "" })))))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "large-4 medium-4 columns bl-1" },
            style.description.trim().length > 0 &&
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row p1 bb-1" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "large-12 columns paddingless" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "mt-1 word-wrap-break" }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_utils__["o" /* formatWithTags */])(style.description)))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row bb-1" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "large-12 columns pt-half pb-half" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("ul", { className: "list-inline marginless newsfeed-rgfont" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__widgets_like_LikeComponent__["a" /* default */], { likable: style, toggleLike: toggleLike }),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null,
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("i", { className: "fa fa-comment-o fa-fw" }),
                            " ",
                            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_utils__["p" /* prettyPrintComment */])(style))))),
            (!comments.meta || (comments.meta && comments.items.length > 0)) &&
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__comment_containers_CommentsContainer__["a" /* default */], { items: comments, loadMoreComments: loadMoreComments }))));
};
/* harmony default export */ __webpack_exports__["a"] = (ModalStyleComponent);


/***/ }),

/***/ "./app/client/activityFeeds/modal/containers/ModalStyleContainer.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ModalStyleComponent__ = __webpack_require__("./app/client/activityFeeds/modal/components/ModalStyleComponent.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__("./node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__comment_middlewares__ = __webpack_require__("./app/client/comment/middlewares.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__selectors__ = __webpack_require__("./app/client/activityFeeds/selectors.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__data_selectors__ = __webpack_require__("./app/client/_data/selectors.ts");





var mapStateToProps = function (state, props) {
    var style = props.style;
    return {
        user: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__data_selectors__["c" /* userByIdSelector */])(state, style.userId),
        comments: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__selectors__["f" /* feedsCommentsSelector */])(state)
    };
};
var mapDispatchToProps = function (dispatch, props) {
    var style = props.style;
    return {
        loadMoreComments: function (meta) {
            if (!meta) {
                dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__comment_middlewares__["a" /* fetchCommentsByStyle */])(style.id, 1));
            }
            else if (meta && meta.hasNext()) {
                dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__comment_middlewares__["a" /* fetchCommentsByStyle */])(style.id, meta.nextPage));
            }
        }
    };
};
var ModalStyleContainer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_0__components_ModalStyleComponent__["a" /* default */]);
/* harmony default export */ __webpack_exports__["a"] = (ModalStyleContainer);


/***/ }),

/***/ "./app/client/activityFeeds/reducers.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export feeds */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_models_Meta__ = __webpack_require__("./app/client/_data/models/Meta.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__("./app/client/activityFeeds/actions.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_models_Feed__ = __webpack_require__("./app/client/_data/models/Feed.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__("./node_modules/redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_immutable__ = __webpack_require__("./node_modules/immutable/dist/immutable.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_class_transformer__ = __webpack_require__("./node_modules/class-transformer/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_class_transformer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_class_transformer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_utils__ = __webpack_require__("./app/client/_helpers/utils.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__comment_reducers__ = __webpack_require__("./app/client/comment/reducers.ts");








//reducers
var feeds = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux__["b" /* combineReducers */])({
    items: items,
    meta: meta,
    loading: loading,
    comments: __WEBPACK_IMPORTED_MODULE_7__comment_reducers__["a" /* default */]
});
/* harmony default export */ __webpack_exports__["a"] = (feeds);
function items(state, action) {
    if (state === void 0) { state = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_immutable__["Map"])(); }
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_1__actions__["c" /* clearFeedsAction */].toString():
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_immutable__["Map"])();
        case __WEBPACK_IMPORTED_MODULE_1__actions__["b" /* receiveFeedsAction */].toString():
            return state.mergeDeep(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__helpers_utils__["u" /* collectionToKeyValue */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_class_transformer__["plainToClass"])(__WEBPACK_IMPORTED_MODULE_2__data_models_Feed__["a" /* default */], action.payload.feeds)));
    }
    return state;
}
function meta(state, action) {
    if (state === void 0) { state = null; }
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_1__actions__["b" /* receiveFeedsAction */].toString():
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_class_transformer__["plainToClass"])(__WEBPACK_IMPORTED_MODULE_0__data_models_Meta__["a" /* default */], action.payload.meta);
    }
    return state;
}
function loading(state, action) {
    if (state === void 0) { state = false; }
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* requestFeedsAction */].toString():
            return true;
        case __WEBPACK_IMPORTED_MODULE_1__actions__["b" /* receiveFeedsAction */].toString():
            return false;
    }
    return state;
}


/***/ }),

/***/ "./app/client/activityFeeds/selectors.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return loadingFeedsSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return feedsSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return feedSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return feedModelSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return feedsMetaSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return feedsCommentsSelector; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect_src__ = __webpack_require__("./node_modules/reselect/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data_selectors__ = __webpack_require__("./app/client/_data/selectors.ts");


var loadingFeedsSelector = function (state) { return state.feeds.loading; };
var feedsSelector = function (state) { return state.feeds.items; };
var feedSelector = function (state, id) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_reselect_src__["a" /* createSelector */])(feedsSelector, function (feeds) { return feeds.get(id); })(state); };
var feedModelSelector = function (state, feed) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__data_selectors__["f" /* dataByResourceNameSelector */])(state, feed.resource).get(feed.trackableId);
};
var feedsMetaSelector = function (state) { return state.feeds.meta; };
var feedsCommentsSelector = function (state) { return state.feeds.comments; };


/***/ }),

/***/ "./app/client/booth/components/BoothFormComponent.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/react.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data_models_Booth__ = __webpack_require__("./app/client/_data/models/Booth.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__widgets_breadcrumbs_BreadcrumbsComponent__ = __webpack_require__("./app/client/_widgets/breadcrumbs/BreadcrumbsComponent.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__routes__ = __webpack_require__("./app/client/routes.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__("./node_modules/react-router-dom/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router__ = __webpack_require__("./node_modules/react-router/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_redux_form__ = __webpack_require__("./node_modules/redux-form/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash__ = __webpack_require__("./node_modules/lodash/lodash.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__widgets_form_InputComponent__ = __webpack_require__("./app/client/_widgets/form/InputComponent.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__widgets_form_validators__ = __webpack_require__("./app/client/_widgets/form/validators.ts");










function termOptions() {
    return __WEBPACK_IMPORTED_MODULE_7_lodash__["map"](__WEBPACK_IMPORTED_MODULE_1__data_models_Booth__["d" /* BoothTerms */], function (each) {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("option", { key: each, value: each }, each));
    });
}
var BoothForm = function (props) {
    var booth = props.booth, shop = props.shop, handleSubmit = props.handleSubmit, onSubmit = props.onSubmit, submitting = props.submitting;
    if (!booth || !shop) {
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_react_router__["b" /* Redirect */], { to: { pathname: __WEBPACK_IMPORTED_MODULE_3__routes__["d" /* ShopsRoutes */].index(), state: { refresh: true } } });
    }
    var pageTitle = booth.isNew() ? "New Booth for Rent" : booth.toString();
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row expanded" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__widgets_breadcrumbs_BreadcrumbsComponent__["a" /* default */], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["b" /* Link */], { to: __WEBPACK_IMPORTED_MODULE_3__routes__["d" /* ShopsRoutes */].index() }, "Shops")),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["b" /* Link */], { to: __WEBPACK_IMPORTED_MODULE_3__routes__["d" /* ShopsRoutes */].view(shop.id) }, shop.name)),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null, pageTitle))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row expanded" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "large-12 columns" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "text-group mt-1 mb-1" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h4", null, pageTitle),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "subheader" }, shop.toString())))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row expanded" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "large-12 columns" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "callout" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("form", { onSubmit: handleSubmit(onSubmit) },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_redux_form__["b" /* Field */], { name: "price", label: "Rent Amount ($)", component: __WEBPACK_IMPORTED_MODULE_8__widgets_form_InputComponent__["a" /* default */], type: "number", validate: [__WEBPACK_IMPORTED_MODULE_9__widgets_form_validators__["a" /* positive_number */]] }),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_redux_form__["b" /* Field */], { name: "workstationCount", label: "Booths Available", required: true, component: __WEBPACK_IMPORTED_MODULE_8__widgets_form_InputComponent__["a" /* default */], type: "number", validate: [__WEBPACK_IMPORTED_MODULE_9__widgets_form_validators__["a" /* positive_number */]] }),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "medium-6 columns" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("label", null,
                                    "Rate",
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "red label-text" }, "*"),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_redux_form__["b" /* Field */], { name: "terms", component: "select" }, termOptions())))),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "medium-6 columns" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("legend", null, "Payment Method"),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("fieldset", null,
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_redux_form__["b" /* Field */], { name: "isNegotiable", component: "input", type: "checkbox" }),
                                        " ",
                                        __WEBPACK_IMPORTED_MODULE_1__data_models_Booth__["e" /* BoothPaymentMethods */].NEGOTIABLE),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_redux_form__["b" /* Field */], { name: "isCommissioned", component: "input", type: "checkbox" }),
                                        " ",
                                        __WEBPACK_IMPORTED_MODULE_1__data_models_Booth__["e" /* BoothPaymentMethods */].COMMISSION)))),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "medium-6 columns" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "mt-1" },
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", { type: "submit", disabled: submitting, className: "button success" }, "Save Changes"),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["b" /* Link */], { className: "button link", to: __WEBPACK_IMPORTED_MODULE_3__routes__["d" /* ShopsRoutes */].view(shop.id) }, "Cancel"))))))))));
};
var BoothFormComponent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_redux_form__["c" /* reduxForm */])({
    form: 'profile_form'
})(BoothForm);
/* harmony default export */ __webpack_exports__["a"] = (BoothFormComponent);


/***/ }),

/***/ "./app/client/booth/components/BoothListItemComponent.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BoothListItemComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/react.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__routes__ = __webpack_require__("./app/client/routes.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__("./node_modules/react-router-dom/es/index.js");



var BoothListItemComponent = function (props) {
    var booth = props.booth, viewBooth = props.viewBooth;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "media-object" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "media-object-section flushed middle" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "img-wrapper small-img-fit" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: booth.imageable().primaryPictureUrl }))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "media-object-section middle" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "text-group" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null,
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("b", null, booth.toString())),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("small", { className: "subheader" },
                        booth.shop.toString(),
                        "\u00A0"),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("small", { className: "subheader" }, booth.shop.address())))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Link */], { to: __WEBPACK_IMPORTED_MODULE_1__routes__["d" /* ShopsRoutes */].viewBooth(booth.shopId, booth.id), className: "button primary pull-right" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("i", { className: "fa fa-eye-o" }),
            "\u00A0 View Booth")));
};
/* unused harmony default export */ var _unused_webpack_default_export = (BoothListItemComponent);


/***/ }),

/***/ "./app/client/booth/components/BoothProfileComponent.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BoothProfileComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/react.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__widgets_breadcrumbs_BreadcrumbsComponent__ = __webpack_require__("./app/client/_widgets/breadcrumbs/BreadcrumbsComponent.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__routes__ = __webpack_require__("./app/client/routes.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__("./node_modules/react-router-dom/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router__ = __webpack_require__("./node_modules/react-router/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__widgets_carousel_CarouselComponent__ = __webpack_require__("./app/client/_widgets/carousel/CarouselComponent.tsx");






var BoothProfileComponent = function (props) {
    var booth = props.booth, shop = props.shop;
    if (!booth) {
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_react_router__["b" /* Redirect */], { to: { pathname: __WEBPACK_IMPORTED_MODULE_2__routes__["d" /* ShopsRoutes */].index(), state: { refresh: true } } });
    }
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row expanded" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__widgets_breadcrumbs_BreadcrumbsComponent__["a" /* default */], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { href: "javascript: history.go(-1)" }, "Back")),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null, booth.toString()))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row expanded" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "large-12 columns" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "text-group mt-1 mb-1" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h4", null, booth.toString())))),
        booth.images.length > 0 &&
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row expanded" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "large-12 columns" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__widgets_carousel_CarouselComponent__["a" /* default */], { images: booth.images }))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "large-12 columns" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "flex-container" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "media-object" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "media-object-section logo middle" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "img-wrapper small-img-fit" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: shop.imageUrl() }))),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "media-object-section middle" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "h4" }, shop.toString()),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "subheader" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("small", null, shop.address())))),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["b" /* Link */], { to: __WEBPACK_IMPORTED_MODULE_2__routes__["d" /* ShopsRoutes */].view(shop.id), className: "button primary hollow small pull-right" }, "View Shop Profile")),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("ul", { className: "list-inline table justified" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", { className: "text-center" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "text-group" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h5", { className: "subheader" }, "Amount / Rate"),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", null,
                                "$",
                                booth.price,
                                " ",
                                booth.terms))),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", { className: "text-center" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "text-group" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h5", { className: "subheader" }, "Payment Method"),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", null, booth.paymentMethods().join(", ")))))))));
};


/***/ }),

/***/ "./app/client/booth/containers/AddBoothContainer.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__("./node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data_selectors__ = __webpack_require__("./app/client/_data/selectors.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_models_Booth__ = __webpack_require__("./app/client/_data/models/Booth.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_BoothFormComponent__ = __webpack_require__("./app/client/booth/components/BoothFormComponent.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__middlewares__ = __webpack_require__("./app/client/booth/middlewares.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_utils__ = __webpack_require__("./app/client/_helpers/utils.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__routes__ = __webpack_require__("./app/client/routes.ts");







var mapDispatchToProps = function (dispatch, props) {
    return {
        onSubmit: function (data) {
            return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__middlewares__["b" /* saveBooth */])(data, function (booth, errors) {
                if (errors && errors.length) {
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__helpers_utils__["r" /* toastError */])("Failed to add a new booth for rent.");
                }
                else {
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__helpers_utils__["k" /* toastSuccess */])("Successfully added a new booth for rent.");
                    props.history.push(__WEBPACK_IMPORTED_MODULE_6__routes__["d" /* ShopsRoutes */].viewBooth(booth.shopId, booth.id));
                }
            }));
        }
    };
};
var mapStateToProps = function (state, props) {
    var shop = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__data_selectors__["g" /* shopByIdSelector */])(state, parseInt(props.match.params.shopId));
    var booth = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__data_models_Booth__["c" /* initializeNewBoothShop */])(shop);
    return {
        booth: booth,
        shop: shop,
        initialValues: booth
    };
};
var AddBoothContainer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3__components_BoothFormComponent__["a" /* default */]);
/* harmony default export */ __webpack_exports__["a"] = (AddBoothContainer);


/***/ }),

/***/ "./app/client/booth/containers/BoothListItemContainer.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__("./node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_BoothListItemComponent__ = __webpack_require__("./app/client/booth/components/BoothListItemComponent.tsx");


var mapDispatchToProps = function (dispatch, props) {
    return {};
};
var mapStateToProps = function (state, props) {
    return {
        shop: props.shop
    };
};
var BoothListItemContainer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__components_BoothListItemComponent__["a" /* BoothListItemComponent */]);
/* harmony default export */ __webpack_exports__["a"] = (BoothListItemContainer);


/***/ }),

/***/ "./app/client/booth/containers/BoothProfileContainer.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__("./node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_BoothProfileComponent__ = __webpack_require__("./app/client/booth/components/BoothProfileComponent.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_selectors__ = __webpack_require__("./app/client/_data/selectors.ts");



var mapDispatchToProps = function (dispatch, props) {
    return {};
};
var mapStateToProps = function (state, props) {
    return {
        shop: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__data_selectors__["g" /* shopByIdSelector */])(state, parseInt(props.match.params.shopId)),
        booth: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__data_selectors__["k" /* boothByIdSelector */])(state, parseInt(props.match.params.boothId))
    };
};
var BoothProfileContainer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__components_BoothProfileComponent__["a" /* BoothProfileComponent */]);
/* harmony default export */ __webpack_exports__["a"] = (BoothProfileContainer);


/***/ }),

/***/ "./app/client/booth/middlewares.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchBoothsByShop; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return saveBooth; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shop_actions__ = __webpack_require__("./app/client/shop/actions.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__repositories_boothRepository__ = __webpack_require__("./app/client/_repositories/boothRepository.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_actions__ = __webpack_require__("./app/client/_data/actions.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable__ = __webpack_require__("./node_modules/immutable/dist/immutable.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__("./node_modules/lodash/lodash.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_data__ = __webpack_require__("./app/client/_helpers/data.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_class_transformer__ = __webpack_require__("./node_modules/class-transformer/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_class_transformer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_class_transformer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__data_models_Meta__ = __webpack_require__("./app/client/_data/models/Meta.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__data_models_Booth__ = __webpack_require__("./app/client/_data/models/Booth.ts");









var fetchBoothsByShop = function (shopId, cursor, page) {
    if (cursor === void 0) { cursor = null; }
    if (page === void 0) { page = null; }
    return function (dispatch) {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__shop_actions__["i" /* requestShopBooths */])());
        __WEBPACK_IMPORTED_MODULE_1__repositories_boothRepository__["a" /* default */].listByShop(shopId, cursor, page, 25)
            .then(function (data) {
            var booths = data.booths, meta = data.meta;
            if (data.error) {
                dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__shop_actions__["d" /* requestFailed */])({ requestErrors: ["Failed to retrieve shop booths."] }));
            }
            dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__data_actions__["a" /* addDataAction */])({
                resource: __WEBPACK_IMPORTED_MODULE_5__helpers_data__["a" /* ResourceType */].booth,
                data: booths
            }));
            var boothIds = __WEBPACK_IMPORTED_MODULE_4_lodash__["map"](booths, function (each) {
                return [each["id"], parseInt(each["id"])];
            });
            return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__shop_actions__["j" /* didReceiveShopBooths */])({
                ids: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"])(boothIds),
                meta: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_class_transformer__["plainToClass"])(__WEBPACK_IMPORTED_MODULE_7__data_models_Meta__["a" /* default */], meta)
            }));
        });
    };
};
var saveBooth = function (booth, cb) {
    return function (dispatch) {
        return __WEBPACK_IMPORTED_MODULE_1__repositories_boothRepository__["a" /* default */].saveBooth(booth)
            .then(function (data) {
            var errors = [];
            var booth = data.booth;
            dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__data_actions__["a" /* addDataAction */])({
                resource: __WEBPACK_IMPORTED_MODULE_5__helpers_data__["a" /* ResourceType */].booth,
                data: booth
            }));
            var boothId = [[booth.id, parseInt(booth["id"])]];
            dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__shop_actions__["k" /* didAddShopBooth */])({
                ids: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"])(boothId)
            }));
            cb(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_class_transformer__["plainToClass"])(__WEBPACK_IMPORTED_MODULE_8__data_models_Booth__["a" /* default */], booth), errors);
        });
    };
};


/***/ }),

/***/ "./app/client/booth/reducers.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return boothCollectionReducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__("./node_modules/redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shop_actions__ = __webpack_require__("./app/client/shop/actions.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__("./node_modules/immutable/dist/immutable.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);



var boothCollectionReducer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux__["b" /* combineReducers */])({
    ids: boothCollectionIds,
    meta: boothCollectionMeta,
    loading: boothCollectionIsLoading,
});
function boothCollectionIds(state, action) {
    if (state === void 0) { state = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])(); }
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_1__shop_actions__["j" /* didReceiveShopBooths */].toString():
            return state.mergeDeep(action.payload.ids);
        case __WEBPACK_IMPORTED_MODULE_1__shop_actions__["k" /* didAddShopBooth */].toString():
            return state.mergeDeep(action.payload.ids);
        case __WEBPACK_IMPORTED_MODULE_1__shop_actions__["b" /* clearShopProfile */].toString():
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])();
    }
    return state;
}
function boothCollectionMeta(state, action) {
    if (state === void 0) { state = null; }
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_1__shop_actions__["j" /* didReceiveShopBooths */].toString():
            return action.payload.meta;
    }
    return state;
}
function boothCollectionIsLoading(state, action) {
    if (state === void 0) { state = false; }
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_1__shop_actions__["i" /* requestShopBooths */].toString():
            return true;
        case __WEBPACK_IMPORTED_MODULE_1__shop_actions__["j" /* didReceiveShopBooths */].toString():
            return false;
    }
    return state;
}
/* unused harmony default export */ var _unused_webpack_default_export = (boothCollectionReducer);


/***/ }),

/***/ "./app/client/comment/actions.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return requestComments; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return receiveComments; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return clearComments; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__("./node_modules/redux-actions/es/index.js");

var requestComments = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_COMMENTS');
var receiveComments = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('RECEIVE_COMMENTS');
var clearComments = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('CLEAR_COMMENTS');


/***/ }),

/***/ "./app/client/comment/components/CommentItemComponent.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/react.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__("./node_modules/moment/moment.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__widgets_user_UserRedirectContainer__ = __webpack_require__("./app/client/_widgets/user/UserRedirectContainer.tsx");



var CommentItemComponent = function (props) {
    var comment = props.comment;
    if (!comment)
        return null;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "large-12 pb-half" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "large-2 medium-2 columns pr-half" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__widgets_user_UserRedirectContainer__["a" /* default */], { id: comment.user.id, element: "a" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: comment.user.profilePicture(), className: "img-wrapper circle" }))),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "large-10 medium-10 columns paddingless" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "marginless" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__widgets_user_UserRedirectContainer__["a" /* default */], { id: comment.user.id, element: "a", className: "inline" }, comment.user.username()),
                        " ",
                        comment.text),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("label", null, __WEBPACK_IMPORTED_MODULE_1_moment__(comment.createdAt).fromNow()))))));
};
/* harmony default export */ __webpack_exports__["a"] = (CommentItemComponent);


/***/ }),

/***/ "./app/client/comment/components/CommentsComponent.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/react.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__containers_CommentItemContainer__ = __webpack_require__("./app/client/comment/containers/CommentItemContainer.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__widgets_loadingIndicator_LoadingIndicatorComponent__ = __webpack_require__("./app/client/_widgets/loadingIndicator/LoadingIndicatorComponent.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_infinite_scroll__ = __webpack_require__("./node_modules/redux-infinite-scroll/lib/ReduxInfiniteScroll.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_infinite_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_redux_infinite_scroll__);




var CommentsComponent = function (props) {
    var comments = props.comments, loadMoreComments = props.loadMoreComments;
    var count = 0;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_redux_infinite_scroll___default.a, { className: 'row large-collapse comments p1', loadMore: function () { return loadMoreComments(comments.meta); }, elementIsScrollable: true, showLoader: true, loadingMore: comments.loading, loader: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__widgets_loadingIndicator_LoadingIndicatorComponent__["a" /* default */], null), threshold: 100 }, comments.items.map(function (comment) {
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__containers_CommentItemContainer__["a" /* default */], { comment: comment, key: count++ });
    })));
};
/* harmony default export */ __webpack_exports__["a"] = (CommentsComponent);


/***/ }),

/***/ "./app/client/comment/containers/CommentItemContainer.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__("./node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_CommentItemComponent__ = __webpack_require__("./app/client/comment/components/CommentItemComponent.tsx");


;
var mapStateToProps = function (state, props) {
    return {
        comment: props.comment
    };
};
var mapDispatchToProps = function (dispatch, ownProps) {
    return {
        dispatch: dispatch
    };
};
var CommentItemContainer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__components_CommentItemComponent__["a" /* default */]);
/* harmony default export */ __webpack_exports__["a"] = (CommentItemContainer);


/***/ }),

/***/ "./app/client/comment/containers/CommentsContainer.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__("./node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_CommentsComponent__ = __webpack_require__("./app/client/comment/components/CommentsComponent.tsx");


var mapStateToProps = function (state, props) {
    return {
        comments: props.items
    };
};
var mapDispatchToProps = function (dispatch, ownProps) {
    return {
        dispatch: dispatch
    };
};
var CommentsContainer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__components_CommentsComponent__["a" /* default */]);
/* harmony default export */ __webpack_exports__["a"] = (CommentsContainer);


/***/ }),

/***/ "./app/client/comment/middlewares.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = fetchCommentsByStyle;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__("./app/client/comment/actions.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__repositories_commentRepository__ = __webpack_require__("./app/client/_repositories/commentRepository.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_models_Comment__ = __webpack_require__("./app/client/_data/models/Comment.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_class_transformer__ = __webpack_require__("./node_modules/class-transformer/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_class_transformer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_class_transformer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__data_models_Meta__ = __webpack_require__("./app/client/_data/models/Meta.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__("./node_modules/lodash/lodash.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__data_actions__ = __webpack_require__("./app/client/_data/actions.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_data__ = __webpack_require__("./app/client/_helpers/data.ts");








function fetchCommentsByStyle(id, page, perPage) {
    if (perPage === void 0) { perPage = 5; }
    return function (dispatch, getState) {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__actions__["b" /* requestComments */])());
        __WEBPACK_IMPORTED_MODULE_1__repositories_commentRepository__["a" /* default */].getByStyleId2(id, page, perPage).then(function (data) {
            var comments = data.comments, meta = data.meta;
            var users = __WEBPACK_IMPORTED_MODULE_5_lodash__["map"](comments, function (each) {
                return each['user'];
            });
            dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__data_actions__["a" /* addDataAction */])({
                resource: __WEBPACK_IMPORTED_MODULE_7__helpers_data__["a" /* ResourceType */].user,
                data: users
            }));
            return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__actions__["c" /* receiveComments */])({
                meta: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_class_transformer__["plainToClass"])(__WEBPACK_IMPORTED_MODULE_4__data_models_Meta__["a" /* default */], meta),
                comments: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_class_transformer__["plainToClass"])(__WEBPACK_IMPORTED_MODULE_2__data_models_Comment__["a" /* default */], comments)
            }));
        });
    };
}


/***/ }),

/***/ "./app/client/comment/reducers.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export commentsReducer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__("./app/client/comment/actions.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__("./node_modules/redux/es/index.js");


var commentsReducer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux__["b" /* combineReducers */])({
    items: items,
    meta: meta,
    loading: loading
});
/* harmony default export */ __webpack_exports__["a"] = (commentsReducer);
function items(state, action) {
    if (state === void 0) { state = []; }
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* clearComments */].toString():
            return [];
        case __WEBPACK_IMPORTED_MODULE_0__actions__["c" /* receiveComments */].toString():
            return state.concat(action.payload.comments);
    }
    return state;
}
function meta(state, action) {
    if (state === void 0) { state = null; }
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* clearComments */].toString():
            return null;
        case __WEBPACK_IMPORTED_MODULE_0__actions__["c" /* receiveComments */].toString():
            return action.payload.meta;
    }
    return state;
}
function loading(state, action) {
    if (state === void 0) { state = false; }
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0__actions__["b" /* requestComments */].toString():
            return true;
        case __WEBPACK_IMPORTED_MODULE_0__actions__["c" /* receiveComments */].toString():
            return false;
    }
    return state;
}


/***/ }),

/***/ "./app/client/dashboard/components/ContentComponent.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/react.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__("./node_modules/react-router-dom/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__search_containers_SearchBarContainer__ = __webpack_require__("./app/client/search/containers/SearchBarContainer.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__("./node_modules/classnames/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_utils__ = __webpack_require__("./app/client/_helpers/utils.tsx");





var ContentComponent = function (props) {
    var children = props.children;
    var classes = __WEBPACK_IMPORTED_MODULE_3_classnames__("dashboard-main", { "off-canvas-content": __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__helpers_utils__["b" /* currentUserIsLoggedIn */])() });
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: classes, "data-off-canvas-content": true },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "title-bar hidden", "data-responsive-toggle": "widemenu", "data-hide-for": "medium" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "title-bar-left" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", { className: "menu-icon", type: "button", "data-open": "offCanvasLeft" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "title-bar-right" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { href: "register-stylist.html", className: "button primary small" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("i", { className: "fa fa-certificate fa-fw" }),
                    "Become A Stylist"),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */], { to: "/" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("i", { className: "fa fa-sign-out fa-fw" }),
                    " Sign Out"))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__search_containers_SearchBarContainer__["a" /* default */], null),
        children));
};
/* harmony default export */ __webpack_exports__["a"] = (ContentComponent);


/***/ }),

/***/ "./app/client/dashboard/components/DashboardComponent.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/react.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__containers_SidebarContainer__ = __webpack_require__("./app/client/dashboard/containers/SidebarContainer.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ContentComponent__ = __webpack_require__("./app/client/dashboard/components/ContentComponent.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_utils__ = __webpack_require__("./app/client/_helpers/utils.tsx");




var DashboardComponent = function (props) {
    var children = props.children;
    var stickyDownload;
    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__helpers_utils__["b" /* currentUserIsLoggedIn */])())
        stickyDownload = (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row panel", style: { border: 'none' } },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "large-12 medium-12 columns" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "stick-download p1 text-center" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "marginless" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h5", { className: "text-white inline v-align-center" }, "Download the Styleteq App and gain access to the best Grooming Professionals near you & beyond."),
                        " ",
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("br", { className: "breaking br2" })),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { href: "https://itunes.apple.com/us/app/styleteq/id1155975962?ls=1&mt=8" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: window.Styleteq.images.applePlay, className: "inline mr-1 ml-1 store" })),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { href: "https://play.google.com/store/apps/details?id=com.styleteq.app" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: window.Styleteq.images.googlePlay, className: "inline store" }))))));
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__helpers_utils__["b" /* currentUserIsLoggedIn */])() ? 'off-canvas-wrapper public-view' : 'off-canvas-wrapper' },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { id: "mainDashboard", className: "off-canvas-wrapper-inner" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__containers_SidebarContainer__["a" /* default */], null),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__ContentComponent__["a" /* default */], { children: children }))),
        stickyDownload));
};
/* harmony default export */ __webpack_exports__["a"] = (DashboardComponent);


/***/ }),

/***/ "./app/client/dashboard/components/RouterComponent.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/react.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__("./node_modules/react-router-dom/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__("./node_modules/react-router/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_api__ = __webpack_require__("./app/client/_helpers/api.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style_containers_MyStylesContainer__ = __webpack_require__("./app/client/style/containers/MyStylesContainer.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__special_containers_SpecialsContainer__ = __webpack_require__("./app/client/special/containers/SpecialsContainer.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__special_containers_SpecialItemContainer__ = __webpack_require__("./app/client/special/containers/SpecialItemContainer.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__activityFeeds_containers_ActivityFeedContainer__ = __webpack_require__("./app/client/activityFeeds/containers/ActivityFeedContainer.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__routes__ = __webpack_require__("./app/client/routes.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__style_middlewares__ = __webpack_require__("./app/client/style/middlewares.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__comment_middlewares__ = __webpack_require__("./app/client/comment/middlewares.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__special_middlewares__ = __webpack_require__("./app/client/special/middlewares.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__shop_container_ShopListContainer__ = __webpack_require__("./app/client/shop/container/ShopListContainer.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__user_middlewares__ = __webpack_require__("./app/client/user/middlewares.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__user_container_MyProfileContainer__ = __webpack_require__("./app/client/user/container/MyProfileContainer.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__style_containers_StyleContainer__ = __webpack_require__("./app/client/style/containers/StyleContainer.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__shop_container_ShopViewContainer__ = __webpack_require__("./app/client/shop/container/ShopViewContainer.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__booth_containers_BoothProfileContainer__ = __webpack_require__("./app/client/booth/containers/BoothProfileContainer.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__search_containers_SearchContainer__ = __webpack_require__("./app/client/search/containers/SearchContainer.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__search_middlewares__ = __webpack_require__("./app/client/search/middlewares.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__booth_containers_AddBoothContainer__ = __webpack_require__("./app/client/booth/containers/AddBoothContainer.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__activityFeeds_middlewares__ = __webpack_require__("./app/client/activityFeeds/middlewares.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_query_string__ = __webpack_require__("./node_modules/query-string/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__helpers_utils__ = __webpack_require__("./app/client/_helpers/utils.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__message_containers_ConversationsContainer__ = __webpack_require__("./app/client/message/containers/ConversationsContainer.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__message_containers_MessagesContainer__ = __webpack_require__("./app/client/message/containers/MessagesContainer.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__message_middlewares__ = __webpack_require__("./app/client/message/middlewares.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__shop_middlewares__ = __webpack_require__("./app/client/shop/middlewares.ts");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};




























var RouterComponent = (function (_super) {
    __extends(RouterComponent, _super);
    function RouterComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.refresh = true;
        _this.rendered = false;
        return _this;
    }
    RouterComponent.prototype.componentWillReceiveProps = function (nextProps) {
        var history = nextProps.history, location = nextProps.location;
        this.pop = history.action == 'POP';
        if (location.state)
            this.refresh = location.state.refresh === true || (history.action != 'POP' && location.state.refresh !== false);
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__helpers_utils__["a" /* toggleBodyScroll */])(true);
    };
    RouterComponent.prototype.renderUser = function (id, props) {
        this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__user_middlewares__["a" /* fetchUser */])(id));
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14__user_container_MyProfileContainer__["a" /* default */], __assign({}, props));
    };
    RouterComponent.prototype.saveScrollPosition = function (cb) {
        this.scrollEventHandler = function () {
            cb(window.pageYOffset);
        };
        window.addEventListener('scroll', this.scrollEventHandler, true);
    };
    RouterComponent.prototype.render = function () {
        var _this = this;
        var _a = this.props, dispatch = _a.dispatch, initialized = _a.initialized, location = _a.location;
        if (__WEBPACK_IMPORTED_MODULE_8__routes__["a" /* StylesRoutes */].index() != location.pathname) {
            window.removeEventListener('scroll', this.scrollEventHandler, true);
        }
        else {
            this.saveScrollPosition(function (scrollPosition) {
                dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__style_middlewares__["a" /* saveScrollPosition */])(scrollPosition));
            });
        }
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* Route */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_3__helpers_api__["a" /* Api */].baseUrl, render: function () {
                    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__helpers_utils__["b" /* currentUserIsLoggedIn */])())
                        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_router__["b" /* Redirect */], { to: __WEBPACK_IMPORTED_MODULE_8__routes__["b" /* FeedsRoutes */].index() });
                    else
                        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_router__["b" /* Redirect */], { to: __WEBPACK_IMPORTED_MODULE_8__routes__["c" /* SearchRoutes */].index() });
                } }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* Route */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_8__routes__["a" /* StylesRoutes */].index(), render: function (props) {
                    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__style_middlewares__["b" /* initializeStyles */])());
                    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__style_containers_MyStylesContainer__["a" /* default */], __assign({}, props));
                } }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* Route */], { exact: true, path: '/:username/styles/:id', render: function (props) {
                    var style_id = props.match.params.id;
                    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__style_middlewares__["c" /* initializeStyle */])(style_id));
                    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__comment_middlewares__["a" /* fetchCommentsByStyle */])(style_id, 1, 10));
                    _this.rendered = true;
                    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_15__style_containers_StyleContainer__["a" /* default */], __assign({}, props));
                } }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* Route */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_8__routes__["d" /* ShopsRoutes */].index(), render: function (props) {
                    if (_this.refresh) {
                        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_27__shop_middlewares__["a" /* refreshShops */])());
                    }
                    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__shop_container_ShopListContainer__["a" /* default */], __assign({}, props));
                } }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* Route */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_8__routes__["d" /* ShopsRoutes */].addBooth(), render: function (props) {
                    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_20__booth_containers_AddBoothContainer__["a" /* default */], __assign({}, props));
                } }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* Route */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_8__routes__["d" /* ShopsRoutes */].viewBooth(), render: function (props) {
                    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_17__booth_containers_BoothProfileContainer__["a" /* default */], __assign({}, props));
                } }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* Route */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_8__routes__["d" /* ShopsRoutes */].view(), render: function (props) {
                    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_16__shop_container_ShopViewContainer__["a" /* default */], __assign({}, props));
                } }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* Route */], { path: __WEBPACK_IMPORTED_MODULE_8__routes__["b" /* FeedsRoutes */].index(), render: function (props) {
                    var query = __WEBPACK_IMPORTED_MODULE_22_query_string__["parse"](props.location.search);
                    var openModal = query.modal;
                    var selectedFeedId = parseInt(query.feedId);
                    if (!_this.pop)
                        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__activityFeeds_middlewares__["a" /* initializeFeeds */])(openModal, selectedFeedId));
                    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__activityFeeds_containers_ActivityFeedContainer__["a" /* default */], __assign({}, props, { openModal: openModal, selectedFeedId: selectedFeedId }));
                } }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* Route */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_8__routes__["e" /* SpecialsRoutes */].index(), render: function (props) {
                    if (_this.refresh)
                        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__special_middlewares__["a" /* initializeSpecials */])());
                    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__special_containers_SpecialsContainer__["a" /* default */], __assign({}, props));
                } }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* Route */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_8__routes__["e" /* SpecialsRoutes */].index() + '/type/:type', render: function (props) {
                    var type = props.match.params.type;
                    if (_this.refresh)
                        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__special_middlewares__["b" /* initializeSpecialsType */])(type));
                    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__special_containers_SpecialsContainer__["a" /* default */], __assign({}, props));
                    // let special_id = props.match.params.id;
                    // dispatch(initializeSpecial(special_id));                    
                    // return <SpecialItemContainer {...props}/>;
                } }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* Route */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_8__routes__["e" /* SpecialsRoutes */].index() + '/:id', render: function (props) {
                    var special_id = props.match.params.id;
                    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__special_middlewares__["c" /* initializeSpecial */])(special_id));
                    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__special_containers_SpecialItemContainer__["a" /* default */], __assign({}, props));
                } }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* Route */], { exact: true, path: '/:str', render: function (props) {
                    return _this.renderUser(props.match.params.str, props);
                } }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* Route */], { exact: true, path: '/:str/followers', render: function (props) {
                    if (!_this.rendered)
                        return _this.renderUser(props.match.params.str, props);
                    _this.rendered = false;
                    return null;
                } }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* Route */], { exact: true, path: '/:str/following', render: function (props) {
                    if (!_this.rendered)
                        return _this.renderUser(props.match.params.str, props);
                    _this.rendered = false;
                    return null;
                } }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* Route */], { path: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__helpers_utils__["c" /* to_url */])(__WEBPACK_IMPORTED_MODULE_3__helpers_api__["a" /* Api */].baseUrl, 'users', ':id'), render: function (props) {
                    return _this.renderUser(props.match.params.id, props);
                } }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* Route */], { path: __WEBPACK_IMPORTED_MODULE_8__routes__["c" /* SearchRoutes */].index(), render: function (props) {
                    if (!_this.pop)
                        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__search_middlewares__["a" /* searchFromUrl */])(props.location.search));
                    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_18__search_containers_SearchContainer__["a" /* default */], __assign({}, props));
                } }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* Route */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_8__routes__["f" /* ConversationsRoutes */].index(), render: function (props) {
                    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_24__message_containers_ConversationsContainer__["a" /* default */], __assign({}, props));
                } }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* Route */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_8__routes__["f" /* ConversationsRoutes */].index() + '/:id/messages', render: function (props) {
                    var conversationId = props.match.params.id;
                    if (!_this.pop)
                        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26__message_middlewares__["b" /* initializeConversation */])(conversationId));
                    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_25__message_containers_MessagesContainer__["a" /* default */], __assign({}, props));
                } }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* Route */], { path: __WEBPACK_IMPORTED_MODULE_8__routes__["f" /* ConversationsRoutes */].index() + '/new', render: function (props) {
                    var query = __WEBPACK_IMPORTED_MODULE_22_query_string__["parse"](props.location.search);
                    var recipientId = parseInt(query.user_id);
                    if (!_this.pop)
                        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26__message_middlewares__["c" /* initializeNewConversation */])(recipientId));
                    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_25__message_containers_MessagesContainer__["a" /* default */], __assign({}, props));
                } })));
    };
    return RouterComponent;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (RouterComponent);


/***/ }),

/***/ "./app/client/dashboard/components/SidebarComponent.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/react.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__("./node_modules/react-router-dom/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__routes__ = __webpack_require__("./app/client/routes.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_api__ = __webpack_require__("./app/client/_helpers/api.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__widgets_sidebarLink_LinkContainer__ = __webpack_require__("./app/client/_widgets/sidebarLink/LinkContainer.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__widgets_user_UserRedirectContainer__ = __webpack_require__("./app/client/_widgets/user/UserRedirectContainer.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__("./node_modules/classnames/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);







var SidebarComponent = function (props) {
    var currentUser = props.currentUser, unreadMessageCount = props.unreadMessageCount;
    var form;
    var classes = __WEBPACK_IMPORTED_MODULE_6_classnames__("off-canvas reveal-for-medium position-left", { "hidden": currentUser == null });
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: classes, id: "offCanvasLeft", "data-off-canvas": true },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("ul", { className: "vertical dropdown menu dashboard-menu", "data-dropdown-menu": true },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "dashboard-menu-text text-center" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "logo" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */], { to: __WEBPACK_IMPORTED_MODULE_3__helpers_api__["a" /* Api */].baseUrl },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: window.Styleteq.images.logoWhite, alt: "Styleteq Logo" })))),
            currentUser &&
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", { className: "profile" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__widgets_user_UserRedirectContainer__["a" /* default */], { id: currentUser.id, element: "a" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: currentUser.profilePicture(), className: "img-wrapper circle" }),
                        "\u00A0",
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null, currentUser.username()),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("small", null, "View Profile"))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__widgets_sidebarLink_LinkContainer__["a" /* default */], { to: __WEBPACK_IMPORTED_MODULE_2__routes__["b" /* FeedsRoutes */].index() },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("i", { className: "fa fa-newspaper-o fa-fw" }),
                " Activity"),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__widgets_sidebarLink_LinkContainer__["a" /* default */], { to: __WEBPACK_IMPORTED_MODULE_2__routes__["c" /* SearchRoutes */].index() },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("i", { className: "fa fa-search fa-fw" }),
                " Search"),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "dashboard-menu-title" }, "ACCOUNT"),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__widgets_sidebarLink_LinkContainer__["a" /* default */], { to: __WEBPACK_IMPORTED_MODULE_2__routes__["f" /* ConversationsRoutes */].index() },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("i", { className: "fa fa-envelope-o fa-fw" }),
                " My Messages",
                unreadMessageCount > 0 &&
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "button__badge ml-1" },
                        unreadMessageCount,
                        " New")),
            currentUser && currentUser.isProfessional &&
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__widgets_sidebarLink_LinkContainer__["a" /* default */], { to: __WEBPACK_IMPORTED_MODULE_2__routes__["d" /* ShopsRoutes */].index() },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("i", { className: "fa fa-scissors fa-fw" }),
                    " My Shops"),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__widgets_sidebarLink_LinkContainer__["a" /* default */], { to: __WEBPACK_IMPORTED_MODULE_2__routes__["a" /* StylesRoutes */].index() },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("i", { className: "fa fa-camera-retro fa-fw" }),
                " My Images"),
            currentUser && currentUser.isProfessional &&
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__widgets_sidebarLink_LinkContainer__["a" /* default */], { to: __WEBPACK_IMPORTED_MODULE_2__routes__["e" /* SpecialsRoutes */].index() },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("i", { className: "fa fa-star fa-fw" }),
                    " My Specials"),
            currentUser &&
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", { className: "footer" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { onClick: function () { return form.submit(); } },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("i", { className: "fa fa-sign-out fa-fw" }),
                        " Sign Out"),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("form", { action: "/v1/users/sign_out", method: "post", ref: function (e) { return form = e; } },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("input", { type: "hidden", name: "_method", value: "delete" }))))));
};
/* harmony default export */ __webpack_exports__["a"] = (SidebarComponent);


/***/ }),

/***/ "./app/client/dashboard/containers/RouterContainer.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__("./node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_RouterComponent__ = __webpack_require__("./app/client/dashboard/components/RouterComponent.tsx");


var mapStateToProps = function (state) {
    return {};
};
var mapDispatchToProps = function (dispatch) {
    return {
        dispatch: dispatch,
    };
};
var RouterContainer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__components_RouterComponent__["a" /* default */]);
/* harmony default export */ __webpack_exports__["a"] = (RouterContainer);


/***/ }),

/***/ "./app/client/dashboard/containers/SidebarContainer.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__("./node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_SidebarComponent__ = __webpack_require__("./app/client/dashboard/components/SidebarComponent.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_selectors__ = __webpack_require__("./app/client/_data/selectors.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__user_selectors__ = __webpack_require__("./app/client/user/selectors.ts");




var mapStateToProps = function (state) {
    return {
        currentUser: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__user_selectors__["b" /* currentUserSelector */])(state),
        unreadMessageCount: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__data_selectors__["p" /* conversationsSelector */])(state).filter(function (c) { return c.unreadCount > 0; }).count()
    };
};
var mapDispatchToProps = function (dispatch) {
    return {
        dispatch: dispatch
    };
};
var SidebarContainer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__components_SidebarComponent__["a" /* default */]);
/* harmony default export */ __webpack_exports__["a"] = (SidebarContainer);


/***/ }),

/***/ "./app/client/message/actions.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return requestConversationsAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return receiveConversationsAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return clearConversationsAction; });
/* unused harmony export requestMessagesAction */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return receiveMessagesAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return clearMessagesAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return sendMessageAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return composeMessageAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return requestFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return requestStarted; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return requestSucceeded; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__("./node_modules/redux-actions/es/index.js");

var requestConversationsAction = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('REQUEST_CONVERSATIONS_ACTION');
var receiveConversationsAction = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('RECEIVE_CONVERSATIONS_ACTION');
var clearConversationsAction = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('CLEAR_CONVERSATIONS_ACTION');
var requestMessagesAction = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('REQUEST_MESSAGES_ACTION');
var receiveMessagesAction = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('RECEIVE_MESSAGES_ACTION');
var clearMessagesAction = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('CLEAR_MESSAGES_ACTION');
var sendMessageAction = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('SEND_MESSAGE_ACTION');
var composeMessageAction = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('COMPOSE_MESSAGE_ACTION');
var requestFailed = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])("REQUEST_FAILED");
var requestStarted = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])("REQUEST_STARTED");
var requestSucceeded = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])("REQUEST_SUCCEEDED");


/***/ }),

/***/ "./app/client/message/components/ConversationComponent.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/react.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__("./node_modules/classnames/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__("./node_modules/moment/moment.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);



var ConversationComponent = function (props) {
    var conversation = props.conversation, recipient = props.recipient, lastMessage = props.lastMessage, viewConversation = props.viewConversation;
    var classes = __WEBPACK_IMPORTED_MODULE_1_classnames__({ 'active': conversation.unreadCount > 0 });
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("tr", { className: classes, onClick: viewConversation },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("td", null, recipient.username()),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("td", { className: "truncate" }, lastMessage.content),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("td", null, __WEBPACK_IMPORTED_MODULE_2_moment__(lastMessage.createdAt).fromNow()),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("td", null)));
};
/* harmony default export */ __webpack_exports__["a"] = (ConversationComponent);


/***/ }),

/***/ "./app/client/message/components/ConversationsComponent.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/react.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__containers_ConversationContainer__ = __webpack_require__("./app/client/message/containers/ConversationContainer.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_infinite_scroll__ = __webpack_require__("./node_modules/redux-infinite-scroll/lib/ReduxInfiniteScroll.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_infinite_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_redux_infinite_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__widgets_loadingIndicator_LoadingIndicatorComponent__ = __webpack_require__("./app/client/_widgets/loadingIndicator/LoadingIndicatorComponent.tsx");




var ConversationsComponent = function (props) {
    var conversations = props.conversations, loadMore = props.loadMore, meta = props.meta, loading = props.loading;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row expanded" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "medium-6 column" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("nav", { "aria-label": "You are here:", role: "navigation", className: "mt-1 mb-1" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("ul", { className: "breadcrumbs" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null, "All Messages")))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "medium-6 column" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "search-box mt-half mb-half" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "pull-right search-box" })))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row expanded" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "medium-12 column" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "panel" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("table", { className: "single-line" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("thead", null,
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("tr", null,
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("th", null, "From: / To:"),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("th", null, "Message"),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("th", null, "Date Received"))),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_redux_infinite_scroll___default.a, { holderType: "tbody", loadMore: function () { return loadMore(meta); }, elementIsScrollable: false, loadingMore: loading, loader: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("tr", null,
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("td", { colSpan: 3 },
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__widgets_loadingIndicator_LoadingIndicatorComponent__["a" /* default */], null))), threshold: 200 }, conversations.map(function (c) {
                            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__containers_ConversationContainer__["a" /* default */], { conversation: c, key: c.id });
                        }))))))));
};
/* harmony default export */ __webpack_exports__["a"] = (ConversationsComponent);


/***/ }),

/***/ "./app/client/message/components/MessagesComponent.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/react.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data_selectors__ = __webpack_require__("./app/client/_data/selectors.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__("./node_modules/moment/moment.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_utils__ = __webpack_require__("./app/client/_helpers/utils.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__routes__ = __webpack_require__("./app/client/routes.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_dom__ = __webpack_require__("./node_modules/react-router-dom/es/index.js");







var timer = 0;
var shouldScrollToBottom = true;
var shouldScrollDown = false;
var perPage = 10;
var loadMoreMessagesWhenScrollingUp = function (callback, meta) {
    document.onscroll = function () {
        if (window.pageYOffset <= 100) {
            var messagesElemContainer = document.getElementsByClassName('in-messages');
            if (messagesElemContainer.length > 0 && meta.totalCount > perPage) {
                var messagesElem = messagesElemContainer[0].childNodes;
                var elemToScroll = messagesElem[perPage];
                if (elemToScroll !== undefined) {
                    if ((messagesElem.length + 1) < meta.totalCount)
                        elemToScroll.scrollIntoView({ behavior: 'smooth' });
                }
                else {
                    messagesElem[1].scrollIntoView({ behavior: 'smooth' });
                }
            }
            callback();
            shouldScrollToBottom = false;
        }
    };
};
var scrollToBottom = function () {
    window.scrollTo(0, document.body.scrollHeight);
};
var handleOnKeyPress = function (e, props) {
    props.composeMessage(e.target.value);
};
var handleOnSubmit = function (e, props) {
    e.preventDefault();
    props.sendMessage();
    var textArea = e.target.querySelectorAll('textarea')[0];
    textArea.value = "";
    textArea.focus();
    shouldScrollToBottom = true;
};
var MessagesComponent = function (props) {
    var messages = props.messages, loadMore = props.loadMore, meta = props.meta, loading = props.loading, state = props.state, recipient = props.recipient, conversation = props.conversation;
    loadMoreMessagesWhenScrollingUp(function () {
        if (!loading && (!meta || meta && meta.hasNext())) {
            loadMore(conversation.id, meta);
        }
    }, meta);
    var messagesList;
    var count = 0;
    if (messages.length > 0) {
        messagesList = (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "in-messages profile" }, messages.map(function (m, i) {
            if (m.senderId) {
                var sender = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__data_selectors__["c" /* userByIdSelector */])(state, m.senderId);
                var hr = (i > 0 ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("hr", { className: "marginless bb-1" }) : null);
                //                        console.log(sender);                            
                return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { key: count++ },
                    hr,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: sender.id == __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__helpers_utils__["f" /* getCurrentUser */])().id ? 'row p1 mr-0 ml-0 reply' : 'row p1 mr-0 ml-0' },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "large-12 column mb-1  small-img-fit" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: sender.profilePictureUrl, className: "img-wrapper circle mr-half" }),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_react_router_dom__["b" /* Link */], { to: __WEBPACK_IMPORTED_MODULE_4__routes__["g" /* UsersRoutes */].index() + "/" + sender.id }, sender.username()),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("label", { className: "pull-right mt-half" }, __WEBPACK_IMPORTED_MODULE_2_moment__(m.createdAt).fromNow())),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "large-12 column" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "mb-0" }, m.content)))));
            }
        })));
    }
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { onLoad: function () {
            if (meta == null || meta.currentPage == 1 || shouldScrollToBottom)
                scrollToBottom();
        } },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "medium-6 column" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("nav", { "aria-label": "You are here:", role: "navigation", className: "mt-1 mb-1" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("ul", { className: "breadcrumbs" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null,
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_react_router_dom__["b" /* Link */], { to: __WEBPACK_IMPORTED_MODULE_4__routes__["f" /* ConversationsRoutes */].index() }, "All Messages")),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null, recipient.fullName)))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "medium-6 column" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "search-box mt-half mb-half" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "pull-right search-box" })))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "medium-12 column" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "panel" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "p1 bb-1 disable" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h4", null, "Sed ut perspiciatis")),
                    messagesList,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row p1 mr-0 ml-0 stick-bottom bt-1" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("form", { onSubmit: function (e) { return handleOnSubmit(e, props); } },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "large-10 medium-10 small-9 column" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("label", null, "Reply"),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("textarea", { rows: 2, onKeyUp: function (e) { return handleOnKeyPress(e, props); } })),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "large-2 medium-2 small-3 column send v-align-center" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", { type: "submit", className: "mb-0 button middle p1" }, "Send")))))))));
};
/* harmony default export */ __webpack_exports__["a"] = (MessagesComponent);


/***/ }),

/***/ "./app/client/message/containers/ConversationContainer.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__("./node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ConversationComponent__ = __webpack_require__("./app/client/message/components/ConversationComponent.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_redux__ = __webpack_require__("./node_modules/react-router-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__routes__ = __webpack_require__("./app/client/routes.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_utils__ = __webpack_require__("./app/client/_helpers/utils.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__data_selectors__ = __webpack_require__("./app/client/_data/selectors.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__middlewares__ = __webpack_require__("./app/client/message/middlewares.ts");







var mapStateToProps = function (state, props) {
    var conversation = props.conversation;
    var recipientId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__helpers_utils__["f" /* getCurrentUser */])().id != conversation.userId1 ? conversation.userId1 : conversation.userId2;
    var recipient = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__data_selectors__["c" /* userByIdSelector */])(state, recipientId);
    var lastMessage = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__data_selectors__["e" /* messageByIdSelector */])(state, conversation.lastMessageId);
    return {
        recipient: recipient,
        lastMessage: lastMessage
    };
};
var mapDispatchToProps = function (dispatch, props) {
    var conversation = props.conversation;
    return {
        viewConversation: function () {
            dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__middlewares__["f" /* readMessage */])(conversation.id));
            dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_router_redux__["d" /* push */])(__WEBPACK_IMPORTED_MODULE_3__routes__["f" /* ConversationsRoutes */].messages(conversation.id)));
        }
    };
};
var ConversationContainer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__components_ConversationComponent__["a" /* default */]);
/* harmony default export */ __webpack_exports__["a"] = (ConversationContainer);


/***/ }),

/***/ "./app/client/message/containers/ConversationsContainer.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__("./node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ConversationsComponent__ = __webpack_require__("./app/client/message/components/ConversationsComponent.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__selectors__ = __webpack_require__("./app/client/message/selectors.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data_selectors__ = __webpack_require__("./app/client/_data/selectors.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__middlewares__ = __webpack_require__("./app/client/message/middlewares.ts");





var mapStateToProps = function (state, props) {
    var _a = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__selectors__["b" /* inboxSelector */])(state), ids = _a.ids, meta = _a.meta, loading = _a.loading;
    var conversations = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__data_selectors__["d" /* conversationByIdsSelector */])(state, ids);
    return {
        conversations: conversations,
        meta: meta,
        loading: loading
    };
};
var mapDispatchToProps = function (dispatch, props) {
    return {
        loadMore: function (meta) {
            if (meta && meta.hasNext()) {
                dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__middlewares__["a" /* fetchConversations */])(meta.nextPage));
            }
        }
    };
};
var ConversationsContainer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__components_ConversationsComponent__["a" /* default */]);
/* harmony default export */ __webpack_exports__["a"] = (ConversationsContainer);


/***/ }),

/***/ "./app/client/message/containers/MessagesContainer.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__("./node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_MessagesComponent__ = __webpack_require__("./app/client/message/components/MessagesComponent.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__selectors__ = __webpack_require__("./app/client/message/selectors.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data_selectors__ = __webpack_require__("./app/client/_data/selectors.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__data_models_User__ = __webpack_require__("./app/client/_data/models/User.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__middlewares__ = __webpack_require__("./app/client/message/middlewares.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions__ = __webpack_require__("./app/client/message/actions.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_utils__ = __webpack_require__("./app/client/_helpers/utils.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_query_string__ = __webpack_require__("./node_modules/query-string/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_query_string__);










var mapStateToProps = function (state, props) {
    var _a = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__selectors__["a" /* messagesSelector */])(state), ids = _a.ids, meta = _a.meta, loading = _a.loading;
    var messages = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__data_selectors__["b" /* messageByIdsSelector */])(state, ids).sort(function (a, b) { return a.createdAt > b.createdAt ? 1 : -1; });
    var recipient = new __WEBPACK_IMPORTED_MODULE_4__data_models_User__["a" /* default */];
    var conversation = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__data_selectors__["a" /* conversationByIdSelector */])(state, parseInt(props.match.params.id));
    if (conversation) {
        var recipientId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__helpers_utils__["f" /* getCurrentUser */])().id != conversation.userId1 ? conversation.userId1 : conversation.userId2;
        recipient = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__data_selectors__["c" /* userByIdSelector */])(state, recipientId);
    }
    else {
        var query = __WEBPACK_IMPORTED_MODULE_8_query_string__["parse"](props.location.search);
        var recipientId = query.user_id;
        var newRecipient = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__data_selectors__["c" /* userByIdSelector */])(state, parseInt(recipientId));
        recipient = newRecipient ? newRecipient : recipient;
        if (messages.length) {
            conversation = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__data_selectors__["a" /* conversationByIdSelector */])(state, messages[0].conversationId);
        }
    }
    return {
        state: state,
        messages: messages,
        meta: meta,
        loading: loading,
        recipient: recipient,
        conversation: conversation
    };
};
var mapDispatchToProps = function (dispatch, props) {
    return {
        loadMore: function (conversationId, meta) {
            if (meta && meta.hasNext()) {
                dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__middlewares__["d" /* fetchMessagesBy */])(conversationId, meta.nextPage));
            }
        },
        sendMessage: function () {
            dispatch(function (dispatch, getState) {
                var composedMessage = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__selectors__["a" /* messagesSelector */])(getState()).composedMessage;
                var query = __WEBPACK_IMPORTED_MODULE_8_query_string__["parse"](props.location.search);
                var recipientId;
                var conversationId;
                var isNew;
                if (query.user_id) {
                    recipientId = query.user_id;
                    conversationId = null;
                    isNew = true;
                }
                else {
                    var conversation = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__data_selectors__["a" /* conversationByIdSelector */])(getState(), parseInt(props.match.params.id));
                    conversationId = conversation.id;
                    recipientId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__helpers_utils__["f" /* getCurrentUser */])().id != conversation.userId1 ? conversation.userId1 : conversation.userId2;
                    isNew = false;
                }
                if (composedMessage != "")
                    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__middlewares__["e" /* sendMessage */])(recipientId, conversationId, composedMessage, isNew));
            });
        },
        composeMessage: function (message) {
            dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actions__["h" /* composeMessageAction */])(message));
        }
    };
};
var MessagesContainer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__components_MessagesComponent__["a" /* default */]);
/* harmony default export */ __webpack_exports__["a"] = (MessagesContainer);


/***/ }),

/***/ "./app/client/message/middlewares.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = initializeConversation;
/* harmony export (immutable) */ __webpack_exports__["c"] = initializeNewConversation;
/* harmony export (immutable) */ __webpack_exports__["a"] = fetchConversations;
/* unused harmony export fetchMessagesByRecipient */
/* harmony export (immutable) */ __webpack_exports__["d"] = fetchMessagesBy;
/* harmony export (immutable) */ __webpack_exports__["e"] = sendMessage;
/* harmony export (immutable) */ __webpack_exports__["f"] = readMessage;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__("./app/client/message/actions.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__repositories_conversationRepository__ = __webpack_require__("./app/client/_repositories/conversationRepository.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_data__ = __webpack_require__("./app/client/_helpers/data.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data_actions__ = __webpack_require__("./app/client/_data/actions.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__("./node_modules/lodash/lodash.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__user_middlewares__ = __webpack_require__("./app/client/user/middlewares.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__selectors__ = __webpack_require__("./app/client/message/selectors.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__data_selectors__ = __webpack_require__("./app/client/_data/selectors.ts");
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};








function initializeConversation(conversationId) {
    return function (dispatch, getState) {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__actions__["a" /* clearMessagesAction */])());
        dispatch(fetchMessagesBy(conversationId));
    };
}
function initializeNewConversation(recipientId) {
    return function (dispatch, getState) {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__actions__["a" /* clearMessagesAction */])());
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__user_middlewares__["a" /* fetchUser */])(recipientId));
        dispatch(fetchMessagesByRecipient(recipientId));
    };
}
function fetchConversations(page) {
    if (page === void 0) { page = 1; }
    return function (dispatch, getState) {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__actions__["b" /* requestConversationsAction */])());
        __WEBPACK_IMPORTED_MODULE_1__repositories_conversationRepository__["a" /* default */].get(page).then(function (data) {
            var conversations = data.conversations, meta = data.meta;
            var _conversations = __WEBPACK_IMPORTED_MODULE_4_lodash__["chain"](conversations).map(function (c) {
                return __assign({}, c, { userId1: c.user1.id, userId2: c.user2.id, lastMessageId: c.last_message.id });
            }).value();
            dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__data_actions__["a" /* addDataAction */])({
                resource: __WEBPACK_IMPORTED_MODULE_2__helpers_data__["a" /* ResourceType */].conversation,
                data: _conversations
            }));
            dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__actions__["c" /* receiveConversationsAction */])({
                meta: meta,
                conversationIds: conversations.map(function (c) { return c.id; })
            }));
        });
    };
}
function fetchMessagesByRecipient(recipientId, page, perPage) {
    if (page === void 0) { page = 1; }
    if (perPage === void 0) { perPage = 5; }
    return function (dispatch, getState) {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__actions__["d" /* requestStarted */])());
        __WEBPACK_IMPORTED_MODULE_1__repositories_conversationRepository__["a" /* default */].getMessagesByRecipientId(recipientId, page, perPage).then(function (data) {
            var messages = data.messages, meta = data.meta;
            console.log(messages);
            console.log('hi');
            var _messages = __WEBPACK_IMPORTED_MODULE_4_lodash__["chain"](messages.reverse()).map(function (m) {
                return __assign({}, m, { senderId: m.sender.id });
            }).value();
            dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__data_actions__["a" /* addDataAction */])({
                resource: __WEBPACK_IMPORTED_MODULE_2__helpers_data__["a" /* ResourceType */].message,
                data: _messages
            }));
            dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__actions__["e" /* receiveMessagesAction */])({
                meta: meta,
                messageIds: messages.map(function (m) { return m.id; })
            }));
            return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__actions__["f" /* requestSucceeded */])());
        });
    };
}
function fetchMessagesBy(conversationId, page, perPage) {
    if (page === void 0) { page = 1; }
    if (perPage === void 0) { perPage = 10; }
    return function (dispatch, getState) {
        // const conversations = dataByResourceNameSelector(getState(), ResourceType.conversation);
        // if(conversations.toArray().length == 0) {
        //     dispatch(fetchConversations());
        // }
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__actions__["d" /* requestStarted */])());
        __WEBPACK_IMPORTED_MODULE_1__repositories_conversationRepository__["a" /* default */].getMessages(conversationId, page, perPage).then(function (data) {
            var messages = data.messages, meta = data.meta;
            var _messages = __WEBPACK_IMPORTED_MODULE_4_lodash__["chain"](messages).map(function (m) {
                return __assign({}, m, { senderId: m.sender.id });
            }).value();
            dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__data_actions__["a" /* addDataAction */])({
                resource: __WEBPACK_IMPORTED_MODULE_2__helpers_data__["a" /* ResourceType */].message,
                data: _messages
            }));
            dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__actions__["e" /* receiveMessagesAction */])({
                meta: meta,
                messageIds: messages.map(function (m) { return m.id; })
            }));
            return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__actions__["f" /* requestSucceeded */])());
        });
    };
}
function sendMessage(userId, conversationId, content, isNew) {
    if (isNew === void 0) { isNew = false; }
    return function (dispatch, getState) {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__actions__["d" /* requestStarted */])());
        __WEBPACK_IMPORTED_MODULE_1__repositories_conversationRepository__["a" /* default */].sendMessage(userId, conversationId, content, isNew).then(function (data) {
            var message = data.message, meta = data.meta;
            // dispatch(initializeConversation(conversationId));
            var ids = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__selectors__["a" /* messagesSelector */])(getState()).ids;
            console.log(ids);
            var _message = __assign({}, message, { senderId: message.sender.id });
            dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__data_actions__["a" /* addDataAction */])({
                resource: __WEBPACK_IMPORTED_MODULE_2__helpers_data__["a" /* ResourceType */].message,
                data: [_message]
            }));
            dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__actions__["e" /* receiveMessagesAction */])({
                messageIds: [message.id]
            }));
            dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__actions__["f" /* requestSucceeded */])());
        });
    };
}
function readMessage(conversationId) {
    return function (dispatch, getState) {
        __WEBPACK_IMPORTED_MODULE_1__repositories_conversationRepository__["a" /* default */].readMessage(conversationId).then(function (data) {
            if (data.error) {
                return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__actions__["g" /* requestFailed */])({ requestErrors: ["Failed to read the message"] }));
            }
        });
        var conversation = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__data_selectors__["a" /* conversationByIdSelector */])(getState(), conversationId);
        var _conversation = __assign({}, conversation, { unreadCount: 0 });
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__data_actions__["a" /* addDataAction */])({
            resource: __WEBPACK_IMPORTED_MODULE_2__helpers_data__["a" /* ResourceType */].conversation,
            data: [_conversation]
        }));
    };
}


/***/ }),

/***/ "./app/client/message/reducers.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return conversations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return messages; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_models_Meta__ = __webpack_require__("./app/client/_data/models/Meta.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__("./app/client/message/actions.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__("./node_modules/redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_class_transformer__ = __webpack_require__("./node_modules/class-transformer/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_class_transformer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_class_transformer__);




//CONVERSATIONS
var conversations = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_redux__["b" /* combineReducers */])({
    ids: conversationIds,
    loading: conversationLoading,
    meta: conversationMeta
});
function conversationIds(state, action) {
    if (state === void 0) { state = []; }
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_1__actions__["c" /* receiveConversationsAction */].toString():
            return state.concat(action.payload.conversationIds);
        case __WEBPACK_IMPORTED_MODULE_1__actions__["i" /* clearConversationsAction */].toString():
            return [];
    }
    return state;
}
function conversationLoading(state, action) {
    if (state === void 0) { state = false; }
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_1__actions__["b" /* requestConversationsAction */].toString():
            return true;
        case __WEBPACK_IMPORTED_MODULE_1__actions__["c" /* receiveConversationsAction */].toString():
            return false;
    }
    return state;
}
function conversationMeta(state, action) {
    if (state === void 0) { state = null; }
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_1__actions__["c" /* receiveConversationsAction */].toString():
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_class_transformer__["plainToClass"])(__WEBPACK_IMPORTED_MODULE_0__data_models_Meta__["a" /* default */], action.payload.meta);
        case __WEBPACK_IMPORTED_MODULE_1__actions__["i" /* clearConversationsAction */].toString():
            return null;
    }
    return state;
}
//MESSAGES
var messages = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_redux__["b" /* combineReducers */])({
    ids: messageIds,
    loading: messageLoading,
    meta: messageMeta,
    composedMessage: composedMessage
});
function messageIds(state, action) {
    if (state === void 0) { state = []; }
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_1__actions__["e" /* receiveMessagesAction */].toString():
        case __WEBPACK_IMPORTED_MODULE_1__actions__["j" /* sendMessageAction */].toString():
            return state.concat(action.payload.messageIds);
        case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* clearMessagesAction */].toString():
            return [];
    }
    return state;
}
function messageLoading(state, action) {
    if (state === void 0) { state = false; }
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_1__actions__["d" /* requestStarted */].toString():
            return true;
        case __WEBPACK_IMPORTED_MODULE_1__actions__["f" /* requestSucceeded */].toString():
            return false;
    }
    return state;
}
function messageMeta(state, action) {
    if (state === void 0) { state = null; }
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_1__actions__["e" /* receiveMessagesAction */].toString():
            if (action.payload.meta)
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_class_transformer__["plainToClass"])(__WEBPACK_IMPORTED_MODULE_0__data_models_Meta__["a" /* default */], action.payload.meta);
            else
                return state;
        case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* clearMessagesAction */].toString():
            return null;
    }
    return state;
}
function errors(state, action) {
    if (state === void 0) { state = []; }
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_1__actions__["d" /* requestStarted */].toString():
            return [];
        case __WEBPACK_IMPORTED_MODULE_1__actions__["f" /* requestSucceeded */].toString():
            return [];
        case __WEBPACK_IMPORTED_MODULE_1__actions__["g" /* requestFailed */].toString():
            return action.payload.requestErrors;
    }
    return state;
}
function composedMessage(state, action) {
    if (state === void 0) { state = ""; }
    if (action.type == __WEBPACK_IMPORTED_MODULE_1__actions__["h" /* composeMessageAction */].toString()) {
        return action.payload;
    }
    return state;
}


/***/ }),

/***/ "./app/client/message/selectors.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return inboxSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return messagesSelector; });
var inboxSelector = function (state) { return state.conversations; };
var messagesSelector = function (state) { return state.messages; };


/***/ }),

/***/ "./app/client/routes.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return UsersRoutes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ShopsRoutes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StylesRoutes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SpecialsRoutes; });
/* unused harmony export BoothsRoutes */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FeedsRoutes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SearchRoutes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return ConversationsRoutes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_api__ = __webpack_require__("./app/client/_helpers/api.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_utils__ = __webpack_require__("./app/client/_helpers/utils.tsx");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var UsersRoutes = (function (_super) {
    __extends(UsersRoutes, _super);
    function UsersRoutes() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UsersRoutes.root = function () {
        return 'users';
    };
    UsersRoutes.short_url = function (str) {
        return '/' + str;
    };
    UsersRoutes.edit_profile = function (id) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_utils__["c" /* to_url */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_utils__["g" /* getSiteUrl */])(), 'v1', 'users', id, 'edit');
    };
    UsersRoutes.following = function (id) {
        if (id === void 0) { id = null; }
        if (typeof id === 'number')
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_utils__["c" /* to_url */])(this.index(), id, 'following');
        else if (typeof id === 'string')
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_utils__["c" /* to_url */])(id, 'following');
    };
    UsersRoutes.followers = function (id) {
        if (id === void 0) { id = null; }
        if (typeof id === 'number')
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_utils__["c" /* to_url */])(this.index(), id, 'followers');
        else if (typeof id === 'string')
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_utils__["c" /* to_url */])(id, 'followers');
    };
    UsersRoutes.sign_in = function () {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_utils__["c" /* to_url */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_utils__["g" /* getSiteUrl */])(), 'v1', 'users', 'sign_in');
    };
    return UsersRoutes;
}(__WEBPACK_IMPORTED_MODULE_0__helpers_api__["c" /* default */]));

var ShopsRoutes = (function (_super) {
    __extends(ShopsRoutes, _super);
    function ShopsRoutes() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ShopsRoutes.root = function () {
        return 'shops';
    };
    ShopsRoutes.view = function (id) {
        if (id === void 0) { id = -1; }
        var _id = id == -1 ? ':shopId' : id;
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_utils__["c" /* to_url */])(this.index(), _id);
    };
    ShopsRoutes.viewBooth = function (shopId, boothId) {
        if (shopId === void 0) { shopId = -1; }
        if (boothId === void 0) { boothId = -1; }
        var _id = boothId == -1 ? ':boothId' : boothId;
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_utils__["c" /* to_url */])(this.view(shopId), "booths", _id);
    };
    ShopsRoutes.addBooth = function (shopId) {
        if (shopId === void 0) { shopId = -1; }
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_utils__["c" /* to_url */])(this.view(shopId), "add-booths");
    };
    ShopsRoutes.editBooth = function (booth) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_utils__["c" /* to_url */])(this.index(), booth.shop.id, "booths", booth.id, "edit");
    };
    return ShopsRoutes;
}(__WEBPACK_IMPORTED_MODULE_0__helpers_api__["c" /* default */]));

var StylesRoutes = (function (_super) {
    __extends(StylesRoutes, _super);
    function StylesRoutes() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    StylesRoutes.root = function () {
        return 'styles';
    };
    StylesRoutes.showStyle = function (username, styleId) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_utils__["c" /* to_url */])("/" + username, 'styles', styleId);
    };
    return StylesRoutes;
}(__WEBPACK_IMPORTED_MODULE_0__helpers_api__["c" /* default */]));

var SpecialsRoutes = (function (_super) {
    __extends(SpecialsRoutes, _super);
    function SpecialsRoutes() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SpecialsRoutes.root = function () {
        return 'specials';
    };
    SpecialsRoutes.view = function (id) {
        if (id === void 0) { id = -1; }
        var _id = id == -1 ? ':id' : id;
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_utils__["c" /* to_url */])(this.index(), _id);
    };
    SpecialsRoutes.tab = function (type) {
        if (type === void 0) { type = null; }
        var _type = type == null ? ':type' : type;
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_utils__["c" /* to_url */])(this.index(), 'type', _type);
    };
    return SpecialsRoutes;
}(__WEBPACK_IMPORTED_MODULE_0__helpers_api__["c" /* default */]));

var BoothsRoutes = (function (_super) {
    __extends(BoothsRoutes, _super);
    function BoothsRoutes() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BoothsRoutes.root = function () {
        return 'booths';
    };
    return BoothsRoutes;
}(__WEBPACK_IMPORTED_MODULE_0__helpers_api__["c" /* default */]));

var FeedsRoutes = (function (_super) {
    __extends(FeedsRoutes, _super);
    function FeedsRoutes() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FeedsRoutes.root = function () {
        return 'feeds';
    };
    FeedsRoutes.preview = function (id) {
        if (id === void 0) { id = -1; }
        var _id = id == -1 ? ':id' : id;
        return this.index() + ("?modal=true&feedId=" + _id);
    };
    return FeedsRoutes;
}(__WEBPACK_IMPORTED_MODULE_0__helpers_api__["d" /* SimpleRoute */]));

var SearchRoutes = (function (_super) {
    __extends(SearchRoutes, _super);
    function SearchRoutes() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SearchRoutes.root = function () {
        return 'search';
    };
    SearchRoutes.query = function (q, geo, typeFilter, secondaryFilters, page, perPage) {
        if (perPage === void 0) { perPage = 25; }
        return this.index() + this.queryUrl(q, geo, typeFilter, secondaryFilters, page, perPage);
    };
    SearchRoutes.queryUrl = function (q, geo, typeFilter, secondaryFilters, page, perPage) {
        if (perPage === void 0) { perPage = 25; }
        var query = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_utils__["d" /* createQueryParameters */])({
            q: q,
            'geo[address]': geo ? geo.address : null,
            'geo[latitude]': geo ? geo.latitude : null,
            'geo[longitude]': geo ? geo.longitude : null,
            resource: typeFilter,
            'filter': secondaryFilters,
            page: page,
            per_page: perPage
        });
        return query;
    };
    return SearchRoutes;
}(__WEBPACK_IMPORTED_MODULE_0__helpers_api__["d" /* SimpleRoute */]));

var ConversationsRoutes = (function (_super) {
    __extends(ConversationsRoutes, _super);
    function ConversationsRoutes() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ConversationsRoutes.root = function () {
        return 'inbox';
    };
    ConversationsRoutes.messages = function (id) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_utils__["c" /* to_url */])(this.index(), id, 'messages');
    };
    ConversationsRoutes.new = function (id) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_utils__["c" /* to_url */])(this.index(), 'new') + ("?user_id=" + id);
    };
    return ConversationsRoutes;
}(__WEBPACK_IMPORTED_MODULE_0__helpers_api__["d" /* SimpleRoute */]));



/***/ }),

/***/ "./app/client/search/actions.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return toggleSearchFiltersAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return setSearchFilterTypeAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return setSearchSecondaryFilterAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return addSearchSecondaryFilterAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return removeSearchSecondaryFilterAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return clearSearchSecondaryFilterAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return clearSearchFiltersAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return setSearchQueryAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return setSearchLocationAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return setSearchGeoLocationAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return setSearchView; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return setSearchNoResultsFound; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return incrementSearchTrendingCategoriesCount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return resetSearchTrendingCategoriesCount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return requestSearchItemsAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return receiveSearchItemsAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return clearSearchItemsAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return requestSearchGeoLocationAction; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__("./node_modules/redux-actions/es/index.js");

//Filter Actions
var toggleSearchFiltersAction = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('TOGGLE_SEARCH_FILTERS');
var setSearchFilterTypeAction = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('SET_SEARCH_FILTER_TYPE');
var setSearchSecondaryFilterAction = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('SET_SEARCH_SECONDARY_FILTER');
var addSearchSecondaryFilterAction = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('ADD_SEARCH_SECONDARY_FILTER');
var removeSearchSecondaryFilterAction = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('REMOVE_SEARCH_SECONDARY_FILTER');
var clearSearchSecondaryFilterAction = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('CLEAR_SEARCH_SECONDARY_FILTER');
var clearSearchFiltersAction = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('CLEAR_SEARCH_FILTERS');
//Query Actions
var setSearchQueryAction = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('SET_SEARCH_QUERY');
var setSearchLocationAction = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('SET_SEARCH_LOCATION');
var setSearchGeoLocationAction = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('SET_SEARCH_GEO_LOCATION');
var setSearchView = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('SET_SEARCH_VIEW');
var setSearchNoResultsFound = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('SET_SEARCH_NO_RESULTS_FOUND');
//Trending Actions
var incrementSearchTrendingCategoriesCount = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('INCREMENT_SEARCH_TRENDING_CATEGORIES_COUNT');
var resetSearchTrendingCategoriesCount = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('CLEAR_SEARCH_TRENDING_CATEGORIES_COUNT');
//Result Actions
var requestSearchItemsAction = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('REQUEST_SEARCH_ITEMS');
var receiveSearchItemsAction = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('RECEIVE_SEARCH_ITEMS');
var clearSearchItemsAction = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('CLEAR_SEARCH_ITEMS');
var requestSearchGeoLocationAction = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('REQUEST_SEARCH_GEO_LOCATION_ACTION');


/***/ }),

/***/ "./app/client/search/components/SearchBarComponent.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/react.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__containers_SearchFiltersContainer__ = __webpack_require__("./app/client/search/containers/SearchFiltersContainer.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_utils__ = __webpack_require__("./app/client/_helpers/utils.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__routes__ = __webpack_require__("./app/client/routes.ts");




var SearchBarComponent = function (props) {
    var query = props.query, location = props.location, toggleFilter = props.toggleFilter, filtersEnabled = props.filtersEnabled, changeQuery = props.changeQuery, changeLocation = props.changeLocation, search = props.search, clear = props.clear;
    // let loginButton;
    // if(notLoggedIn)
    //     loginButton = (
    //         <li className="btn-login">
    //             <a href={UsersRoutes.sign_in()} className="primary">
    //                 <i className="fa fa-user" aria-hidden="true"></i> &nbsp;Login
    //             </a>
    //         </li>
    //     );
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { id: "widemenu", className: "top-bar" },
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__helpers_utils__["b" /* currentUserIsLoggedIn */])() ?
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "top-bar-title" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null,
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", { id: "hamburger", className: "menu-icon dark mr-1", type: "button" }))) : '',
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "top-bar-left" }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__helpers_utils__["b" /* currentUserIsLoggedIn */])()
                ?
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("ul", { className: "search menu" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null,
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("input", { type: "text", placeholder: "Enter keyword", onChange: changeQuery, value: query, onKeyPress: function (e) { return e.key === 'Enter' && search(); } })),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null,
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("input", { type: "text", placeholder: "Enter location", onChange: changeLocation, value: location, onKeyPress: function (e) { return e.key === 'Enter' && search(); } })),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null,
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { className: "button primary expanded", onClick: search },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("i", { className: "fa fa-search" }),
                                " \u00A0Search")),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null,
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { className: "button primary hollow expanded", onClick: toggleFilter },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("i", { className: "fa fa-filter" }),
                                " \u00A0Filters")),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null,
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { onClick: clear }, "Clear Filters")))
                :
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("ul", { className: "search menu" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", { className: "btn-login" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { href: __WEBPACK_IMPORTED_MODULE_3__routes__["g" /* UsersRoutes */].sign_in(), className: "primary" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("i", { className: "fa fa-user", "aria-hidden": "true" }),
                                " \u00A0Login"))))),
        filtersEnabled && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__containers_SearchFiltersContainer__["a" /* default */], null)));
};
/* harmony default export */ __webpack_exports__["a"] = (SearchBarComponent);


/***/ }),

/***/ "./app/client/search/components/SearchComponent.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/react.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducers__ = __webpack_require__("./app/client/search/reducers.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_SearchTrendingContainer__ = __webpack_require__("./app/client/search/containers/SearchTrendingContainer.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__widgets_loadingIndicator_LoadingIndicatorComponent__ = __webpack_require__("./app/client/_widgets/loadingIndicator/LoadingIndicatorComponent.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__containers_SearchResultContainer__ = __webpack_require__("./app/client/search/containers/SearchResultContainer.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux_infinite_scroll__ = __webpack_require__("./node_modules/redux-infinite-scroll/lib/ReduxInfiniteScroll.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux_infinite_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_redux_infinite_scroll__);






var SearchComponent = function (props) {
    var loading = props.loading, loadingMessage = props.loadingMessage, results = props.results, view = props.view, noResultsFound = props.noResultsFound, meta = props.meta, loadMore = props.loadMore;
    if (loading)
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__widgets_loadingIndicator_LoadingIndicatorComponent__["a" /* default */], { message: loadingMessage })));
    if (view == __WEBPACK_IMPORTED_MODULE_1__reducers__["b" /* SearchView */].TRENDING)
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            noResultsFound &&
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "large-12 columns" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null, "No results found for this location. Try again or check out these suggestions."))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__containers_SearchTrendingContainer__["a" /* default */], { results: results })));
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_redux_infinite_scroll___default.a, { holderType: "ul", className: "list-block flex-container", loadMore: function () { return loadMore(meta); }, elementIsScrollable: false, loadingMore: loading, loader: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__widgets_loadingIndicator_LoadingIndicatorComponent__["a" /* default */], null), threshold: 200 }, results.toArray().map(function (r) {
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__containers_SearchResultContainer__["a" /* default */], { result: r, key: r.id });
        }))));
};
/* harmony default export */ __webpack_exports__["a"] = (SearchComponent);


/***/ }),

/***/ "./app/client/search/components/SearchFiltersComponent.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return professionalFilter; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/react.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__("./node_modules/lodash/lodash.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};


var typeFiltersWithoutBooth = {
    style: 'Images',
    salon: 'Shops',
    user: 'Users',
    special: 'Specials'
};
var typeFilters = __assign({}, typeFiltersWithoutBooth, { booth: 'Booths For Rent' });
var imageFilters = {
    professional: 'From Professionals',
    user: 'From Users'
};
var shopFilters = [
    'Barbershop',
    'Salon',
    'Unisex',
    'Spa',
    'Nails',
    'Tattoo'
];
var professionalFilter = [
    'Non Professional',
    'Barber',
    'Hairstylist',
    'Nail Technician',
    'Esthetician',
    'Make Up Artist',
    'Tattoo Artist',
    'Other'
];
var SearchFiltersComponent = function (props) {
    var selectedType = props.selectedType, secondaryFilters = props.secondaryFilters, changeFilterType = props.changeFilterType, toggleSecondaryFilter = props.toggleSecondaryFilter, currentUser = props.currentUser;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { id: "searchFilters", className: "row p1", style: { display: 'block' } },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("fieldset", { className: "large-6 columns" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("legend", null, "Filter Your Search"),
            Object.keys(currentUser && currentUser.isProfessional ? typeFilters : typeFiltersWithoutBooth).map(function (t) {
                return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { key: t },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("input", { type: "radio", checked: selectedType == t, onClick: function () { return changeFilterType(t); } }),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("label", null, typeFilters[t])));
            })),
        __WEBPACK_IMPORTED_MODULE_1_lodash__["includes"](['style', 'salon', 'user'], selectedType) &&
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("fieldset", { className: "large-6 columns" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("legend", null, "Check these out"),
                selectedType == 'style' && Object.keys(imageFilters).map(function (f) {
                    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](CheckBoxFilter, { label: imageFilters[f], value: f, currentFilters: secondaryFilters, onChange: toggleSecondaryFilter, key: f });
                }),
                selectedType == 'salon' && shopFilters.map(function (f) {
                    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](CheckBoxFilter, { label: f, value: f, currentFilters: secondaryFilters, onChange: toggleSecondaryFilter, key: f });
                }),
                selectedType == 'user' && professionalFilter.map(function (f) {
                    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](CheckBoxFilter, { label: f, value: f, currentFilters: secondaryFilters, onChange: toggleSecondaryFilter, key: f });
                }))));
};
var CheckBoxFilter = function (props) {
    var label = props.label, value = props.value, currentFilters = props.currentFilters, onChange = props.onChange;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("input", { type: "checkbox", value: value, checked: __WEBPACK_IMPORTED_MODULE_1_lodash__["includes"](currentFilters, value), onChange: onChange }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("label", null, label)));
};
/* harmony default export */ __webpack_exports__["b"] = (SearchFiltersComponent);


/***/ }),

/***/ "./app/client/search/components/SearchResultComponent.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/react.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data_models_Style__ = __webpack_require__("./app/client/_data/models/Style.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_components_MyStylesGalleryImageComponent__ = __webpack_require__("./app/client/style/components/MyStylesGalleryImageComponent.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data_models_User__ = __webpack_require__("./app/client/_data/models/User.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SearchTrendingUserComponent__ = __webpack_require__("./app/client/search/components/SearchTrendingUserComponent.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__data_models_Shop__ = __webpack_require__("./app/client/_data/models/Shop.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__data_models_Special__ = __webpack_require__("./app/client/_data/models/Special.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SearchTrendingShopComponent__ = __webpack_require__("./app/client/search/components/SearchTrendingShopComponent.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__SearchTrendingSpecialComponent__ = __webpack_require__("./app/client/search/components/SearchTrendingSpecialComponent.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__SearchResultItemComponent__ = __webpack_require__("./app/client/search/components/SearchResultItemComponent.tsx");










var SearchResultComponent = function (props) {
    var result = props.result, model = props.model, forTrending = props.forTrending, viewItem = props.viewItem, dependencies = props.dependencies;
    if (forTrending) {
        if (model instanceof __WEBPACK_IMPORTED_MODULE_1__data_models_Style__["a" /* default */])
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__style_components_MyStylesGalleryImageComponent__["a" /* default */], { item: model });
        else if (model instanceof __WEBPACK_IMPORTED_MODULE_3__data_models_User__["a" /* default */])
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__SearchTrendingUserComponent__["a" /* default */], { user: model, viewItem: viewItem, result: result });
        else if (model instanceof __WEBPACK_IMPORTED_MODULE_5__data_models_Shop__["a" /* default */])
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__SearchTrendingShopComponent__["a" /* default */], { shop: model, result: result, viewItem: viewItem });
        else if (model instanceof __WEBPACK_IMPORTED_MODULE_6__data_models_Special__["a" /* default */])
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__SearchTrendingSpecialComponent__["a" /* default */], { special: model, result: result, viewItem: viewItem });
    }
    else
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__SearchResultItemComponent__["a" /* default */], { result: result, model: model, viewItem: viewItem, dependencies: dependencies });
};
/* harmony default export */ __webpack_exports__["a"] = (SearchResultComponent);


/***/ }),

/***/ "./app/client/search/components/SearchResultItemComponent.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/react.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data_models_Style__ = __webpack_require__("./app/client/_data/models/Style.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_models_User__ = __webpack_require__("./app/client/_data/models/User.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data_models_Shop__ = __webpack_require__("./app/client/_data/models/Shop.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__data_models_Booth__ = __webpack_require__("./app/client/_data/models/Booth.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_utils__ = __webpack_require__("./app/client/_helpers/utils.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__("./node_modules/lodash/lodash.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_pluralize__ = __webpack_require__("./node_modules/pluralize/pluralize.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_pluralize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_pluralize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__data_models_Special__ = __webpack_require__("./app/client/_data/models/Special.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment__ = __webpack_require__("./node_modules/moment/moment.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_moment__);










var SearchResultItemComponent = function (props) {
    var result = props.result, model = props.model, viewItem = props.viewItem, dependencies = props.dependencies;
    var image = "";
    var title = "";
    var description = "";
    var distance = result.distance;
    if (model instanceof __WEBPACK_IMPORTED_MODULE_2__data_models_User__["a" /* default */]) {
        var user = model;
        image = user.profilePicture();
        title = user.username();
        description = user.completeAddress();
        if (!user.isProfessional) {
            distance = null;
            description = null;
        }
    }
    else if (model instanceof __WEBPACK_IMPORTED_MODULE_3__data_models_Shop__["a" /* default */]) {
        var shop = model;
        image = shop.primaryPictureUrl;
        title = shop.name;
        description = shop.completeAddress();
        if (!dependencies.user.isProfessional)
            description = null;
    }
    else if (model instanceof __WEBPACK_IMPORTED_MODULE_4__data_models_Booth__["a" /* default */]) {
        var booth = model;
        image = booth.primaryPictureUrl || dependencies.shop.primaryPictureUrl;
        title = dependencies.shop.name;
        description = booth.workstationCount + " " + __WEBPACK_IMPORTED_MODULE_7_pluralize__('booth', booth.workstationCount) + " available";
    }
    else if (model instanceof __WEBPACK_IMPORTED_MODULE_8__data_models_Special__["a" /* default */]) {
        var special = model;
        image = dependencies.user.profilePicture();
        title = special.title;
        description = "Ends on " + __WEBPACK_IMPORTED_MODULE_9_moment__(special.endDate).format('MMMM D, YYYY h:m A');
    }
    else if (model instanceof __WEBPACK_IMPORTED_MODULE_1__data_models_Style__["a" /* default */]) {
        var style = model;
        image = style.primaryPictureUrl;
        title = dependencies.user.name;
        description = style.tags.length ? style.tags.join(", ") : style.description;
    }
    if (dependencies.user && !dependencies.user.isProfessional)
        distance = null;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "media-object" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "media-object-section flushed middle" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "img-wrapper small-img-fit" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: image }))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "media-object-section middle" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "text-group" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null,
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("b", null, title),
                        distance &&
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("small", { className: "ml-1" },
                                result.distanceInMiles(),
                                " Miles")),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("small", { className: "subheader" }, description)))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { className: "button primary hollow pull-right", onClick: viewItem },
            "View ",
            __WEBPACK_IMPORTED_MODULE_6_lodash__["capitalize"](__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__helpers_utils__["i" /* clientModelName */])(model)))));
};
/* harmony default export */ __webpack_exports__["a"] = (SearchResultItemComponent);


/***/ }),

/***/ "./app/client/search/components/SearchTrendingComponent.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/react.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__containers_SearchResultContainer__ = __webpack_require__("./app/client/search/containers/SearchResultContainer.tsx");


var SearchTrendingComponent = function (props) {
    var styles = props.styles, specials = props.specials, shops = props.shops, users = props.users;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
        !styles.isEmpty() &&
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "large-12 columns" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h6", { className: "page-lead" }, "Popular Images"))),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "large-12 columns" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "featured-image-block-grid" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row large-up-3 medium-up-2 small-up-1" }, styles.toArray().map(function (s) {
                                return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__containers_SearchResultContainer__["a" /* default */], { key: s.id, result: s, forTrending: true });
                            })))))),
        !styles.isEmpty() &&
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "large-12 columns" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h6", { className: "page-lead" }, "Popular Professionals"),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("ul", { className: "list-block flex-container" }, users.toArray().map(function (s) {
                        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__containers_SearchResultContainer__["a" /* default */], { key: s.id, result: s, forTrending: true });
                    })))),
        !shops.isEmpty() &&
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "large-12 columns" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h6", { className: "page-lead" }, "Popular Shops"))),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row" }, shops.toArray().map(function (s) {
                    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__containers_SearchResultContainer__["a" /* default */], { key: s.id, result: s, forTrending: true });
                }))),
        !specials.isEmpty() &&
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "large-12 columns" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h6", { className: "page-lead" }, "Popular Specials"))),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row" }, specials.toArray().map(function (s) {
                    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__containers_SearchResultContainer__["a" /* default */], { key: s.id, result: s, forTrending: true });
                })))));
};
/* harmony default export */ __webpack_exports__["a"] = (SearchTrendingComponent);


/***/ }),

/***/ "./app/client/search/components/SearchTrendingShopComponent.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/react.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__widgets_like_LikeContainer__ = __webpack_require__("./app/client/_widgets/like/LikeContainer.tsx");


var SearchTrendingShopComponent = function (props) {
    var result = props.result, shop = props.shop, viewItem = props.viewItem;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "medium-6 columns" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { onClick: viewItem },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "newsfeed-panel callout paddingless mb-half" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "large-12 columns" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "post-img fixed-size v-align-center" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: shop.primaryPictureUrl || window.Styleteq.images.stPlaceholder }),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "text-wrapper" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h5", null, shop.name),
                                result.distance &&
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h6", null,
                                        result.distanceInMiles(),
                                        " Miles"),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h6", { className: "subheader" }, shop.completeAddress()))))),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row p1 paddingless" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "large-12 columns" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("ul", { className: "list-inline marginless newsfeed-lgfont" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__widgets_like_LikeContainer__["a" /* default */], { model: shop }))))))));
};
/* harmony default export */ __webpack_exports__["a"] = (SearchTrendingShopComponent);


/***/ }),

/***/ "./app/client/search/components/SearchTrendingSpecialComponent.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/react.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__widgets_like_LikeContainer__ = __webpack_require__("./app/client/_widgets/like/LikeContainer.tsx");


var SearchTrendingSpecialComponent = function (props) {
    var result = props.result, special = props.special, viewItem = props.viewItem;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "medium-12 columns" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { onClick: viewItem },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "callout paddingless mb-1" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row pr-1 pl-1" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "large-12 columns paddingless bb-1 p2 specials" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "text-center" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", null, special.title.toUpperCase()),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, special.description),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("small", null,
                                "Starts on ",
                                special.prettyStartDate(),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("br", null),
                                special.prettyEndDateString(),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("br", null),
                                result.distance &&
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "subheader" },
                                        result.distanceInMiles(),
                                        " Miles "))))),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row p1" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "large-12 columns" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("ul", { className: "list-inline marginless newsfeed-lgfont" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__widgets_like_LikeContainer__["a" /* default */], { model: special }))))))));
};
/* harmony default export */ __webpack_exports__["a"] = (SearchTrendingSpecialComponent);


/***/ }),

/***/ "./app/client/search/components/SearchTrendingUserComponent.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/react.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var SearchTrendingUserComponent = function (props) {
    var result = props.result, user = props.user, viewItem = props.viewItem;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "media-object" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "media-object-section flushed middle" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "img-wrapper small circle" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: user.profilePicture() }))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "media-object-section middle" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "text-group" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null,
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("b", null, user.username()),
                        result.distance &&
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("small", { className: "ml-1" },
                                result.distanceInMiles(),
                                " Miles")),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("small", { className: "subheader" }, user.profession)))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { className: "button primary pull-right", onClick: viewItem }, "View Profile")));
};
/* harmony default export */ __webpack_exports__["a"] = (SearchTrendingUserComponent);


/***/ }),

/***/ "./app/client/search/containers/SearchBarContainer.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__("./node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_SearchBarComponent__ = __webpack_require__("./app/client/search/components/SearchBarComponent.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__("./app/client/search/actions.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__selectors__ = __webpack_require__("./app/client/search/selectors.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__middlewares__ = __webpack_require__("./app/client/search/middlewares.ts");





var mapStateToProps = function (state, props) {
    var search = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__selectors__["a" /* searchSelector */])(state);
    return {
        query: search.query,
        location: search.geo.address,
        filtersEnabled: search.filters.enabled
    };
};
var mapDispatchToProps = function (dispatch) {
    return {
        toggleFilter: function () {
            dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["a" /* toggleSearchFiltersAction */])());
        },
        changeQuery: function (e) {
            dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["h" /* setSearchQueryAction */])({ query: e.currentTarget.value }));
        },
        changeLocation: function (e) {
            dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["m" /* setSearchLocationAction */])({ location: e.currentTarget.value }));
        },
        search: function () {
            dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__middlewares__["c" /* pushSearch */])());
        },
        clear: function () {
            dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["g" /* clearSearchFiltersAction */])());
        }
    };
};
var SearchBarContainer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__components_SearchBarComponent__["a" /* default */]);
/* harmony default export */ __webpack_exports__["a"] = (SearchBarContainer);


/***/ }),

/***/ "./app/client/search/containers/SearchContainer.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__("./node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_SearchComponent__ = __webpack_require__("./app/client/search/components/SearchComponent.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__selectors__ = __webpack_require__("./app/client/search/selectors.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__middlewares__ = __webpack_require__("./app/client/search/middlewares.ts");




var mapStateToProps = function (state, props) {
    var search = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__selectors__["a" /* searchSelector */])(state);
    return {
        meta: search.meta,
        loading: search.loading,
        loadingMessage: search.loadingMessage,
        results: search.results,
        view: search.view,
        noResultsFound: search.noSearchResultsFound
    };
};
var mapDispatchToProps = function (dispatch) {
    return {
        loadMore: function (meta) {
            if (meta && meta.hasNext())
                dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__middlewares__["b" /* search */])());
        }
    };
};
var SearchContainer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__components_SearchComponent__["a" /* default */]);
/* harmony default export */ __webpack_exports__["a"] = (SearchContainer);


/***/ }),

/***/ "./app/client/search/containers/SearchFiltersContainer.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__("./node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__("./app/client/search/actions.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__selectors__ = __webpack_require__("./app/client/search/selectors.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_SearchFiltersComponent__ = __webpack_require__("./app/client/search/components/SearchFiltersComponent.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__middlewares__ = __webpack_require__("./app/client/search/middlewares.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__data_selectors__ = __webpack_require__("./app/client/_data/selectors.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__user_selectors__ = __webpack_require__("./app/client/user/selectors.ts");







var mapStateToProps = function (state, props) {
    var search = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__selectors__["b" /* searchFiltersSelector */])(state);
    var currentUser = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__data_selectors__["c" /* userByIdSelector */])(state, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__user_selectors__["a" /* currentUserIdSelector */])(state));
    return {
        selectedType: search.typeFilter,
        secondaryFilters: search.secondaryFilters,
        currentUser: currentUser
    };
};
var mapDispatchToProps = function (dispatch) {
    return {
        changeFilterType: function (type) {
            dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__middlewares__["d" /* changeSearchFilterType */])(type));
        },
        toggleSecondaryFilter: function (e) {
            var target = e.currentTarget;
            var action = target.checked ? __WEBPACK_IMPORTED_MODULE_1__actions__["d" /* addSearchSecondaryFilterAction */] : __WEBPACK_IMPORTED_MODULE_1__actions__["e" /* removeSearchSecondaryFilterAction */];
            dispatch(action({ secondaryFilter: target.value }));
        }
    };
};
var SearchFiltersContainer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3__components_SearchFiltersComponent__["b" /* default */]);
/* harmony default export */ __webpack_exports__["a"] = (SearchFiltersContainer);


/***/ }),

/***/ "./app/client/search/containers/SearchResultContainer.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__("./node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_SearchResultComponent__ = __webpack_require__("./app/client/search/components/SearchResultComponent.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_selectors__ = __webpack_require__("./app/client/_data/selectors.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_pluralize__ = __webpack_require__("./node_modules/pluralize/pluralize.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_pluralize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_pluralize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_utils__ = __webpack_require__("./app/client/_helpers/utils.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_data__ = __webpack_require__("./app/client/_helpers/data.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__routes__ = __webpack_require__("./app/client/routes.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router_redux__ = __webpack_require__("./node_modules/react-router-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__data_models_Booth__ = __webpack_require__("./app/client/_data/models/Booth.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__data_models_Special__ = __webpack_require__("./app/client/_data/models/Special.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__data_models_Style__ = __webpack_require__("./app/client/_data/models/Style.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_class_transformer__ = __webpack_require__("./node_modules/class-transformer/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_class_transformer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_class_transformer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__shop_middlewares__ = __webpack_require__("./app/client/shop/middlewares.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__data_models_Shop__ = __webpack_require__("./app/client/_data/models/Shop.ts");














var mapStateToProps = function (state, props) {
    var result = props.result;
    var data = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__data_selectors__["f" /* dataByResourceNameSelector */])(state, __WEBPACK_IMPORTED_MODULE_3_pluralize__(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__helpers_utils__["h" /* apiModelNameToClientModelName */])(result.type)).toLowerCase());
    var model = data.get(result.modelId);
    var dependencies = {};
    if (model instanceof __WEBPACK_IMPORTED_MODULE_8__data_models_Booth__["a" /* default */])
        dependencies['shop'] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__data_selectors__["g" /* shopByIdSelector */])(state, model.shopId);
    if (model instanceof __WEBPACK_IMPORTED_MODULE_9__data_models_Special__["a" /* default */])
        dependencies['user'] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__data_selectors__["c" /* userByIdSelector */])(state, model.userId);
    if (model instanceof __WEBPACK_IMPORTED_MODULE_10__data_models_Style__["a" /* default */])
        dependencies['user'] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__data_selectors__["c" /* userByIdSelector */])(state, model.userId);
    if (model instanceof __WEBPACK_IMPORTED_MODULE_13__data_models_Shop__["a" /* default */])
        dependencies['user'] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__data_selectors__["c" /* userByIdSelector */])(state, model.userId);
    return {
        result: result,
        model: model,
        dependencies: dependencies
    };
};
var mapDispatchToProps = function (dispatch, props) {
    var result = props.result;
    return {
        viewItem: function () {
            switch (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__helpers_utils__["h" /* apiModelNameToClientModelName */])(result.type).toLowerCase()) {
                case __WEBPACK_IMPORTED_MODULE_5__helpers_data__["a" /* ResourceType */].user:
                    return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react_router_redux__["d" /* push */])(__WEBPACK_IMPORTED_MODULE_6__routes__["g" /* UsersRoutes */].show(result.modelId)));
                case __WEBPACK_IMPORTED_MODULE_5__helpers_data__["a" /* ResourceType */].shop:
                    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__shop_middlewares__["b" /* initializeShopProfile */])(result.modelId));
                    return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react_router_redux__["d" /* push */])(__WEBPACK_IMPORTED_MODULE_6__routes__["d" /* ShopsRoutes */].view(result.modelId)));
                case __WEBPACK_IMPORTED_MODULE_5__helpers_data__["a" /* ResourceType */].booth:
                    var booth = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_class_transformer__["plainToClass"])(__WEBPACK_IMPORTED_MODULE_8__data_models_Booth__["a" /* default */], result.entityProperties);
                    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__shop_middlewares__["b" /* initializeShopProfile */])(booth.shopId));
                    return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react_router_redux__["d" /* push */])(__WEBPACK_IMPORTED_MODULE_6__routes__["d" /* ShopsRoutes */].viewBooth(booth.shopId, booth.id)));
                case __WEBPACK_IMPORTED_MODULE_5__helpers_data__["a" /* ResourceType */].style:
                    var s = result.entityProperties;
                    return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react_router_redux__["d" /* push */])(__WEBPACK_IMPORTED_MODULE_6__routes__["a" /* StylesRoutes */].showStyle(s.user.name, s.id)));
                case __WEBPACK_IMPORTED_MODULE_5__helpers_data__["a" /* ResourceType */].special:
                    return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react_router_redux__["d" /* push */])(__WEBPACK_IMPORTED_MODULE_6__routes__["e" /* SpecialsRoutes */].show(result.modelId)));
            }
        }
    };
};
var SearchResultContainer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__components_SearchResultComponent__["a" /* default */]);
/* harmony default export */ __webpack_exports__["a"] = (SearchResultContainer);


/***/ }),

/***/ "./app/client/search/containers/SearchTrendingContainer.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__("./node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_SearchTrendingComponent__ = __webpack_require__("./app/client/search/components/SearchTrendingComponent.tsx");


var mapStateToProps = function (state, props) {
    var results = props.results;
    return {
        styles: results.filter(function (r) { return r.type == 'Style'; }),
        specials: results.filter(function (r) { return r.type == 'Special'; }),
        shops: results.filter(function (r) { return r.type == 'Salon'; }),
        users: results.filter(function (r) { return r.type == 'User'; }),
    };
};
var mapDispatchToProps = function (dispatch) {
    return {};
};
var SearchTrendingContainer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__components_SearchTrendingComponent__["a" /* default */]);
/* harmony default export */ __webpack_exports__["a"] = (SearchTrendingContainer);


/***/ }),

/***/ "./app/client/search/middlewares.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SearchAddressType */
/* harmony export (immutable) */ __webpack_exports__["d"] = changeSearchFilterType;
/* harmony export (immutable) */ __webpack_exports__["c"] = pushSearch;
/* harmony export (immutable) */ __webpack_exports__["a"] = searchFromUrl;
/* unused harmony export searchTrending */
/* unused harmony export searchFromStateValues */
/* harmony export (immutable) */ __webpack_exports__["b"] = search;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors__ = __webpack_require__("./app/client/search/selectors.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__repositories_searchRepository__ = __webpack_require__("./app/client/_repositories/searchRepository.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__("./app/client/search/actions.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_utils__ = __webpack_require__("./app/client/_helpers/utils.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__data_actions__ = __webpack_require__("./app/client/_data/actions.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__("./node_modules/lodash/lodash.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__reducers__ = __webpack_require__("./app/client/search/reducers.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router_redux__ = __webpack_require__("./node_modules/react-router-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__routes__ = __webpack_require__("./app/client/routes.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_query_string__ = __webpack_require__("./node_modules/query-string/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_SearchFiltersComponent__ = __webpack_require__("./app/client/search/components/SearchFiltersComponent.tsx");
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};











var SearchAddressType;
(function (SearchAddressType) {
    SearchAddressType[SearchAddressType["LOCATION"] = 0] = "LOCATION";
    SearchAddressType[SearchAddressType["PROXIMITY"] = 1] = "PROXIMITY";
    SearchAddressType[SearchAddressType["NONE"] = 2] = "NONE";
})(SearchAddressType || (SearchAddressType = {}));
function changeSearchFilterType(type) {
    return function (dispatch, getState) {
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__selectors__["b" /* searchFiltersSelector */])(getState()).typeFilter != type) {
            dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["f" /* clearSearchSecondaryFilterAction */])());
            dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["b" /* setSearchFilterTypeAction */])({ type: type }));
        }
    };
}
function pushSearch() {
    return function (dispatch, getState) {
        var data = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__selectors__["a" /* searchSelector */])(getState());
        var filter = data.filters;
        var type = filter.typeFilter;
        var secondaryFilters = filter.secondaryFilters.length ? filter.secondaryFilters : null;
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react_router_redux__["d" /* push */])(__WEBPACK_IMPORTED_MODULE_8__routes__["c" /* SearchRoutes */].query(data.query, data.geo, type, secondaryFilters, null, null)));
    };
}
function searchFromUrl(url) {
    return function (dispatch) {
        if (url.length == 0) {
            dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["g" /* clearSearchFiltersAction */])());
            dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["q" /* setSearchView */])({ view: __WEBPACK_IMPORTED_MODULE_6__reducers__["b" /* SearchView */].TRENDING }));
            dispatch(searchTrending());
        }
        else {
            var query = __WEBPACK_IMPORTED_MODULE_9_query_string__["parse"](url, { arrayFormat: 'bracket' });
            if (query['q'])
                dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["h" /* setSearchQueryAction */])({ query: query['q'] }));
            if (query['resource'])
                dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["b" /* setSearchFilterTypeAction */])({ type: query['resource'] }));
            if (query['filter'])
                dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["c" /* setSearchSecondaryFilterAction */])({ secondaryFilters: query['filter'] }));
            if (query['geo[address]'])
                dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["m" /* setSearchLocationAction */])({ location: query['geo[address]'] }));
            if (query['geo[longitude]'])
                dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["n" /* setSearchGeoLocationAction */])({
                    coords: {
                        longitude: parseFloat(query['geo[longitude]']),
                        latitude: parseFloat(query['geo[latitude]'])
                    }
                }));
            dispatch(searchFromStateValues());
        }
    };
}
function searchTrending(addressType) {
    if (addressType === void 0) { addressType = SearchAddressType.LOCATION; }
    return function (dispatch, getState) {
        var geo = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__selectors__["a" /* searchSelector */])(getState()).geo;
        if (addressType == SearchAddressType.LOCATION && geo.address.trim().length == 0)
            addressType = SearchAddressType.PROXIMITY;
        var proc = function () {
            dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["p" /* resetSearchTrendingCategoriesCount */])());
            dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["j" /* clearSearchItemsAction */])());
            dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["k" /* requestSearchItemsAction */])());
            var geo = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__selectors__["a" /* searchSelector */])(getState()).geo;
            if (addressType == SearchAddressType.NONE)
                geo = null;
            searchTrendingCategory(dispatch, 'style', 6, addressType, geo);
            searchTrendingCategory(dispatch, 'special', 6, addressType, geo);
            searchTrendingCategory(dispatch, 'salon', 4, addressType, geo);
            searchTrendingCategory(dispatch, 'user', 5, addressType, geo);
        };
        if (addressType == SearchAddressType.PROXIMITY && geo.longitude == null && geo.latitude == null)
            getLocationForSearch(dispatch, proc);
        else
            proc();
    };
}
function searchFromStateValues() {
    return function (dispatch, getState) {
        var geo = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__selectors__["a" /* searchSelector */])(getState()).geo;
        var proc = function () {
            dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["q" /* setSearchView */])({ view: __WEBPACK_IMPORTED_MODULE_6__reducers__["b" /* SearchView */].SEARCH }));
            dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["j" /* clearSearchItemsAction */])());
            dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["k" /* requestSearchItemsAction */])());
            dispatch(search());
        };
        if (geo.longitude == null && geo.latitude == null)
            getLocationForSearch(dispatch, proc);
        else
            proc();
    };
}
function search() {
    return function (dispatch, getState) {
        var data = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__selectors__["a" /* searchSelector */])(getState());
        var filter = data.filters;
        var type = filter.typeFilter;
        var secondaryFilters = filter.secondaryFilters.length ? filter.secondaryFilters : null;
        var meta = data.meta;
        __WEBPACK_IMPORTED_MODULE_1__repositories_searchRepository__["a" /* default */].search(data.query, data.geo, type, secondaryFilters, meta ? meta.nextPage : 1).then(function (data) {
            if (data.results.length)
                addSearchData(dispatch, data);
            else {
                dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["q" /* setSearchView */])({ view: __WEBPACK_IMPORTED_MODULE_6__reducers__["b" /* SearchView */].TRENDING }));
                dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["r" /* setSearchNoResultsFound */])());
                dispatch(searchTrending());
            }
        });
    };
}
//helpers
function searchTrendingCategory(dispatch, category, perPage, addressType, geo) {
    var _geo = __WEBPACK_IMPORTED_MODULE_5_lodash__["cloneDeep"](geo);
    var secondaryFilters = category == 'user' ? __WEBPACK_IMPORTED_MODULE_5_lodash__["cloneDeep"](__WEBPACK_IMPORTED_MODULE_10__components_SearchFiltersComponent__["a" /* professionalFilter */]).splice(1) : null;
    if (addressType == SearchAddressType.PROXIMITY)
        __WEBPACK_IMPORTED_MODULE_5_lodash__["chain"](_geo).set('address', null).value();
    __WEBPACK_IMPORTED_MODULE_1__repositories_searchRepository__["a" /* default */].searchTrendingCategory(category, _geo, perPage, secondaryFilters).then(function (data) {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["o" /* incrementSearchTrendingCategoriesCount */])());
        if (data.results.length)
            addSearchData(dispatch, data);
        dispatch(function (dispatch, getState) {
            var search = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__selectors__["a" /* searchSelector */])(getState());
            if (search.trendingCategoriesCount == 4 && search.results.isEmpty()) {
                if (addressType == SearchAddressType.LOCATION)
                    dispatch(searchTrending(SearchAddressType.PROXIMITY));
                else if (addressType == SearchAddressType.PROXIMITY)
                    dispatch(searchTrending(SearchAddressType.NONE));
            }
        });
    });
}
function addSearchData(dispatch, data) {
    var typeId = {
        'User': 1,
        'Salon': 2,
        'Special': 3,
        'Style': 4,
        'Booth': 5,
    };
    var items = data.results.map(function (data) {
        return __assign({}, data, { model_id: data.entity_properties.id, id: parseInt("" + data.entity_properties.id + typeId[data.type]) });
    });
    __WEBPACK_IMPORTED_MODULE_5_lodash__["chain"](items)
        .groupBy(function (d) { return d.type; })
        .map(function (value, key) {
        return {
            resource: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__helpers_utils__["h" /* apiModelNameToClientModelName */])(key).toLowerCase(),
            value: value.map(function (v) { return v.entity_properties; })
        };
    })
        .forEach(function (map) {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__data_actions__["a" /* addDataAction */])({
            resource: map.resource,
            data: map.value
        }));
    }).value();
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["i" /* receiveSearchItemsAction */])({ data: items, meta: data.meta }));
}
function getLocationForSearch(dispatch, callback) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["l" /* requestSearchGeoLocationAction */])());
    var location = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__helpers_utils__["n" /* getLocation */])(function (position) {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["n" /* setSearchGeoLocationAction */])({ coords: position.coords }));
        callback();
    }, function (error) {
        switch (error.code) {
            case error.PERMISSION_DENIED:
                console.log("User has denied the request for GeoLocation.");
                break;
            case error.POSITION_UNAVAILABLE:
                console.log("Location information is unavailable.");
                break;
            case error.TIMEOUT:
                console.log("The request to get user location timed out.");
                break;
            default:
                console.log("An unknown error occurred.");
                break;
        }
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["n" /* setSearchGeoLocationAction */])({ coords: { latitude: null, longitude: null } }));
        callback();
    });
}


/***/ }),

/***/ "./app/client/search/reducers.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SearchView; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__("./node_modules/redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__("./app/client/search/actions.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__("./node_modules/lodash/lodash.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable__ = __webpack_require__("./node_modules/immutable/dist/immutable.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__data_models_Meta__ = __webpack_require__("./app/client/_data/models/Meta.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_data__ = __webpack_require__("./app/client/_helpers/data.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_class_transformer__ = __webpack_require__("./node_modules/class-transformer/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_class_transformer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_class_transformer__);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};







var SearchView;
(function (SearchView) {
    SearchView[SearchView["SEARCH"] = 0] = "SEARCH";
    SearchView[SearchView["TRENDING"] = 1] = "TRENDING";
})(SearchView || (SearchView = {}));
//initial states
var initialFilters = {
    enabled: false,
    typeFilter: null,
    secondaryFilters: []
};
var initialResults = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_immutable__["OrderedMap"])();
var initialGeo = {
    latitude: null,
    longitude: null,
    address: ''
};
//reducers
var searchReducer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux__["b" /* combineReducers */])({
    filters: filters,
    query: query,
    results: results,
    meta: meta,
    loading: loading,
    loadingMessage: loadingMessage,
    geo: geo,
    trendingCategoriesCount: trendingCategoriesCount,
    view: view,
    noSearchResultsFound: noSearchResultsFound
});
/* harmony default export */ __webpack_exports__["a"] = (searchReducer);
function filters(state, action) {
    if (state === void 0) { state = initialFilters; }
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* toggleSearchFiltersAction */].toString():
            return __assign({}, state, { enabled: !state.enabled });
        case __WEBPACK_IMPORTED_MODULE_1__actions__["b" /* setSearchFilterTypeAction */].toString():
            return __assign({}, state, { typeFilter: action.payload.type });
        case __WEBPACK_IMPORTED_MODULE_1__actions__["c" /* setSearchSecondaryFilterAction */].toString():
            return __assign({}, state, { secondaryFilters: action.payload.secondaryFilters });
        case __WEBPACK_IMPORTED_MODULE_1__actions__["d" /* addSearchSecondaryFilterAction */].toString():
            return __assign({}, state, { secondaryFilters: state.secondaryFilters.concat([action.payload.secondaryFilter]) });
        case __WEBPACK_IMPORTED_MODULE_1__actions__["e" /* removeSearchSecondaryFilterAction */].toString():
            return __assign({}, state, { secondaryFilters: __WEBPACK_IMPORTED_MODULE_2_lodash__["without"](state.secondaryFilters, action.payload.secondaryFilter) });
        case __WEBPACK_IMPORTED_MODULE_1__actions__["f" /* clearSearchSecondaryFilterAction */].toString():
            return __assign({}, state, { secondaryFilters: [] });
        case __WEBPACK_IMPORTED_MODULE_1__actions__["g" /* clearSearchFiltersAction */].toString():
            return initialFilters;
    }
    return state;
}
function query(state, action) {
    if (state === void 0) { state = ''; }
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_1__actions__["h" /* setSearchQueryAction */].toString():
            return action.payload.query;
        case __WEBPACK_IMPORTED_MODULE_1__actions__["g" /* clearSearchFiltersAction */].toString():
            return '';
    }
    return state;
}
function results(state, action) {
    if (state === void 0) { state = initialResults; }
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_1__actions__["i" /* receiveSearchItemsAction */].toString():
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__helpers_data__["b" /* addData */])(__WEBPACK_IMPORTED_MODULE_5__helpers_data__["a" /* ResourceType */].search, action.payload.data, state);
        case __WEBPACK_IMPORTED_MODULE_1__actions__["j" /* clearSearchItemsAction */].toString():
            return state.clear();
    }
    return state;
}
function meta(state, action) {
    if (state === void 0) { state = null; }
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_1__actions__["i" /* receiveSearchItemsAction */].toString():
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_class_transformer__["plainToClass"])(__WEBPACK_IMPORTED_MODULE_4__data_models_Meta__["a" /* default */], action.payload.meta);
        case __WEBPACK_IMPORTED_MODULE_1__actions__["j" /* clearSearchItemsAction */].toString():
            return null;
    }
    return state;
}
function loading(state, action) {
    if (state === void 0) { state = false; }
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_1__actions__["k" /* requestSearchItemsAction */].toString():
        case __WEBPACK_IMPORTED_MODULE_1__actions__["l" /* requestSearchGeoLocationAction */].toString():
            return true;
        case __WEBPACK_IMPORTED_MODULE_1__actions__["i" /* receiveSearchItemsAction */].toString():
            return false;
    }
    return state;
}
function loadingMessage(state, action) {
    if (state === void 0) { state = null; }
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_1__actions__["k" /* requestSearchItemsAction */].toString():
            return "Fetching data from server.";
        case __WEBPACK_IMPORTED_MODULE_1__actions__["l" /* requestSearchGeoLocationAction */].toString():
            return "Getting current location.";
        case __WEBPACK_IMPORTED_MODULE_1__actions__["i" /* receiveSearchItemsAction */].toString():
            return null;
    }
    return state;
}
function geo(state, action) {
    if (state === void 0) { state = initialGeo; }
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_1__actions__["m" /* setSearchLocationAction */].toString():
            return __assign({}, state, { address: action.payload.location });
        case __WEBPACK_IMPORTED_MODULE_1__actions__["n" /* setSearchGeoLocationAction */].toString():
            var _a = action.payload.coords, latitude = _a.latitude, longitude = _a.longitude;
            return __assign({}, state, { latitude: latitude, longitude: longitude });
        case __WEBPACK_IMPORTED_MODULE_1__actions__["g" /* clearSearchFiltersAction */].toString():
            return initialGeo;
    }
    return state;
}
function trendingCategoriesCount(state, action) {
    if (state === void 0) { state = 0; }
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_1__actions__["o" /* incrementSearchTrendingCategoriesCount */].toString():
            return state + 1;
        case __WEBPACK_IMPORTED_MODULE_1__actions__["p" /* resetSearchTrendingCategoriesCount */].toString():
            return 0;
    }
    return state;
}
function view(state, action) {
    if (state === void 0) { state = SearchView.TRENDING; }
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_1__actions__["q" /* setSearchView */].toString():
            return action.payload.view;
    }
    return state;
}
function noSearchResultsFound(state, action) {
    if (state === void 0) { state = false; }
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_1__actions__["r" /* setSearchNoResultsFound */].toString():
            return true;
        case __WEBPACK_IMPORTED_MODULE_1__actions__["q" /* setSearchView */].toString():
            return false;
    }
    return state;
}


/***/ }),

/***/ "./app/client/search/selectors.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return searchSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return searchFiltersSelector; });
/* unused harmony export searchResultsSelector */
var searchSelector = function (state) { return state.search; };
var searchFiltersSelector = function (state) { return searchSelector(state).filters; };
var searchResultsSelector = function (state) { return searchSelector(state).results; };


/***/ }),

/***/ "./app/client/shop/actions.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return requestStarted; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return requestFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return requestSucceeded; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return didReceiveShops; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return invalidateShops; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return setMyShopsFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return clearShopProfile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return requestShopProfessionals; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return didReceiveShopProfessionals; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return requestShopBooths; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return didReceiveShopBooths; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return didAddShopBooth; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__("./node_modules/redux-actions/es/index.js");

var requestStarted = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])("REQUEST_STARTED");
var requestFailed = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])("REQUEST_FAILED");
var requestSucceeded = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])("REQUEST_SUCCEEDED");
var didReceiveShops = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])("RECEIVE_SHOPS");
var invalidateShops = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])("INVALIDATE_SHOPS");
var setMyShopsFilter = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])("SET_SHOPS_FILTER");
// shop profile actions
var clearShopProfile = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])("CLEAR_SHOP_PROFILE");
var requestShopProfessionals = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])("REQUEST_SHOP_PROFESSIONALS");
var didReceiveShopProfessionals = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])("RECEIVE_SHOP_PROFESSIONALS");
var requestShopBooths = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])("REQUEST_SHOP_BOOTHS");
var didReceiveShopBooths = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])("RECEIVE_SHOP_BOOTHS");
var didAddShopBooth = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])("ADD_SHOP_BOOTH");


/***/ }),

/***/ "./app/client/shop/components/ShopBoothsComponent.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/react.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__booth_containers_BoothListItemContainer__ = __webpack_require__("./app/client/booth/containers/BoothListItemContainer.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_utils__ = __webpack_require__("./app/client/_helpers/utils.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__("./node_modules/react-router-dom/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__routes__ = __webpack_require__("./app/client/routes.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux_infinite_scroll__ = __webpack_require__("./node_modules/redux-infinite-scroll/lib/ReduxInfiniteScroll.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux_infinite_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_redux_infinite_scroll__);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};






var ShopBoothsComponent = function (props) {
    var items = props.items, shop = props.shop, loadMore = props.loadMore, loading = props.loading, meta = props.meta;
    var withOwnerPermission = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__helpers_utils__["f" /* getCurrentUser */])() ? shop.isOwnedBy(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__helpers_utils__["f" /* getCurrentUser */])().id) : false;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_redux_infinite_scroll___default.a, { holderType: "ul", className: "list-block flex-container", loadMore: function () { return loadMore(meta); }, elementIsScrollable: false, loadingMore: loading, showLoader: false, threshold: 200 },
        items.map(function (each) {
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__booth_containers_BoothListItemContainer__["a" /* default */], __assign({}, props, { key: "booth_" + each.id, booth: each }));
        }),
        withOwnerPermission &&
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", { className: "bb-0" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "m0-auto add-media mb-1" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "text-center p1 pb-1" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["b" /* Link */], { to: __WEBPACK_IMPORTED_MODULE_4__routes__["d" /* ShopsRoutes */].addBooth(shop.id), className: "button hollow pull-right" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h5", { className: "mb-0 text-upper" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("i", { className: "fa fa-plus mr-half", "aria-hidden": "true" }),
                                " Click here to add booth")))))));
};
/* harmony default export */ __webpack_exports__["a"] = (ShopBoothsComponent);


/***/ }),

/***/ "./app/client/shop/components/ShopListComponent.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/react.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_infinite_scroll__ = __webpack_require__("./node_modules/redux-infinite-scroll/lib/ReduxInfiniteScroll.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_infinite_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_infinite_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__widgets_breadcrumbs_BreadcrumbsComponent__ = __webpack_require__("./app/client/_widgets/breadcrumbs/BreadcrumbsComponent.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__container_ShopListItemContainer__ = __webpack_require__("./app/client/shop/container/ShopListItemContainer.ts");
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};




var ShopListComponent = function (props) {
    var items = props.items, meta = props.meta, loading = props.loading, loadMore = props.loadMore, filterByName = props.filterByName;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row expanded" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__widgets_breadcrumbs_BreadcrumbsComponent__["a" /* default */], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null, "Shops"))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row expanded" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "large-12 columns" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_redux_infinite_scroll___default.a, { holderType: "ul", className: "list-block flex-container", loadMore: function () { return loadMore(meta); }, elementIsScrollable: false, loadingMore: loading, showLoader: false, threshold: 200 }, items.toArray().map(function (shop) {
                    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__container_ShopListItemContainer__["a" /* default */], __assign({}, props, { key: shop.id, shop: shop }));
                }))))));
};
/* harmony default export */ __webpack_exports__["a"] = (ShopListComponent);


/***/ }),

/***/ "./app/client/shop/components/ShopListItemComponent.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ShopBoothCountComponent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/react.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__routes__ = __webpack_require__("./app/client/routes.ts");


var ShopBoothCountComponent = function (props) {
    var shop = props.shop, loadBooths = props.loadBooths;
    if (!shop.boothCollection) {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("td", null));
    }
    else {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("td", null, shop.boothCollection.meta.totalCount + " booth" + (shop.boothCollection.meta.totalCount > 1 ? "s" : "")));
    }
};
var ShopListItemComponent = function (props) {
    var shop = props.shop, viewShop = props.viewShop;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "media-object" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "media-object-section flushed middle" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "img-wrapper small-img-fit" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: shop.imageUrl() }))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "media-object-section middle" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "text-group" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null,
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("b", null, shop.toString())),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("small", { className: "subheader" }, shop.address())))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { href: __WEBPACK_IMPORTED_MODULE_1__routes__["d" /* ShopsRoutes */].view(shop.id), onClick: function (e) { e.preventDefault(); viewShop(shop); }, className: "button primary pull-right" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("i", { className: "fa fa-eye-o" }),
            "\u00A0 View Shop Profile")));
};
/* harmony default export */ __webpack_exports__["a"] = (ShopListItemComponent);


/***/ }),

/***/ "./app/client/shop/components/ShopMapModalComponent.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/react.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__widgets_modal_ModalComponent__ = __webpack_require__("./app/client/_widgets/modal/ModalComponent.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_google_maps__ = __webpack_require__("./node_modules/react-google-maps/lib/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_google_maps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_google_maps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_google_maps_lib_async_withScriptjs__ = __webpack_require__("./node_modules/react-google-maps/lib/async/withScriptjs.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_google_maps_lib_async_withScriptjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_google_maps_lib_async_withScriptjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__("./node_modules/lodash/lodash.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__widgets_loadingIndicator_LoadingIndicatorComponent__ = __webpack_require__("./app/client/_widgets/loadingIndicator/LoadingIndicatorComponent.tsx");
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};






var AsyncShopMap = __WEBPACK_IMPORTED_MODULE_4_lodash__["flowRight"](__WEBPACK_IMPORTED_MODULE_3_react_google_maps_lib_async_withScriptjs___default.a, __WEBPACK_IMPORTED_MODULE_2_react_google_maps__["withGoogleMap"])(function (props) {
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_google_maps__["GoogleMap"], { defaultZoom: 15, center: props.center }, props.markers.map(function (marker) { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_google_maps__["Marker"], __assign({}, marker))); })));
});
var ShopMapModalComponent = function (props) {
    var active = props.active, close = props.close, shop = props.shop;
    var markers = [{
            position: {
                lat: shop.latitude,
                lng: shop.longitude,
            },
            key: "shop_marker_" + shop.id,
            defaultAnimation: 2
        }];
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__widgets_modal_ModalComponent__["a" /* default */], { show: active, onExit: close, size: __WEBPACK_IMPORTED_MODULE_1__widgets_modal_ModalComponent__["b" /* ModalSizes */].SMALL, className: "" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { id: "followingModal" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "reveal-heading" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h5", null, "View Map"),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", { className: "close-button", type: "button", onClick: function (e) { e.preventDefault(); close(); } },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null, "\u00D7"))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](AsyncShopMap, { googleMapURL: "https://maps.googleapis.com/maps/api/js?v=3.exp&key=AIzaSyBhpGXiYVzuFj5E5ahGg-oVbdvILnpYuG0", loadingElement: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__widgets_loadingIndicator_LoadingIndicatorComponent__["a" /* default */], null), containerElement: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { style: { width: "100%", height: 400 } }), mapElement: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { style: { width: "100%", height: "100%" } }), onMapLoad: __WEBPACK_IMPORTED_MODULE_4_lodash__["noop"], onMapClick: __WEBPACK_IMPORTED_MODULE_4_lodash__["noop"], markers: markers, onMarkerRightClick: __WEBPACK_IMPORTED_MODULE_4_lodash__["noop"], center: { lat: shop.latitude, lng: shop.longitude } }))));
};
/* harmony default export */ __webpack_exports__["a"] = (ShopMapModalComponent);


/***/ }),

/***/ "./app/client/shop/components/ShopProfessionalsComponent.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ShopProfessionalListItemComponent */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ShopProfessionalsComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/react.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__("./node_modules/react-router-dom/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__routes__ = __webpack_require__("./app/client/routes.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_infinite_scroll__ = __webpack_require__("./node_modules/redux-infinite-scroll/lib/ReduxInfiniteScroll.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_infinite_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_redux_infinite_scroll__);




var ShopProfessionalListItemComponent = function (props) {
    var item = props.item;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "media-object" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "media-object-section flushed middle" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "img-wrapper small circle" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: item.profilePicture() }))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "media-object-section middle" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "text-group" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null,
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("b", null, item.username())),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("small", { className: "subheader" }, item.profession)))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */], { to: __WEBPACK_IMPORTED_MODULE_2__routes__["g" /* UsersRoutes */].show(item.id), className: "button primary pull-right" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("i", { className: "fa fa-eye-o" }),
            "\u00A0 View Professional")));
};
var ShopProfessionalsComponent = function (props) {
    var items = props.items, loading = props.loading, loadMore = props.loadMore, meta = props.meta;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_redux_infinite_scroll___default.a, { holderType: "ul", className: "list-block flex-container", loadMore: function () { return loadMore(meta); }, elementIsScrollable: false, loadingMore: loading, showLoader: false, threshold: 200 }, items.map(function (each) {
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ShopProfessionalListItemComponent, { key: "user_" + each.id, item: each });
    })));
};


/***/ }),

/***/ "./app/client/shop/components/ShopViewComponent.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/react.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__("./node_modules/react-router/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__routes__ = __webpack_require__("./app/client/routes.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__widgets_breadcrumbs_BreadcrumbsComponent__ = __webpack_require__("./app/client/_widgets/breadcrumbs/BreadcrumbsComponent.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__container_ShopBoothsContainer__ = __webpack_require__("./app/client/shop/container/ShopBoothsContainer.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__container_ShopProfessionalsContainer__ = __webpack_require__("./app/client/shop/container/ShopProfessionalsContainer.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router_dom__ = __webpack_require__("./node_modules/react-router-dom/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ShopMapModalComponent__ = __webpack_require__("./app/client/shop/components/ShopMapModalComponent.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__widgets_carousel_CarouselComponent__ = __webpack_require__("./app/client/_widgets/carousel/CarouselComponent.tsx");









var ShopViewComponent = function (props) {
    var shop = props.shop, shopOwner = props.shopOwner, toggleMapModal = props.toggleMapModal, activeModal = props.activeModal;
    if (!shop) {
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router__["b" /* Redirect */], { to: { pathname: __WEBPACK_IMPORTED_MODULE_2__routes__["d" /* ShopsRoutes */].index(), state: { refresh: true } } });
    }
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row expanded" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__widgets_breadcrumbs_BreadcrumbsComponent__["a" /* default */], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { href: "javascript: history.go(-1)" }, "Back")),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null, shop.name))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row expanded" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "large-12 columns" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "text-group mt-1 mb-1" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h4", null, shop.name),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "subheader" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("i", { className: "fa fa-heart" }),
                        "\u00A0 ",
                        shop.likeCount,
                        " Followers")))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row expanded" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "large-12 columns" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__widgets_carousel_CarouselComponent__["a" /* default */], { images: shop.images }))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row expanded" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "large-12 columns" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "flex-container" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "media-object" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "media-object-section logo middle" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "img-wrapper circle" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: shopOwner.profilePicture() }))),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "media-object-section middle" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "h4" }, shopOwner && shopOwner.username()),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "subheader" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("small", null,
                                    shop.address(),
                                    "\u00A0 ",
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { href: "#", onClick: function (e) { e.preventDefault(); toggleMapModal(activeModal); } }, "View Map"))),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__ShopMapModalComponent__["a" /* default */], { active: activeModal.active, close: function () { toggleMapModal(activeModal); }, shop: shop }))),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_react_router_dom__["b" /* Link */], { to: __WEBPACK_IMPORTED_MODULE_2__routes__["g" /* UsersRoutes */].show(shop.userId), className: "button primary hollow small pull-right" }, "View Profile")))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "large-12 columns" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h6", { className: "page-lead" }, "Booths For Rent"),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__container_ShopBoothsContainer__["a" /* default */], { shop: shop }))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "large-12 columns" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h6", { className: "page-lead" }, "Professionals"),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__container_ShopProfessionalsContainer__["a" /* default */], { shop: shop })))));
};
/* harmony default export */ __webpack_exports__["a"] = (ShopViewComponent);


/***/ }),

/***/ "./app/client/shop/container/ShopBoothsContainer.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__("./node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__booth_middlewares__ = __webpack_require__("./app/client/booth/middlewares.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ShopBoothsComponent__ = __webpack_require__("./app/client/shop/components/ShopBoothsComponent.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data_selectors__ = __webpack_require__("./app/client/_data/selectors.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__selectors__ = __webpack_require__("./app/client/shop/selectors.ts");





var mapDispatchToProps = function (dispatch, props) {
    return {
        loadMore: function (meta) {
            if (meta && meta.hasNext()) {
                dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__booth_middlewares__["a" /* fetchBoothsByShop */])(props.shop.id, meta.cursor, meta.nextPage));
            }
        }
    };
};
var mapStateToProps = function (state, props) {
    var items = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__data_selectors__["j" /* boothsSelector */])(state).filter(function (each) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__selectors__["c" /* shopBoothsSelector */])(state).ids.has(each.id);
    }).toArray();
    return {
        shop: props.shop,
        items: items,
        meta: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__selectors__["c" /* shopBoothsSelector */])(state).meta,
        loading: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__selectors__["c" /* shopBoothsSelector */])(state).loading
    };
};
var ShopBoothsContainer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2__components_ShopBoothsComponent__["a" /* default */]);
/* harmony default export */ __webpack_exports__["a"] = (ShopBoothsContainer);


/***/ }),

/***/ "./app/client/shop/container/ShopListContainer.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__("./node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ShopListComponent__ = __webpack_require__("./app/client/shop/components/ShopListComponent.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__selectors__ = __webpack_require__("./app/client/shop/selectors.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__middlewares__ = __webpack_require__("./app/client/shop/middlewares.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__data_selectors__ = __webpack_require__("./app/client/_data/selectors.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions__ = __webpack_require__("./app/client/shop/actions.ts");






var mapDispatchToProps = function (dispatch, props) {
    return {
        filterByName: function (e) {
            if (e.target.value.length > 2) {
                //dispatch(setMyShopsFilter({filter: e.target.value}));
            }
            dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actions__["l" /* setMyShopsFilter */])({ filter: e.target.value }));
        },
        loadMore: function (meta) {
            if (meta && meta.hasNext()) {
                dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__middlewares__["d" /* fetchShops */])(meta.cursor, meta.nextPage));
            }
        }
    };
};
var mapStateToProps = function (state, props) {
    var shops = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__data_selectors__["l" /* shopsSelector */])(state).filter(function (shop) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__selectors__["d" /* myShopsSelector */])(state).ids.has(shop.id);
    });
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__selectors__["d" /* myShopsSelector */])(state).filter && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__selectors__["d" /* myShopsSelector */])(state).filter.length > 0) {
        var filter_1 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__selectors__["d" /* myShopsSelector */])(state).filter && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__selectors__["d" /* myShopsSelector */])(state).filter.toLowerCase();
        shops = shops.filter(function (shop) {
            return shop.name.toLocaleLowerCase().includes(filter_1);
        });
    }
    return {
        items: shops,
        loading: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__selectors__["d" /* myShopsSelector */])(state).loading,
        meta: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__selectors__["d" /* myShopsSelector */])(state).meta,
        errors: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__selectors__["d" /* myShopsSelector */])(state).errors,
    };
};
var ShopListContainer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__components_ShopListComponent__["a" /* default */]);
/* harmony default export */ __webpack_exports__["a"] = (ShopListContainer);


/***/ }),

/***/ "./app/client/shop/container/ShopListItemContainer.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__("./node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ShopListItemComponent__ = __webpack_require__("./app/client/shop/components/ShopListItemComponent.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__routes__ = __webpack_require__("./app/client/routes.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__middlewares__ = __webpack_require__("./app/client/shop/middlewares.ts");




var mapDispatchToProps = function (dispatch, props) {
    return {
        viewShop: function (shop) {
            dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__middlewares__["b" /* initializeShopProfile */])(shop.id));
            props.history.push(__WEBPACK_IMPORTED_MODULE_2__routes__["d" /* ShopsRoutes */].view(shop.id));
        }
    };
};
var mapStateToProps = function (state, props) {
    return {
        shop: props.shop
    };
};
var ShopListItemContainer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__components_ShopListItemComponent__["a" /* default */]);
/* harmony default export */ __webpack_exports__["a"] = (ShopListItemContainer);


/***/ }),

/***/ "./app/client/shop/container/ShopProfessionalsContainer.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__("./node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ShopProfessionalsComponent__ = __webpack_require__("./app/client/shop/components/ShopProfessionalsComponent.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_models_User__ = __webpack_require__("./app/client/_data/models/User.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data_selectors__ = __webpack_require__("./app/client/_data/selectors.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__selectors__ = __webpack_require__("./app/client/shop/selectors.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__middlewares__ = __webpack_require__("./app/client/shop/middlewares.ts");






var mapDispatchToProps = function (dispatch, props) {
    return {
        loadMore: function (meta) {
            if (meta && meta.hasNext()) {
                dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__middlewares__["c" /* fetchShopProfessionals */])(props.shop.id, meta.cursor, meta.nextPage));
            }
        }
    };
};
var mapStateToProps = function (state, props) {
    var items = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__data_selectors__["i" /* usersSelector */])(state).filter(function (each) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__selectors__["b" /* shopProfileProfessionalSelector */])(state).ids.has(each.id) && each instanceof __WEBPACK_IMPORTED_MODULE_2__data_models_User__["a" /* default */];
    }).toArray();
    return {
        items: items,
        meta: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__selectors__["b" /* shopProfileProfessionalSelector */])(state).meta,
        loading: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__selectors__["b" /* shopProfileProfessionalSelector */])(state).loading
    };
};
var ShopProfessionalsContainer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__components_ShopProfessionalsComponent__["a" /* ShopProfessionalsComponent */]);
/* harmony default export */ __webpack_exports__["a"] = (ShopProfessionalsContainer);


/***/ }),

/***/ "./app/client/shop/container/ShopViewContainer.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__("./node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ShopViewComponent__ = __webpack_require__("./app/client/shop/components/ShopViewComponent.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_selectors__ = __webpack_require__("./app/client/_data/selectors.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__widgets_modal_actions__ = __webpack_require__("./app/client/_widgets/modal/actions.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__selectors__ = __webpack_require__("./app/client/shop/selectors.ts");





var mapDispatchToProps = function (dispatch, props) {
    return {
        toggleMapModal: function (modalState) {
            if (modalState.key != "shop.map") {
                // reinit modal state if previously opened modal is not this modal
                modalState.key = "shop.map";
                modalState.active = false;
            }
            dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__widgets_modal_actions__["a" /* toggleActiveModal */])({
                key: modalState.key,
                active: !modalState.active
            }));
        }
    };
};
var mapStateToProps = function (state, props) {
    var shop = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__data_selectors__["g" /* shopByIdSelector */])(state, parseInt(props.match.params.shopId));
    return {
        shop: shop,
        shopOwner: shop && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__data_selectors__["c" /* userByIdSelector */])(state, shop.userId),
        activeModal: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__selectors__["a" /* shopProfileActiveModalSelector */])(state)
    };
};
var ShopViewContainer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__components_ShopViewComponent__["a" /* default */]);
/* harmony default export */ __webpack_exports__["a"] = (ShopViewContainer);


/***/ }),

/***/ "./app/client/shop/middlewares.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = refreshShops;
/* harmony export (immutable) */ __webpack_exports__["b"] = initializeShopProfile;
/* harmony export (immutable) */ __webpack_exports__["d"] = fetchShops;
/* harmony export (immutable) */ __webpack_exports__["c"] = fetchShopProfessionals;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__("./app/client/shop/actions.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__repositories_shopRepository__ = __webpack_require__("./app/client/_repositories/shopRepository.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_class_transformer__ = __webpack_require__("./node_modules/class-transformer/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_class_transformer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_class_transformer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data_models_Meta__ = __webpack_require__("./app/client/_data/models/Meta.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_utils__ = __webpack_require__("./app/client/_helpers/utils.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__data_actions__ = __webpack_require__("./app/client/_data/actions.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_data__ = __webpack_require__("./app/client/_helpers/data.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash__ = __webpack_require__("./node_modules/lodash/lodash.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_immutable__ = __webpack_require__("./node_modules/immutable/dist/immutable.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__booth_middlewares__ = __webpack_require__("./app/client/booth/middlewares.ts");










function refreshShops() {
    return function (dispatch) {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__actions__["a" /* invalidateShops */])());
        return dispatch(fetchShops());
    };
}
function initializeShopProfile(shopId) {
    return function (dispatch) {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__booth_middlewares__["a" /* fetchBoothsByShop */])(shopId));
        dispatch(fetchShopProfessionals(shopId));
        return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__actions__["b" /* clearShopProfile */])());
    };
}
function fetchShops(cursor, page) {
    if (cursor === void 0) { cursor = null; }
    if (page === void 0) { page = null; }
    return function (dispatch) {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__actions__["c" /* requestStarted */])());
        __WEBPACK_IMPORTED_MODULE_1__repositories_shopRepository__["a" /* default */].listByUser(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__helpers_utils__["f" /* getCurrentUser */])(), cursor, page, 25)
            .then(function (data) {
            var salons = data.salons, meta = data.meta;
            // Todo: handle errors
            if (data.error) {
                return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__actions__["d" /* requestFailed */])({ requestErrors: ["Failed to retrieve salons."] }));
            }
            var shopIds = __WEBPACK_IMPORTED_MODULE_7_lodash__["map"](salons, function (each) {
                return [each["id"], parseInt(each["id"])];
            });
            dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__data_actions__["a" /* addDataAction */])({
                resource: __WEBPACK_IMPORTED_MODULE_6__helpers_data__["a" /* ResourceType */].shop,
                data: salons
            }));
            dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__actions__["e" /* didReceiveShops */])({
                ids: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_immutable__["Map"])(shopIds),
                meta: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_class_transformer__["plainToClass"])(__WEBPACK_IMPORTED_MODULE_3__data_models_Meta__["a" /* default */], meta),
            }));
            return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__actions__["f" /* requestSucceeded */])());
        });
    };
}
function fetchShopProfessionals(shopId, cursor, page) {
    if (cursor === void 0) { cursor = null; }
    if (page === void 0) { page = null; }
    return function (dispatch) {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__actions__["g" /* requestShopProfessionals */])());
        __WEBPACK_IMPORTED_MODULE_1__repositories_shopRepository__["a" /* default */].getShopProfessionals(shopId, cursor, page, 25)
            .then(function (data) {
            var professionals = data.professionals, meta = data.meta;
            var userIds = __WEBPACK_IMPORTED_MODULE_7_lodash__["map"](professionals, function (each) {
                return [each["id"], parseInt(each["id"])];
            });
            dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__data_actions__["a" /* addDataAction */])({
                resource: __WEBPACK_IMPORTED_MODULE_6__helpers_data__["a" /* ResourceType */].user,
                data: professionals
            }));
            return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__actions__["h" /* didReceiveShopProfessionals */])({
                ids: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_immutable__["Map"])(userIds),
                meta: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_class_transformer__["plainToClass"])(__WEBPACK_IMPORTED_MODULE_3__data_models_Meta__["a" /* default */], meta)
            }));
        });
    };
}


/***/ }),

/***/ "./app/client/shop/reducers.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return myShopsReducer; });
/* unused harmony export shopProfessionals */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return shopProfileReducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__("./node_modules/redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__("./app/client/shop/actions.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__("./node_modules/immutable/dist/immutable.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__booth_reducers__ = __webpack_require__("./app/client/booth/reducers.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__widgets_modal_reducer__ = __webpack_require__("./app/client/_widgets/modal/reducer.ts");





var myShopsReducer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux__["b" /* combineReducers */])({
    ids: myShopsList,
    filter: shopsListFilter,
    meta: meta,
    loading: loading,
    errors: errors
});
/* unused harmony default export */ var _unused_webpack_default_export = (myShopsReducer);
function shopsListFilter(state, action) {
    if (state === void 0) { state = null; }
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_1__actions__["l" /* setMyShopsFilter */].toString(): {
            return action.payload.filter;
        }
        case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* invalidateShops */].toString(): {
            return null;
        }
    }
    return state;
}
//-- start shop professionals reducers
var shopProfessionals = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux__["b" /* combineReducers */])({
    ids: shopProfessionalItems,
    meta: shopProfessionalMeta,
    loading: shopProfessionalIsLoading
});
function shopProfessionalItems(state, action) {
    if (state === void 0) { state = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])(); }
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_1__actions__["h" /* didReceiveShopProfessionals */].toString():
            return state.mergeDeep(action.payload.ids);
        case __WEBPACK_IMPORTED_MODULE_1__actions__["b" /* clearShopProfile */].toString():
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])();
    }
    return state;
}
function shopProfessionalMeta(state, action) {
    if (state === void 0) { state = null; }
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_1__actions__["h" /* didReceiveShopProfessionals */].toString():
            return action.payload.meta;
    }
    return state;
}
function shopProfessionalIsLoading(state, action) {
    if (state === void 0) { state = false; }
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_1__actions__["g" /* requestShopProfessionals */].toString():
            return true;
        case __WEBPACK_IMPORTED_MODULE_1__actions__["h" /* didReceiveShopProfessionals */].toString():
            return false;
    }
    return state;
}
//-- end shop professionals reducers
//-- shop profile
var shopProfileReducer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux__["b" /* combineReducers */])({
    professionals: shopProfessionals,
    booths: __WEBPACK_IMPORTED_MODULE_3__booth_reducers__["a" /* boothCollectionReducer */],
    activeModal: __WEBPACK_IMPORTED_MODULE_4__widgets_modal_reducer__["a" /* default */]
});
function myShopsList(state, action) {
    if (state === void 0) { state = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])(); }
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* invalidateShops */].toString():
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])();
        case __WEBPACK_IMPORTED_MODULE_1__actions__["e" /* didReceiveShops */].toString():
            return state.mergeDeep(action.payload.ids);
    }
    return state;
}
function errors(state, action) {
    if (state === void 0) { state = []; }
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_1__actions__["c" /* requestStarted */].toString():
            return [];
        case __WEBPACK_IMPORTED_MODULE_1__actions__["f" /* requestSucceeded */].toString():
            return [];
        case __WEBPACK_IMPORTED_MODULE_1__actions__["d" /* requestFailed */].toString():
            return action.payload.requestErrors;
    }
    return state;
}
function loading(state, action) {
    if (state === void 0) { state = false; }
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_1__actions__["c" /* requestStarted */].toString():
            return true;
        case __WEBPACK_IMPORTED_MODULE_1__actions__["f" /* requestSucceeded */].toString():
            return false;
        case __WEBPACK_IMPORTED_MODULE_1__actions__["d" /* requestFailed */].toString():
            return false;
    }
    return state;
}
function meta(state, action) {
    if (state === void 0) { state = null; }
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_1__actions__["e" /* didReceiveShops */].toString():
            return action.payload.meta;
    }
    return state;
}


/***/ }),

/***/ "./app/client/shop/selectors.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return myShopsSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return shopProfileActiveModalSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return shopProfileProfessionalSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return shopBoothsSelector; });
var myShopsSelector = function (state) { return state.myShops; };
// shop profile selectors
var shopProfileActiveModalSelector = function (state) { return state.shopProfile.activeModal; };
var shopProfileProfessionalSelector = function (state) { return state.shopProfile.professionals; };
var shopBoothsSelector = function (state) { return state.shopProfile.booths; };


/***/ }),

/***/ "./app/client/special/actions.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return didReceiveSpecial; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return clearSpecial; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return didReceiveSpecials; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return clearSpecials; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return requestFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return requestStarted; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return requestSucceeded; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__("./node_modules/redux-actions/es/index.js");

var didReceiveSpecial = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('RECEIVE_SPECIAL');
var clearSpecial = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('CLEAR_SPECIAL');
var didReceiveSpecials = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('RECEIVE_SPECIALS');
var clearSpecials = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('CLEAR_SPECIALS');
var requestFailed = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])("REQUEST_FAILED");
var requestStarted = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])("REQUEST_STARTED");
var requestSucceeded = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])("REQUEST_SUCCEEDED");


/***/ }),

/***/ "./app/client/special/components/SpecialItemComponent.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/react.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__widgets_loadingIndicator_LoadingIndicatorComponent__ = __webpack_require__("./app/client/_widgets/loadingIndicator/LoadingIndicatorComponent.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__widgets_user_UserProfileHeaderComponent__ = __webpack_require__("./app/client/_widgets/user/UserProfileHeaderComponent.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__widgets_like_LikeContainer__ = __webpack_require__("./app/client/_widgets/like/LikeContainer.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__widgets_breadcrumbs_BreadcrumbsComponent__ = __webpack_require__("./app/client/_widgets/breadcrumbs/BreadcrumbsComponent.tsx");





var SpecialModalComponent = function (props) {
    var item = props.item, loading = props.loading;
    if (loading) {
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__widgets_loadingIndicator_LoadingIndicatorComponent__["a" /* default */], null));
    }
    if (!item)
        return null;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__widgets_breadcrumbs_BreadcrumbsComponent__["a" /* default */], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { href: "javascript: history.go(-1)" }, "Back")),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null, "View Special"))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__widgets_user_UserProfileHeaderComponent__["a" /* default */], { user: item.user }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "large-12 columns" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "newsfeed-panel callout paddingless mb-half" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row p1" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "large-12 columns paddingless bt-1 bb-1 p2 specials" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "text-center" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", null, item.title),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { style: { wordWrap: 'break-word' } }, item.description),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("small", null,
                                    "Starts on ",
                                    item.prettyStartDate(),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("br", null),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null, item.prettyEndDateString()))))),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row p1" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "large-12 columns" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("ul", { className: "list-inline marginless newsfeed-lgfont" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__widgets_like_LikeContainer__["a" /* default */], { model: item })))))))));
};
/* harmony default export */ __webpack_exports__["a"] = (SpecialModalComponent);


/***/ }),

/***/ "./app/client/special/components/SpecialsComponent.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/react.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__routes__ = __webpack_require__("./app/client/routes.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__("./node_modules/react-router-dom/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_infinite_scroll__ = __webpack_require__("./node_modules/redux-infinite-scroll/lib/ReduxInfiniteScroll.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_infinite_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_redux_infinite_scroll__);




var handleOnClickViewSpecials = function (specialsTab, props) {
    props.viewSpecials(specialsTab);
};
var SpecialsComponent = function (specialComponentProps) {
    var items = specialComponentProps.items, currentPath = specialComponentProps.currentPath, loading = specialComponentProps.loading, loadMore = specialComponentProps.loadMore, meta = specialComponentProps.meta;
    var specialsList;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "large-12 columns" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("ul", { className: "tabs expanded mt-2", "data-tabs": true, id: "users" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", { className: "tabs-title text-center", onClick: function (e) { return handleOnClickViewSpecials(null, specialComponentProps); } },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Link */], { to: __WEBPACK_IMPORTED_MODULE_1__routes__["e" /* SpecialsRoutes */].index(), "aria-selected": (currentPath == __WEBPACK_IMPORTED_MODULE_1__routes__["e" /* SpecialsRoutes */].index() ? 'true' : 'false') }, "My Specials")),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", { className: "tabs-title text-center", onClick: function (e) { return handleOnClickViewSpecials('liked', specialComponentProps); } },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { href: "#", "aria-selected": (currentPath == __WEBPACK_IMPORTED_MODULE_1__routes__["e" /* SpecialsRoutes */].tab('liked') ? 'true' : 'false') }, "Liked Specials")),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", { className: "tabs-title text-center", onClick: function (e) { return handleOnClickViewSpecials('expired', specialComponentProps); } },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { href: "#", "aria-selected": (currentPath == __WEBPACK_IMPORTED_MODULE_1__routes__["e" /* SpecialsRoutes */].tab('expired') ? 'true' : 'false') }, "Expired"))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "tabs-content", "data-tabs-content": "users" },
                specialsList,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_redux_infinite_scroll___default.a, { holderType: "ul", className: "list-block flex-container", loadMore: function () { return loadMore(meta, currentPath); }, elementIsScrollable: false, loadingMore: loading, showLoader: false, threshold: 100 }, items.toArray().map(function (item) {
                    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", { key: item.id },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "media-object" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "media-object-section flushed middle" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "img-wrapper small" },
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: item.user.profilePicture() }))),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "media-object-section middle" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "text-group" },
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null,
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("b", null, item.title)),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "subheader" },
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("small", null, item.prettyEndDateString())),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "subheader" },
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("small", null,
                                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("i", { className: "fa fa-heart" }),
                                            " \u00A0 ",
                                            item.likeCount > 1 ? item.likeCount + ' Likes' : item.likeCount + ' Like'))))),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Link */], { to: __WEBPACK_IMPORTED_MODULE_1__routes__["e" /* SpecialsRoutes */].view(item.id), className: "button primary pull-right" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("i", { className: "fa fa-eye-o" }),
                            "\u00A0 View Special")));
                }))))));
};
/* harmony default export */ __webpack_exports__["a"] = (SpecialsComponent);


/***/ }),

/***/ "./app/client/special/containers/SpecialItemContainer.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__("./node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_SpecialItemComponent__ = __webpack_require__("./app/client/special/components/SpecialItemComponent.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__selectors__ = __webpack_require__("./app/client/special/selectors.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data_selectors__ = __webpack_require__("./app/client/_data/selectors.ts");




var mapStateToProps = function (state, props) {
    var special = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__data_selectors__["h" /* specialByIdSelector */])(state, parseInt(props.match.params.id));
    return {
        item: special,
        loading: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__selectors__["a" /* selectorLoadingSpecial */])(state),
    };
};
var mapDispatchToProps = function (dispatch, ownProps) {
    return {
        dispatch: dispatch,
    };
};
var SpecialItemContainer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__components_SpecialItemComponent__["a" /* default */]);
/* harmony default export */ __webpack_exports__["a"] = (SpecialItemContainer);


/***/ }),

/***/ "./app/client/special/containers/SpecialsContainer.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__("./node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_SpecialsComponent__ = __webpack_require__("./app/client/special/components/SpecialsComponent.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_redux__ = __webpack_require__("./node_modules/react-router-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__routes__ = __webpack_require__("./app/client/routes.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__selectors__ = __webpack_require__("./app/client/special/selectors.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__middlewares__ = __webpack_require__("./app/client/special/middlewares.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions__ = __webpack_require__("./app/client/special/actions.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_routerSelectors__ = __webpack_require__("./app/client/_helpers/routerSelectors.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__data_selectors__ = __webpack_require__("./app/client/_data/selectors.ts");









var mapStateToProps = function (state, ownProps) {
    var specials = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__selectors__["b" /* mySpecialsSelector */])(state).ids.map(function (id) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__data_selectors__["h" /* specialByIdSelector */])(state, id);
    });
    return {
        items: specials,
        loading: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__selectors__["b" /* mySpecialsSelector */])(state).loading,
        meta: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__selectors__["b" /* mySpecialsSelector */])(state).meta,
        errors: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__selectors__["b" /* mySpecialsSelector */])(state).errors,
        currentPath: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__helpers_routerSelectors__["a" /* currentPathSelector */])(state),
    };
};
var mapDispatchToProps = function (dispatch, ownProps) {
    return {
        dispatch: dispatch,
        viewSpecials: function (specialType) {
            dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actions__["a" /* clearSpecials */])());
            switch (specialType) {
                case "liked":
                    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__middlewares__["d" /* fetchLikedSpecialsByUser */])());
                    break;
                case "expired":
                    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__middlewares__["e" /* fetchExpiredSpecialsByUser */])());
                    break;
                default:
                    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__middlewares__["f" /* fetchSpecialsByUser */])());
                    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_router_redux__["d" /* push */])(__WEBPACK_IMPORTED_MODULE_3__routes__["e" /* SpecialsRoutes */].index()));
                    return;
            }
            dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_router_redux__["d" /* push */])(__WEBPACK_IMPORTED_MODULE_3__routes__["e" /* SpecialsRoutes */].tab(specialType)));
        },
        loadMore: function (meta, currentPath) {
            if (meta && meta.hasNext()) {
                switch (currentPath) {
                    case __WEBPACK_IMPORTED_MODULE_3__routes__["e" /* SpecialsRoutes */].tab('liked'):
                        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__middlewares__["d" /* fetchLikedSpecialsByUser */])(meta.cursor, meta.nextPage));
                        break;
                    case __WEBPACK_IMPORTED_MODULE_3__routes__["e" /* SpecialsRoutes */].tab('expired'):
                        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__middlewares__["e" /* fetchExpiredSpecialsByUser */])(meta.cursor, meta.nextPage));
                        break;
                    default:
                        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__middlewares__["f" /* fetchSpecialsByUser */])(meta.cursor, meta.nextPage));
                        return;
                }
            }
        }
    };
};
var SpecialsContainer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__components_SpecialsComponent__["a" /* default */]);
/* harmony default export */ __webpack_exports__["a"] = (SpecialsContainer);


/***/ }),

/***/ "./app/client/special/middlewares.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = initializeSpecials;
/* harmony export (immutable) */ __webpack_exports__["c"] = initializeSpecial;
/* harmony export (immutable) */ __webpack_exports__["b"] = initializeSpecialsType;
/* unused harmony export fetchSpecialBy */
/* harmony export (immutable) */ __webpack_exports__["f"] = fetchSpecialsByUser;
/* harmony export (immutable) */ __webpack_exports__["e"] = fetchExpiredSpecialsByUser;
/* harmony export (immutable) */ __webpack_exports__["d"] = fetchLikedSpecialsByUser;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__("./app/client/special/actions.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__repositories_specialRepository__ = __webpack_require__("./app/client/_repositories/specialRepository.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_class_transformer__ = __webpack_require__("./node_modules/class-transformer/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_class_transformer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_class_transformer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_utils__ = __webpack_require__("./app/client/_helpers/utils.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__data_models_Meta__ = __webpack_require__("./app/client/_data/models/Meta.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__("./node_modules/lodash/lodash.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_data__ = __webpack_require__("./app/client/_helpers/data.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__data_actions__ = __webpack_require__("./app/client/_data/actions.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__data_selectors__ = __webpack_require__("./app/client/_data/selectors.ts");









function initializeSpecials() {
    return function (dispatch) {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__actions__["a" /* clearSpecials */])());
        dispatch(fetchSpecialsByUser());
    };
}
function initializeSpecial(id) {
    return function (dispatch) {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__actions__["b" /* clearSpecial */])());
        dispatch(fetchSpecialBy(id));
    };
}
function initializeSpecialsType(type) {
    return function (dispatch) {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__actions__["a" /* clearSpecials */])());
        switch (type.toString()) {
            case "liked":
                dispatch(fetchLikedSpecialsByUser());
                break;
            case "expired":
                dispatch(fetchExpiredSpecialsByUser());
                break;
            default:
                dispatch(fetchSpecialsByUser());
                return;
        }
    };
}
function fetchSpecialBy(id) {
    return function (dispatch, getState) {
        var special = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__data_selectors__["h" /* specialByIdSelector */])(getState(), parseInt(id));
        if (!special) {
            dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__actions__["b" /* clearSpecial */])());
            dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__actions__["c" /* requestStarted */])());
            __WEBPACK_IMPORTED_MODULE_1__repositories_specialRepository__["a" /* default */].getById(id).then(function (data) {
                var special = data.special;
                if (data.error) {
                    return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__actions__["d" /* requestFailed */])({ requestErrors: ["Failed to retrieve styles."] }));
                }
                dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__data_actions__["a" /* addDataAction */])({
                    resource: __WEBPACK_IMPORTED_MODULE_6__helpers_data__["a" /* ResourceType */].special,
                    data: [special]
                }));
                dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__actions__["e" /* didReceiveSpecial */])({
                    id: special.id,
                }));
                return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__actions__["f" /* requestSucceeded */])());
            });
        }
    };
}
function fetchSpecialsByUser(cursor, page, perPage) {
    if (cursor === void 0) { cursor = null; }
    if (page === void 0) { page = null; }
    if (perPage === void 0) { perPage = 5; }
    return function (dispatch, getState) {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__actions__["c" /* requestStarted */])());
        __WEBPACK_IMPORTED_MODULE_1__repositories_specialRepository__["a" /* default */].getByUserId(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__helpers_utils__["f" /* getCurrentUser */])(), cursor, page, perPage).then(function (data) {
            var specials = data.specials, meta = data.meta;
            if (data.error) {
                return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__actions__["d" /* requestFailed */])({ requestErrors: ["Failed to retrieve specials."] }));
            }
            var specialIds = __WEBPACK_IMPORTED_MODULE_5_lodash__["map"](specials, function (each) {
                return [each["id"], parseInt(each["id"])];
            });
            dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__data_actions__["a" /* addDataAction */])({
                resource: __WEBPACK_IMPORTED_MODULE_6__helpers_data__["a" /* ResourceType */].special,
                data: specials
            }));
            dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__actions__["g" /* didReceiveSpecials */])({
                ids: specialIds,
                meta: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_class_transformer__["plainToClass"])(__WEBPACK_IMPORTED_MODULE_4__data_models_Meta__["a" /* default */], meta),
            }));
            return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__actions__["f" /* requestSucceeded */])());
        });
    };
}
function fetchExpiredSpecialsByUser(cursor, page, perPage) {
    if (cursor === void 0) { cursor = null; }
    if (page === void 0) { page = null; }
    if (perPage === void 0) { perPage = 5; }
    return function (dispatch, getState) {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__actions__["c" /* requestStarted */])());
        __WEBPACK_IMPORTED_MODULE_1__repositories_specialRepository__["a" /* default */].getExpiredSpecialsByUserId(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__helpers_utils__["f" /* getCurrentUser */])(), cursor, page, perPage).then(function (data) {
            var expired_specials = data.expired_specials, meta = data.meta;
            if (data.error) {
                return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__actions__["d" /* requestFailed */])({ requestErrors: ["Failed to retrieve specials."] }));
            }
            var specialIds = __WEBPACK_IMPORTED_MODULE_5_lodash__["map"](expired_specials, function (each) {
                return [each["id"], parseInt(each["id"])];
            });
            dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__data_actions__["a" /* addDataAction */])({
                resource: __WEBPACK_IMPORTED_MODULE_6__helpers_data__["a" /* ResourceType */].special,
                data: expired_specials
            }));
            dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__actions__["g" /* didReceiveSpecials */])({
                ids: specialIds,
                meta: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_class_transformer__["plainToClass"])(__WEBPACK_IMPORTED_MODULE_4__data_models_Meta__["a" /* default */], meta),
            }));
            return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__actions__["f" /* requestSucceeded */])());
        });
    };
}
function fetchLikedSpecialsByUser(cursor, page, perPage) {
    if (cursor === void 0) { cursor = null; }
    if (page === void 0) { page = null; }
    if (perPage === void 0) { perPage = 5; }
    return function (dispatch, getState) {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__actions__["c" /* requestStarted */])());
        __WEBPACK_IMPORTED_MODULE_1__repositories_specialRepository__["a" /* default */].getLikedSpecialsByUserId(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__helpers_utils__["f" /* getCurrentUser */])(), cursor, page, perPage).then(function (data) {
            var liked_specials = data.liked_specials, meta = data.meta;
            if (data.error) {
                return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__actions__["d" /* requestFailed */])({ requestErrors: ["Failed to retrieve specials."] }));
            }
            var specialIds = __WEBPACK_IMPORTED_MODULE_5_lodash__["map"](liked_specials, function (each) {
                return [each["id"], parseInt(each["id"])];
            });
            dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__data_actions__["a" /* addDataAction */])({
                resource: __WEBPACK_IMPORTED_MODULE_6__helpers_data__["a" /* ResourceType */].special,
                data: liked_specials
            }));
            dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__actions__["g" /* didReceiveSpecials */])({
                ids: specialIds,
                meta: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_class_transformer__["plainToClass"])(__WEBPACK_IMPORTED_MODULE_4__data_models_Meta__["a" /* default */], meta),
            }));
            return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__actions__["f" /* requestSucceeded */])());
        });
    };
}


/***/ }),

/***/ "./app/client/special/reducers.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return specialReducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__("./app/client/special/actions.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__("./node_modules/redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__("./node_modules/immutable/dist/immutable.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);



//reducers
var mySpecialsReducer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux__["b" /* combineReducers */])({
    ids: items,
    meta: meta,
    loading: loading,
    errors: errors
});
var specialReducer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux__["b" /* combineReducers */])({
    item: item,
    loading: loading,
});

/* harmony default export */ __webpack_exports__["a"] = (mySpecialsReducer);
function loading(state, action) {
    if (state === void 0) { state = false; }
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0__actions__["c" /* requestStarted */].toString():
            return true;
        case __WEBPACK_IMPORTED_MODULE_0__actions__["f" /* requestSucceeded */].toString():
            return false;
    }
    return false;
}
function meta(state, action) {
    if (state === void 0) { state = null; }
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0__actions__["g" /* didReceiveSpecials */].toString():
            return action.payload.meta;
    }
    return state;
}
function items(state, action) {
    if (state === void 0) { state = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_immutable__["OrderedMap"])(); }
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* clearSpecials */].toString():
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_immutable__["OrderedMap"])();
        case __WEBPACK_IMPORTED_MODULE_0__actions__["g" /* didReceiveSpecials */].toString():
            return state.mergeDeep(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])(action.payload.ids));
    }
    return state;
}
function item(state, action) {
    if (state === void 0) { state = null; }
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0__actions__["b" /* clearSpecial */].toString():
            return null;
        case __WEBPACK_IMPORTED_MODULE_0__actions__["e" /* didReceiveSpecial */].toString():
            return action.payload.id;
    }
    return state;
}
function errors(state, action) {
    if (state === void 0) { state = []; }
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0__actions__["c" /* requestStarted */].toString():
            return [];
        case __WEBPACK_IMPORTED_MODULE_0__actions__["f" /* requestSucceeded */].toString():
            return [];
        case __WEBPACK_IMPORTED_MODULE_0__actions__["d" /* requestFailed */].toString():
            return action.payload.requestErrors;
    }
    return state;
}


/***/ }),

/***/ "./app/client/special/selectors.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return mySpecialsSelector; });
/* unused harmony export selectorSpecial */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return selectorLoadingSpecial; });
var mySpecialsSelector = function (state) { return state.mySpecials; };
var selectorSpecial = function (state) { return state.mySpecials; };
var selectorLoadingSpecial = function (state) { return state.mySpecials.loading; };


/***/ }),

/***/ "./app/client/style/actions.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return clearStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return clearStyles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return saveScrollpos; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return requestFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return requestStarted; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return requestSucceeded; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return didReceiveStyles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return didReceiveStyle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__("./node_modules/redux-actions/es/index.js");

var clearStyle = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('CLEAR_STYLE');
var clearStyles = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('CLEAR_STYLES');
var saveScrollpos = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('SAVE_SCROLLPOS_ACTION');
var requestFailed = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])("REQUEST_FAILED");
var requestStarted = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])("REQUEST_STARTED");
var requestSucceeded = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])("REQUEST_SUCCEEDED");
var didReceiveStyles = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])("RECEIVE_STYLES");
var didReceiveStyle = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])("RECEIVE_STYLE");


/***/ }),

/***/ "./app/client/style/components/MyStylesComponent.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/react.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MyStylesGalleryComponent__ = __webpack_require__("./app/client/style/components/MyStylesGalleryComponent.tsx");
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};


var scrollToLastScrollPosition = function (props) {
    window.scrollTo(0, props.scrollPosition);
};
var MyStylesComponent = function (props) {
    var items = props.items;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row", onLoad: function () {
            scrollToLastScrollPosition(props);
        } },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "large-12 columns" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "callout mt-1" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__MyStylesGalleryComponent__["a" /* default */], __assign({}, props))))));
};
/* harmony default export */ __webpack_exports__["a"] = (MyStylesComponent);


/***/ }),

/***/ "./app/client/style/components/MyStylesGalleryComponent.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/react.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MyStylesGalleryImageComponent__ = __webpack_require__("./app/client/style/components/MyStylesGalleryImageComponent.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_infinite_scroll__ = __webpack_require__("./node_modules/redux-infinite-scroll/lib/ReduxInfiniteScroll.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_infinite_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_redux_infinite_scroll__);



var MyStylesGalleryComponent = function (props) {
    var items = props.items, loading = props.loading, loadMore = props.loadMore, meta = props.meta;
    var count = 0;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "featured-image-block-grid" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_redux_infinite_scroll___default.a, { holderType: "div", className: "row large-up-3 small-up-1", loadMore: function () { return loadMore(meta); }, elementIsScrollable: false, loadingMore: loading, showLoader: false, threshold: 100 }, items.toArray().map(function (item) {
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__MyStylesGalleryImageComponent__["a" /* default */], { item: item, key: count++ });
        }))));
};
/* harmony default export */ __webpack_exports__["a"] = (MyStylesGalleryComponent);


/***/ }),

/***/ "./app/client/style/components/MyStylesGalleryImageComponent.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/react.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__("./node_modules/react-router-dom/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__routes__ = __webpack_require__("./app/client/routes.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__widgets_like_LikeContainer__ = __webpack_require__("./app/client/_widgets/like/LikeContainer.tsx");




var MyStylesGalleryImageComponent = function (props) {
    var item = props.item;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "featured-image-block column" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */], { to: __WEBPACK_IMPORTED_MODULE_2__routes__["a" /* StylesRoutes */].showStyle(item.user.name, item.id) },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: item.primaryPictureUrl, alt: item.description })),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__widgets_like_LikeContainer__["a" /* default */], { model: item, isGalleryView: true })));
};
/* harmony default export */ __webpack_exports__["a"] = (MyStylesGalleryImageComponent);


/***/ }),

/***/ "./app/client/style/components/StyleComponent.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/react.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_utils__ = __webpack_require__("./app/client/_helpers/utils.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__comment_containers_CommentsContainer__ = __webpack_require__("./app/client/comment/containers/CommentsContainer.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__widgets_user_UserProfileHeaderComponent__ = __webpack_require__("./app/client/_widgets/user/UserProfileHeaderComponent.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__widgets_like_LikeContainer__ = __webpack_require__("./app/client/_widgets/like/LikeContainer.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__widgets_breadcrumbs_BreadcrumbsComponent__ = __webpack_require__("./app/client/_widgets/breadcrumbs/BreadcrumbsComponent.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__widgets_loadingIndicator_LoadingIndicatorComponent__ = __webpack_require__("./app/client/_widgets/loadingIndicator/LoadingIndicatorComponent.tsx");







var StyleComponent = function (props) {
    var style = props.style, loading = props.loading, comments = props.comments, loadMoreComments = props.loadMoreComments, notFoundStyle = props.notFoundStyle;
    if (!style && loading)
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row expanded" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__widgets_loadingIndicator_LoadingIndicatorComponent__["a" /* default */], { message: "Loading Style..." })));
    else if ((!loading && notFoundStyle) || (!loading && style === undefined))
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row expanded", style: { paddingLeft: '1rem', paddingTop: '1rem' } },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h1", null, "Style not found. :(")));
    else
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__widgets_breadcrumbs_BreadcrumbsComponent__["a" /* default */], null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null,
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { href: "javascript: history.go(-1)" }, "Back")),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null, "View Image"))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__widgets_user_UserProfileHeaderComponent__["a" /* default */], { user: style.user }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row newsfeed-modal" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "large-12 columns" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "callout" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "large-6 columns main-post" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "post-img v-align-center" },
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: style.primaryPictureUrl, alt: "" }))),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "large-6 columns" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row p1 bb-1" },
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "large-12 columns paddingless" },
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "mt-1", style: { wordWrap: 'break-word' } }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_utils__["o" /* formatWithTags */])(style.description)))),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row bb-1" },
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "large-12 columns pt-half pb-half" },
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("ul", { className: "list-inline marginless newsfeed-rgfont" },
                                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__widgets_like_LikeContainer__["a" /* default */], { model: style }),
                                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null,
                                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("i", { className: "fa fa-comment-o fa-fw" }),
                                                " ",
                                                style.commentCount,
                                                " Comments")))),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__comment_containers_CommentsContainer__["a" /* default */], { items: comments, loadMoreComments: loadMoreComments }))))))));
};
/* harmony default export */ __webpack_exports__["a"] = (StyleComponent);


/***/ }),

/***/ "./app/client/style/containers/MyStylesContainer.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__("./node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_MyStylesComponent__ = __webpack_require__("./app/client/style/components/MyStylesComponent.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__selectors__ = __webpack_require__("./app/client/style/selectors.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data_selectors__ = __webpack_require__("./app/client/_data/selectors.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__middlewares__ = __webpack_require__("./app/client/style/middlewares.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_utils__ = __webpack_require__("./app/client/_helpers/utils.tsx");






var mapStateToProps = function (state, ownProps) {
    var styles = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__helpers_utils__["s" /* createOrderedMapfromIDs */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__selectors__["c" /* myStylesSelector */])(state).ids, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__data_selectors__["n" /* stylesSelector */])(state));
    return {
        items: styles,
        loading: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__selectors__["c" /* myStylesSelector */])(state).loading,
        meta: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__selectors__["c" /* myStylesSelector */])(state).meta,
        errors: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__selectors__["c" /* myStylesSelector */])(state).errors,
        scrollPosition: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__selectors__["c" /* myStylesSelector */])(state).scrollPosition
    };
};
var mapDispatchToProps = function (dispatch, ownProps) {
    return {
        dispatch: dispatch,
        loadMore: function (meta) {
            if (meta && meta.hasNext()) {
                dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__middlewares__["d" /* fetchStylesByUser */])(meta.cursor, meta.nextPage));
            }
        }
    };
};
var MyStylesContainer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__components_MyStylesComponent__["a" /* default */]);
/* harmony default export */ __webpack_exports__["a"] = (MyStylesContainer);


/***/ }),

/***/ "./app/client/style/containers/StyleContainer.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__("./node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_StyleComponent__ = __webpack_require__("./app/client/style/components/StyleComponent.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__selectors__ = __webpack_require__("./app/client/style/selectors.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__comment_middlewares__ = __webpack_require__("./app/client/comment/middlewares.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__data_selectors__ = __webpack_require__("./app/client/_data/selectors.ts");





var mapStateToProps = function (state, props) {
    var style = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__data_selectors__["m" /* styleByIdSelector */])(state, parseInt(props.match.params.id));
    var notFound = false;
    if (style && style.user.name != props.match.params.username) {
        notFound = true;
    }
    return {
        style: style,
        loading: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__selectors__["a" /* loadingStyleSelector */])(state),
        comments: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__selectors__["b" /* styleCommentsSelector */])(state),
        notFoundStyle: notFound
    };
};
var mapDispatchToProps = function (dispatch, props) {
    return {
        dispatch: dispatch,
        loadMoreComments: function (meta) {
            dispatch(function (dispatch, getState) {
                var style = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__data_selectors__["m" /* styleByIdSelector */])(getState(), parseInt(props.match.params.id));
                if (style != null) {
                    if (!meta) {
                        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__comment_middlewares__["a" /* fetchCommentsByStyle */])(style.id, 1));
                    }
                    else if (meta && meta.hasNext()) {
                        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__comment_middlewares__["a" /* fetchCommentsByStyle */])(style.id, meta.nextPage));
                    }
                }
            });
        }
    };
};
var StyleContainer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__components_StyleComponent__["a" /* default */]);
/* harmony default export */ __webpack_exports__["a"] = (StyleContainer);


/***/ }),

/***/ "./app/client/style/middlewares.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = saveScrollPosition;
/* harmony export (immutable) */ __webpack_exports__["b"] = initializeStyles;
/* harmony export (immutable) */ __webpack_exports__["c"] = initializeStyle;
/* unused harmony export fetchStyle */
/* harmony export (immutable) */ __webpack_exports__["d"] = fetchStylesByUser;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__("./app/client/style/actions.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__comment_actions__ = __webpack_require__("./app/client/comment/actions.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_actions__ = __webpack_require__("./app/client/_data/actions.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__repositories_styleRepository__ = __webpack_require__("./app/client/_repositories/styleRepository.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_class_transformer__ = __webpack_require__("./node_modules/class-transformer/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_class_transformer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_class_transformer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_utils__ = __webpack_require__("./app/client/_helpers/utils.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__data_models_Meta__ = __webpack_require__("./app/client/_data/models/Meta.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_data__ = __webpack_require__("./app/client/_helpers/data.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__data_selectors__ = __webpack_require__("./app/client/_data/selectors.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__selectors__ = __webpack_require__("./app/client/style/selectors.ts");











function saveScrollPosition(scrollPosition) {
    return function (dispatch, getState) {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__actions__["a" /* saveScrollpos */])(scrollPosition));
    };
}
function initializeStyles() {
    return function (dispatch, getState) {
        var styles = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__helpers_utils__["s" /* createOrderedMapfromIDs */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__selectors__["c" /* myStylesSelector */])(getState()).ids, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__data_selectors__["n" /* stylesSelector */])(getState()));
        var totalStylesLoaded = styles.toArray().length;
        var stylesMeta = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__selectors__["c" /* myStylesSelector */])(getState()).meta;
        if (!totalStylesLoaded || (stylesMeta != null && stylesMeta.totalCount > totalStylesLoaded)) {
            if (stylesMeta != null && stylesMeta.nextPage < stylesMeta.totalPages)
                dispatch(fetchStylesByUser(stylesMeta.cursor, stylesMeta.nextPage));
            else {
                dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__actions__["b" /* clearStyles */])());
                dispatch(fetchStylesByUser());
            }
        }
    };
}
function initializeStyle(style_id) {
    return function (dispatch) {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__comment_actions__["a" /* clearComments */])());
        dispatch(fetchStyle(style_id));
    };
}
function fetchStyle(id) {
    return function (dispatch, getState) {
        // here we check if the style we wanna fetch already exist in our state and return it so 
        // we can avoid server requests everytime we wanna fetch a style.
        var style = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__data_selectors__["m" /* styleByIdSelector */])(getState(), parseInt(id));
        if (!style) {
            dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__actions__["c" /* clearStyle */])());
            dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__actions__["d" /* requestStarted */])());
            __WEBPACK_IMPORTED_MODULE_3__repositories_styleRepository__["a" /* default */].getById(id).then(function (data) {
                if (data) {
                    var style_1 = data.style;
                    if (data.error) {
                        return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__actions__["e" /* requestFailed */])({ requestErrors: ["Failed to retrieve styles."] }));
                    }
                    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__data_actions__["a" /* addDataAction */])({
                        resource: __WEBPACK_IMPORTED_MODULE_7__helpers_data__["a" /* ResourceType */].style,
                        data: [style_1]
                    }));
                    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__actions__["f" /* didReceiveStyle */])({
                        id: style_1.id,
                    }));
                }
                return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__actions__["g" /* requestSucceeded */])());
            });
        }
    };
}
function fetchStylesByUser(cursor, page, perPage) {
    if (cursor === void 0) { cursor = null; }
    if (page === void 0) { page = null; }
    if (perPage === void 0) { perPage = 10; }
    return function (dispatch, getState) {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__actions__["d" /* requestStarted */])());
        __WEBPACK_IMPORTED_MODULE_3__repositories_styleRepository__["a" /* default */].getByUserId(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__helpers_utils__["f" /* getCurrentUser */])(), cursor, page, perPage).then(function (data) {
            var styles = data.styles, meta = data.meta;
            // Todo: handle errors
            if (data.error) {
                return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__actions__["e" /* requestFailed */])({ requestErrors: ["Failed to retrieve styles."] }));
            }
            var styleIds = styles.map(function (style) { return style.id; });
            dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__data_actions__["a" /* addDataAction */])({
                resource: __WEBPACK_IMPORTED_MODULE_7__helpers_data__["a" /* ResourceType */].style,
                data: styles
            }));
            dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__actions__["h" /* didReceiveStyles */])({
                ids: styleIds,
                meta: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_class_transformer__["plainToClass"])(__WEBPACK_IMPORTED_MODULE_6__data_models_Meta__["a" /* default */], meta),
            }));
            return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__actions__["g" /* requestSucceeded */])());
        });
    };
}


/***/ }),

/***/ "./app/client/style/reducers.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return myStylesReducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__("./app/client/style/actions.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__comment_actions__ = __webpack_require__("./app/client/comment/actions.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__comment_reducers__ = __webpack_require__("./app/client/comment/reducers.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__("./node_modules/redux/es/index.js");




//reducers
var myStylesReducer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux__["b" /* combineReducers */])({
    ids: items,
    meta: meta,
    loading: loading,
    errors: errors,
    scrollPosition: scrollPosition
});
var styleReducer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux__["b" /* combineReducers */])({
    id: item,
    loading: loading,
    comments: __WEBPACK_IMPORTED_MODULE_2__comment_reducers__["a" /* default */]
});

/* harmony default export */ __webpack_exports__["a"] = (styleReducer);
function errors(state, action) {
    if (state === void 0) { state = []; }
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0__actions__["d" /* requestStarted */].toString():
            return [];
        case __WEBPACK_IMPORTED_MODULE_0__actions__["g" /* requestSucceeded */].toString():
            return [];
        case __WEBPACK_IMPORTED_MODULE_0__actions__["e" /* requestFailed */].toString():
            return action.payload.requestErrors;
    }
    return state;
}
function item(state, action) {
    if (state === void 0) { state = null; }
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0__actions__["b" /* clearStyles */].toString():
            return null;
        case __WEBPACK_IMPORTED_MODULE_0__actions__["f" /* didReceiveStyle */].toString():
            return action.payload.id;
    }
    return state;
}
function items(state, action) {
    if (state === void 0) { state = []; }
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0__actions__["b" /* clearStyles */].toString():
            return [];
        case __WEBPACK_IMPORTED_MODULE_0__actions__["h" /* didReceiveStyles */].toString():
            return state.concat(action.payload.ids);
    }
    return state;
}
function meta(state, action) {
    if (state === void 0) { state = null; }
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0__actions__["h" /* didReceiveStyles */].toString():
            return action.payload.meta;
        case __WEBPACK_IMPORTED_MODULE_0__actions__["b" /* clearStyles */].toString():
            return null;
    }
    return state;
}
function loading(state, action) {
    if (state === void 0) { state = false; }
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0__actions__["d" /* requestStarted */].toString():
        case __WEBPACK_IMPORTED_MODULE_1__comment_actions__["b" /* requestComments */].toString():
            return true;
        case __WEBPACK_IMPORTED_MODULE_0__actions__["g" /* requestSucceeded */].toString():
            return false;
    }
    return state;
}
function scrollPosition(state, action) {
    if (state === void 0) { state = 0; }
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* saveScrollpos */].toString():
            return action.payload;
    }
    return state;
}


/***/ }),

/***/ "./app/client/style/selectors.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return loadingStyleSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return styleCommentsSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return myStylesSelector; });
var loadingStyleSelector = function (state) { return state.style.loading; };
var styleCommentsSelector = function (state) { return state.style.comments; };
var myStylesSelector = function (state) { return state.myStyles; };


/***/ }),

/***/ "./app/client/user/actions.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return requestNewData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return receiveNewData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return requestUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return receiveUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return receiveUserError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return requestStyles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return requestDifferentItems; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return receiveStyles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return requestSpecials; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return receiveSpecials; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return requestUsers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return receiveUsers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return requestShops; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return receiveShops; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return commonStateAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return commonCityAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return requestUserSave; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return receiveUserSave; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return clearUserAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return clearFollow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return clearFollowItems; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addCurrentUserAction; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__("./node_modules/redux-actions/es/index.js");

var requestNewData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_NEW_DATA');
var receiveNewData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('RECEIVE_NEW_DATA');
var requestUser = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('FETCH_USER');
var receiveUser = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('RECEIVE_USER');
var receiveUserError = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('RECEIVE_USER_ERROR');
var requestStyles = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('USER_FETCH_STYLES');
var requestDifferentItems = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('USER_FETCH_DIFFERENT_ITEMS');
var receiveStyles = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('USER_RECEIVE_STYLES');
var requestSpecials = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('USER_FETCH_SPECIALS');
var receiveSpecials = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('USER_RECEIVE_SPECIALS');
var requestUsers = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('USER_FETCH_USERs');
var receiveUsers = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('USER_RECEIVE_USERS');
var requestShops = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('USER_FETCH_SHOPS');
var receiveShops = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('USER_RECEIVE_SHOPS');
var commonStateAction = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('COMMON_STATE_ACTION');
var commonCityAction = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('COMMON_CITY_ACTION');
var requestUserSave = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('REQUEST_USER_SAVE');
var receiveUserSave = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('RECEIVE_USER_SAVE');
var clearUserAction = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('CLEAR_USER_ACTION');
var clearFollow = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('CLEAR_FOLLOW');
var clearFollowItems = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('CLEAR_FOLLOW_ITEMS');
var addCurrentUserAction = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('ADD_CURRENT_USER_ACTION');


/***/ }),

/***/ "./app/client/user/components/MyProfileBottomComponent.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/react.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MyProfileTabViewComponent__ = __webpack_require__("./app/client/user/components/MyProfileTabViewComponent.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MyProfileTabsComponent__ = __webpack_require__("./app/client/user/components/MyProfileTabsComponent.tsx");
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};



var MyProfileBotttomComponent = function (props) {
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__MyProfileTabsComponent__["a" /* default */], __assign({}, props)),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__MyProfileTabViewComponent__["a" /* default */], __assign({}, props))));
};
/* harmony default export */ __webpack_exports__["a"] = (MyProfileBotttomComponent);


/***/ }),

/***/ "./app/client/user/components/MyProfileComponent.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/react.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__widgets_loadingIndicator_LoadingIndicatorComponent__ = __webpack_require__("./app/client/_widgets/loadingIndicator/LoadingIndicatorComponent.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__("./node_modules/react-router/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modal_containers_FollowListModalContainer__ = __webpack_require__("./app/client/user/modal/containers/FollowListModalContainer.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_api__ = __webpack_require__("./app/client/_helpers/api.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_utils__ = __webpack_require__("./app/client/_helpers/utils.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__container_MyProfileBottomContainer__ = __webpack_require__("./app/client/user/container/MyProfileBottomContainer.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__widgets_follow_FollowContainer__ = __webpack_require__("./app/client/_widgets/follow/FollowContainer.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__MyProfileDetailsComponent__ = __webpack_require__("./app/client/user/components/MyProfileDetailsComponent.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__widgets_user_UserRedirectContainer__ = __webpack_require__("./app/client/_widgets/user/UserRedirectContainer.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__helpers_data__ = __webpack_require__("./app/client/_helpers/data.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__routes__ = __webpack_require__("./app/client/routes.ts");
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};












var FollowingModal = function (props, showFollowing, profile) {
    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__modal_containers_FollowListModalContainer__["a" /* default */], __assign({}, __assign({}, props, { showFollowing: showFollowing, profile: profile })));
};
var MyProfileComponent = function (props) {
    var profile = props.profile, currentUser = props.currentUser, viewFollowing = props.viewFollowing, viewFollowers = props.viewFollowers, loadingUser = props.loadingUser;
    if (!profile && loadingUser) {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row expanded" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__widgets_loadingIndicator_LoadingIndicatorComponent__["a" /* default */], { message: "Loading user..." })));
    }
    else if (!profile && !loadingUser) {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row expanded", style: { paddingLeft: '1rem', paddingTop: '1rem' } },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h1", null, "User not found. :(")));
    }
    else {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row large-12 columns" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "callout mt-1" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "large-2 columns" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "img-wrapper circle large" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: profile.profilePicture() }))),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "large-10 columns" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "media-object" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "media-object-section middle" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "text-group" },
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h5", null,
                                        profile.username(),
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("small", { className: "subheader" },
                                            "- ",
                                            profile.displayProfession()))))),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "pull-right" },
                            currentUser && !(currentUser.id == profile.id) && profile.isProfessional &&
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__widgets_user_UserRedirectContainer__["a" /* default */], { className: "button primary small", id: profile.id, element: "a", type: __WEBPACK_IMPORTED_MODULE_10__helpers_data__["a" /* ResourceType */].message },
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("i", { className: "fa fa-envelope-o fa-fw" }),
                                    "\u00A0 Message"),
                            !currentUser && profile.isProfessional &&
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { href: __WEBPACK_IMPORTED_MODULE_11__routes__["g" /* UsersRoutes */].sign_in(), className: "button primary small" },
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("i", { className: "fa fa-envelope-o fa-fw" }),
                                    "\u00A0 Message"),
                            "\u2003",
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__widgets_follow_FollowContainer__["a" /* default */], { model: profile, className: "small" }),
                            currentUser && (currentUser.id == profile.id) &&
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { className: " button primary small pull-right", href: __WEBPACK_IMPORTED_MODULE_11__routes__["g" /* UsersRoutes */].edit_profile(profile.id) },
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("i", { className: " fa fa-edit" }),
                                    "\u00A0 Edit Profile")),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__MyProfileDetailsComponent__["a" /* default */], { profile: profile, currentUser: currentUser }))),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("ul", { className: " list-inline table justified" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", { className: " text-center" },
                        profile.followingCount > 0 &&
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { onClick: function () { return viewFollowing(profile.id, profile.name); } },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("b", null, profile.followingCount),
                                " Following"),
                        profile.followingCount == 0 &&
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null,
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("b", null, profile.followingCount),
                                " Following"),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* Route */], { exact: true, path: [__WEBPACK_IMPORTED_MODULE_4__helpers_api__["a" /* Api */].baseUrl, 'users', ':id', 'following'].join('/'), render: function (props) {
                                return FollowingModal(props, true, profile);
                            } }),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* Route */], { exact: true, path: ['/:str', 'following'].join('/'), render: function (props) {
                                return FollowingModal(props, true, profile);
                            } })),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", { className: " text-center" },
                        profile.followersCount > 0 &&
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { onClick: function () { return viewFollowers(profile.id, profile.name); } },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("b", null, profile.followersCount),
                                " ",
                                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__helpers_utils__["t" /* prettyPrintFollower */])(profile.followersCount)),
                        profile.followersCount == 0 &&
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null,
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("b", null, profile.followersCount),
                                " ",
                                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__helpers_utils__["t" /* prettyPrintFollower */])(profile.followersCount)),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* Route */], { exact: true, path: [__WEBPACK_IMPORTED_MODULE_4__helpers_api__["a" /* Api */].baseUrl, 'users', ':id', 'followers'].join('/'), render: function (props) {
                                return FollowingModal(props, false, profile);
                            } }),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* Route */], { exact: true, path: ['/:str', 'followers'].join('/'), render: function (props) {
                                return FollowingModal(props, false, profile);
                            } }))),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__container_MyProfileBottomContainer__["a" /* default */], { profile: profile }))));
    }
};
/* harmony default export */ __webpack_exports__["a"] = (MyProfileComponent);


/***/ }),

/***/ "./app/client/user/components/MyProfileDetailsComponent.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/react.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_utils__ = __webpack_require__("./app/client/_helpers/utils.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__routes__ = __webpack_require__("./app/client/routes.ts");



var MyProfileDetailsComponent = function (_a) {
    var profile = _a.profile, currentUser = _a.currentUser;
    var show = currentUser && profile.id == currentUser.id || profile.isProfessional;
    var phoneNumber = profile.phoneNumber();
    var profileUrl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_utils__["g" /* getSiteUrl */])() + __WEBPACK_IMPORTED_MODULE_2__routes__["g" /* UsersRoutes */].short_url(profile.name);
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: " row" },
            profile.fullName &&
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: " large-4 columns" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: " text-group" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h5", { className: " subheader" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("small", null, "Full Name")),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, profile.fullName))),
            profile.gender() != '' &&
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: " large-4 columns" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: " text-group" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h5", { className: " subheader" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("small", null, "Gender")),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, profile.gender()))),
            show && phoneNumber &&
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: " large-4 columns" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: " text-group" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h5", { className: " subheader" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("small", null, "Contact No.")),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, phoneNumber)))),
        show &&
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: " row" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: " large-12 columns" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: " text-group" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h5", { className: " subheader" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("small", null, "Address")),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, profile.completeAddress())))),
        profile.bio &&
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: " row" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: " large-12 columns" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: " text-group" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h5", { className: " subheader" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("small", null, "Short Description")),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, profile.bio)))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: " row" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: " large-12 columns" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: " text-group" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h5", { className: " subheader" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("small", null, "Profile Url")),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null,
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { href: profileUrl }, profileUrl)))))));
};
/* harmony default export */ __webpack_exports__["a"] = (MyProfileDetailsComponent);


/***/ }),

/***/ "./app/client/user/components/MyProfileSpecialsComponent.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/react.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__("./node_modules/classnames/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_infinite_scroll__ = __webpack_require__("./node_modules/redux-infinite-scroll/lib/ReduxInfiniteScroll.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_infinite_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_redux_infinite_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_data__ = __webpack_require__("./app/client/_helpers/data.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__widgets_user_UserRedirectContainer__ = __webpack_require__("./app/client/_widgets/user/UserRedirectContainer.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__widgets_loadingIndicator_LoadingIndicatorComponent__ = __webpack_require__("./app/client/_widgets/loadingIndicator/LoadingIndicatorComponent.tsx");






var MyProfileSpecialsComponent = function (_a) {
    var specials = _a.specials, loadMore = _a.loadMore;
    if (specials.items.toArray().length == 0 && !specials.loading) {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "tabs-content", "data-tabs-content": "users" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "tabs-panel is-active" }, "No Specials")));
    }
    else {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("table", null,
            !specials.loading &&
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("thead", null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("tr", null,
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("th", null, "Special Title"),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("th", null, "Expiration Date"),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("th", null))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_redux_infinite_scroll___default.a, { loadMore: function () { return loadMore(specials.meta, __WEBPACK_IMPORTED_MODULE_3__helpers_data__["a" /* ResourceType */].special); }, loadingMore: specials.loading, holderType: "tbody", loader: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("tr", null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("td", null,
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__widgets_loadingIndicator_LoadingIndicatorComponent__["a" /* default */], null))), showLoader: true, elementIsScrollable: false, threshold: 200 }, specials.items.toArray().map(function (special) {
                return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("tr", { key: special.id },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("td", null,
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__widgets_user_UserRedirectContainer__["a" /* default */], { id: special.id, element: "b", type: __WEBPACK_IMPORTED_MODULE_3__helpers_data__["a" /* ResourceType */].special }, special.title)),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("td", null, special.prettyEndDateString()),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("td", null,
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("i", { className: __WEBPACK_IMPORTED_MODULE_1_classnames__("fa fa-fw", {
                                "fa-heart": special.likeCount > 0,
                                "fa-heart-o": special.likeCount == 0
                            }) }),
                        "\u00A0",
                        special.likeCount > 1 ? special.likeCount + ' Likes' : special.likeCount + ' Like')));
            }))));
    }
};
/* harmony default export */ __webpack_exports__["a"] = (MyProfileSpecialsComponent);


/***/ }),

/***/ "./app/client/user/components/MyProfileStylesComponent.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/react.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_infinite_scroll__ = __webpack_require__("./node_modules/redux-infinite-scroll/lib/ReduxInfiniteScroll.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_infinite_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_infinite_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_data__ = __webpack_require__("./app/client/_helpers/data.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_components_MyStylesGalleryImageComponent__ = __webpack_require__("./app/client/style/components/MyStylesGalleryImageComponent.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__widgets_loadingIndicator_LoadingIndicatorComponent__ = __webpack_require__("./app/client/_widgets/loadingIndicator/LoadingIndicatorComponent.tsx");





var MyProfileStylesComponent = function (_a) {
    var styles = _a.styles, loadMore = _a.loadMore, loadingTab = _a.loadingTab, likedStyleLoad = _a.likedStyleLoad;
    if (styles.items.toArray().length == 0 && !loadingTab) {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "tabs-content", "data-tabs-content": "users" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "tabs-panel is-active" }, "No Images")));
    }
    else {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "featured-image-block-grid" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_redux_infinite_scroll___default.a, { loadMore: function () { return loadMore(styles.meta, __WEBPACK_IMPORTED_MODULE_2__helpers_data__["a" /* ResourceType */].style, likedStyleLoad); }, loadingMore: loadingTab, showLoader: true, loader: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__widgets_loadingIndicator_LoadingIndicatorComponent__["a" /* default */], null), elementIsScrollable: false, holderType: "div", className: "row large-up-3 small-up-1", threshold: 100 }, styles.items.toArray().map(function (style) {
                return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__style_components_MyStylesGalleryImageComponent__["a" /* default */], { key: style.id, item: style }));
            }))));
    }
};
/* harmony default export */ __webpack_exports__["a"] = (MyProfileStylesComponent);


/***/ }),

/***/ "./app/client/user/components/MyProfileTabViewComponent.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/react.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MyProfileSpecialsComponent__ = __webpack_require__("./app/client/user/components/MyProfileSpecialsComponent.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MyProfileStylesComponent__ = __webpack_require__("./app/client/user/components/MyProfileStylesComponent.tsx");
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};



var MyProfileTabViewComponent = function (props) {
    var styleLoad = props.styleLoad, likedStyleLoad = props.likedStyleLoad;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "tabs-content", "data-tabs-content": "users" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "tabs-panel is-active" },
            (styleLoad || likedStyleLoad) && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__MyProfileStylesComponent__["a" /* default */], __assign({}, props)),
            !(styleLoad || likedStyleLoad) && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__MyProfileSpecialsComponent__["a" /* default */], __assign({}, props)))));
};
/* harmony default export */ __webpack_exports__["a"] = (MyProfileTabViewComponent);


/***/ }),

/***/ "./app/client/user/components/MyProfileTabsComponent.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/react.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var MyProfileTabsComponent = function (props) {
    var loadStyles = props.loadStyles, loadLikedStyles = props.loadLikedStyles, loadSpecials = props.loadSpecials, styleLoad = props.styleLoad, likedStyleLoad = props.likedStyleLoad, profile = props.profile;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("ul", { className: "tabs expanded", "data-tabs": true, id: "users" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", { className: "tabs-title text-center is-active" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { href: "", "aria-selected": styleLoad, onClick: function (e) { return loadStyles(profile.id, e); } }, "My Images")),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", { className: "tabs-title text-center" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { href: "", "aria-selected": likedStyleLoad, onClick: function (e) { return loadLikedStyles(profile.id, e); } }, "Liked Images")),
        profile.isProfessional &&
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", { className: "tabs-title text-center" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { href: "", "aria-selected": !styleLoad && !likedStyleLoad, onClick: function (e) { return loadSpecials(profile.id, e); } }, "Specials"))));
};
/* harmony default export */ __webpack_exports__["a"] = (MyProfileTabsComponent);


/***/ }),

/***/ "./app/client/user/container/MyProfileBottomContainer.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__("./node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_MyProfileBottomComponent__ = __webpack_require__("./app/client/user/components/MyProfileBottomComponent.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__selectors__ = __webpack_require__("./app/client/user/selectors.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__middlewares__ = __webpack_require__("./app/client/user/middlewares.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__data_selectors__ = __webpack_require__("./app/client/_data/selectors.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_utils__ = __webpack_require__("./app/client/_helpers/utils.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_data__ = __webpack_require__("./app/client/_helpers/data.ts");







var mapStateToProps = function (state, ownProps) {
    var sp = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__selectors__["e" /* getSpecialsSelector */])(state);
    return {
        profile: ownProps.profile,
        loadingTab: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__selectors__["f" /* loadingTabSelector */])(state),
        styleLoad: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__selectors__["g" /* styleLoadSelector */])(state),
        likedStyleLoad: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__selectors__["h" /* likedStyleLoadSelector */])(state),
        styles: {
            items: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__helpers_utils__["s" /* createOrderedMapfromIDs */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__selectors__["i" /* getStylesSelector */])(state).ids, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__data_selectors__["n" /* stylesSelector */])(state)),
            meta: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__selectors__["i" /* getStylesSelector */])(state).meta
        },
        specials: {
            items: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__helpers_utils__["s" /* createOrderedMapfromIDs */])(sp.ids, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__data_selectors__["o" /* specialsSelector */])(state)),
            meta: sp.meta,
            loading: sp.loading
        },
    };
};
var mapDispatchToProps = function (dispatch, ownProps) {
    return {
        loadMore: function (meta, resource, isLiked) {
            if (isLiked === void 0) { isLiked = null; }
            if (meta && meta.hasNext()) {
                if (resource == __WEBPACK_IMPORTED_MODULE_6__helpers_data__["a" /* ResourceType */].special) {
                    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__middlewares__["e" /* fetchUserSpecials */])(ownProps.profile.id, meta.nextPage));
                }
                else if (resource == __WEBPACK_IMPORTED_MODULE_6__helpers_data__["a" /* ResourceType */].style) {
                    if (!isLiked) {
                        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__middlewares__["f" /* fetchUserStyles */])(ownProps.profile.id, meta.nextPage));
                    }
                    else {
                        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__middlewares__["g" /* fetchUserLikedStyles */])(ownProps.profile.id, meta.nextPage));
                    }
                }
            }
        },
        loadStyles: function (id, e) {
            e.stopPropagation();
            e.preventDefault();
            dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__middlewares__["h" /* clearItems */])());
            dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__middlewares__["f" /* fetchUserStyles */])(id));
        },
        loadLikedStyles: function (id, e) {
            e.stopPropagation();
            e.preventDefault();
            dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__middlewares__["h" /* clearItems */])());
            dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__middlewares__["g" /* fetchUserLikedStyles */])(id));
        },
        loadSpecials: function (id, e) {
            e.stopPropagation();
            e.preventDefault();
            dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__middlewares__["h" /* clearItems */])());
            dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__middlewares__["e" /* fetchUserSpecials */])(id));
        }
    };
};
var MyProfileBottomContainer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__components_MyProfileBottomComponent__["a" /* default */]);
/* harmony default export */ __webpack_exports__["a"] = (MyProfileBottomContainer);


/***/ }),

/***/ "./app/client/user/container/MyProfileContainer.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__("./node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_MyProfileComponent__ = __webpack_require__("./app/client/user/components/MyProfileComponent.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__selectors__ = __webpack_require__("./app/client/user/selectors.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__middlewares__ = __webpack_require__("./app/client/user/middlewares.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_redux__ = __webpack_require__("./node_modules/react-router-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__routes__ = __webpack_require__("./app/client/routes.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__data_selectors__ = __webpack_require__("./app/client/_data/selectors.ts");







var mapStateToProps = function (state, ownProps) {
    var user = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__data_selectors__["c" /* userByIdSelector */])(state, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__selectors__["c" /* userIDSelector */])(state));
    var currentUser = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__data_selectors__["c" /* userByIdSelector */])(state, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__selectors__["a" /* currentUserIdSelector */])(state));
    var profile = user && currentUser && currentUser.id == user.id ? currentUser : user;
    return {
        profile: profile,
        currentUser: currentUser,
        loadingUser: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__selectors__["d" /* loadingUserSelector */])(state),
    };
};
var mapDispatchToProps = function (dispatch, ownProps) {
    return {
        viewFollowing: function (id, name) {
            dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__middlewares__["b" /* initFollow */])());
            dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__middlewares__["c" /* fetchUserFollowing */])(id, 1));
            if (window.location.toString().includes(name)) {
                dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_router_redux__["d" /* push */])(__WEBPACK_IMPORTED_MODULE_5__routes__["g" /* UsersRoutes */].following(name), { refresh: false }));
            }
            else {
                dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_router_redux__["d" /* push */])(__WEBPACK_IMPORTED_MODULE_5__routes__["g" /* UsersRoutes */].following(id), { refresh: false }));
            }
        },
        viewFollowers: function (id, name) {
            dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__middlewares__["b" /* initFollow */])());
            dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__middlewares__["d" /* fetchUserFollowers */])(id, 1));
            if (window.location.toString().includes(name)) {
                dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_router_redux__["d" /* push */])(__WEBPACK_IMPORTED_MODULE_5__routes__["g" /* UsersRoutes */].followers(name), { refresh: false }));
            }
            else {
                dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_router_redux__["d" /* push */])(__WEBPACK_IMPORTED_MODULE_5__routes__["g" /* UsersRoutes */].followers(id), { refresh: false }));
            }
        }
    };
};
var MyProfileContainer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__components_MyProfileComponent__["a" /* default */]);
/* harmony default export */ __webpack_exports__["a"] = (MyProfileContainer);


/***/ }),

/***/ "./app/client/user/middlewares.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = fetchUser;
/* harmony export (immutable) */ __webpack_exports__["f"] = fetchUserStyles;
/* harmony export (immutable) */ __webpack_exports__["g"] = fetchUserLikedStyles;
/* harmony export (immutable) */ __webpack_exports__["e"] = fetchUserSpecials;
/* harmony export (immutable) */ __webpack_exports__["c"] = fetchUserFollowing;
/* harmony export (immutable) */ __webpack_exports__["j"] = fetchShopFollowing;
/* harmony export (immutable) */ __webpack_exports__["d"] = fetchUserFollowers;
/* unused harmony export fetchStateList */
/* unused harmony export fetchCityList */
/* unused harmony export saveProfile */
/* harmony export (immutable) */ __webpack_exports__["b"] = initFollow;
/* harmony export (immutable) */ __webpack_exports__["i"] = changeFollow;
/* harmony export (immutable) */ __webpack_exports__["h"] = clearItems;
/* unused harmony export initializeUserEdit */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__("./app/client/user/actions.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_class_transformer__ = __webpack_require__("./node_modules/class-transformer/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_class_transformer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_class_transformer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__repositories_userRepository__ = __webpack_require__("./app/client/_repositories/userRepository.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__repositories_commonRepository__ = __webpack_require__("./app/client/_repositories/commonRepository.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_utils__ = __webpack_require__("./app/client/_helpers/utils.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__data_models_Meta__ = __webpack_require__("./app/client/_data/models/Meta.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__data_actions__ = __webpack_require__("./app/client/_data/actions.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_data__ = __webpack_require__("./app/client/_helpers/data.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__data_selectors__ = __webpack_require__("./app/client/_data/selectors.ts");
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};









var loggedUser = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__helpers_utils__["f" /* getCurrentUser */])();
function fetchUser(id) {
    return function (dispatch, getState) {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__actions__["b" /* requestUser */])());
        var users = getState().data.users;
        //get user from state nase on id
        var user = users.find(function (user) { return user.name == id; });
        if (!user)
            user = users.find(function (user) { return user.id == id; });
        //if still null get from api
        if (!user) {
            dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__actions__["c" /* requestNewData */])());
            dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__actions__["d" /* clearUserAction */])());
            __WEBPACK_IMPORTED_MODULE_2__repositories_userRepository__["a" /* default */].get(id).then(function (data) {
                var error = data.error, user = data.user;
                if (!error) {
                    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__data_actions__["a" /* addDataAction */])({
                        resource: __WEBPACK_IMPORTED_MODULE_7__helpers_data__["a" /* ResourceType */].user,
                        data: user
                    }));
                    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__actions__["e" /* receiveUser */])({
                        userID: user.id
                    }));
                    dispatch(fetchUserStyles(user.id));
                    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__actions__["f" /* receiveNewData */])());
                }
                else {
                    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__actions__["g" /* receiveUserError */])());
                }
            });
        }
        else {
            //check if user is already loaded on page (following and follower redirect; back button)
            var active_user = getState().user.userID && getState().user.userID == user.id;
            if (!active_user) {
                dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__actions__["d" /* clearUserAction */])());
                dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__actions__["e" /* receiveUser */])({
                    userID: user.id
                }));
                dispatch(fetchUserStyles(user.id));
            }
            //update user data in background
            __WEBPACK_IMPORTED_MODULE_2__repositories_userRepository__["a" /* default */].get(id).then(function (data) {
                var error = data.error, user = data.user;
                if (!error) {
                    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__data_actions__["b" /* updateDataAction */])({
                        resource: __WEBPACK_IMPORTED_MODULE_7__helpers_data__["a" /* ResourceType */].user,
                        data: user
                    }));
                }
            });
        }
    };
}
function fetchUserStyles(id, page, perPage) {
    if (page === void 0) { page = null; }
    if (perPage === void 0) { perPage = 10; }
    return function (dispatch, getState) {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__actions__["h" /* requestStyles */])({
            tab: "style",
        }));
        __WEBPACK_IMPORTED_MODULE_2__repositories_userRepository__["a" /* default */].getStylesById(id, page, perPage).then(function (data) {
            var styles = data.styles, meta = data.meta;
            returnDispatch(dispatch, getState(), styles, meta, __WEBPACK_IMPORTED_MODULE_7__helpers_data__["a" /* ResourceType */].style);
        });
    };
}
function fetchUserLikedStyles(id, page, perPage) {
    if (page === void 0) { page = null; }
    if (perPage === void 0) { perPage = 10; }
    return function (dispatch, getState) {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__actions__["h" /* requestStyles */])({
            tab: "likedStyle"
        }));
        __WEBPACK_IMPORTED_MODULE_2__repositories_userRepository__["a" /* default */].getLikedStylesById(id, page, perPage).then(function (data) {
            var liked_styles = data.liked_styles, meta = data.meta;
            returnDispatch(dispatch, getState(), liked_styles, meta, __WEBPACK_IMPORTED_MODULE_7__helpers_data__["a" /* ResourceType */].style);
        });
    };
}
function fetchUserSpecials(id, page, perPage) {
    if (page === void 0) { page = null; }
    if (perPage === void 0) { perPage = 10; }
    return function (dispatch, getState) {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__actions__["i" /* requestSpecials */])({
            tab: "special"
        }));
        __WEBPACK_IMPORTED_MODULE_2__repositories_userRepository__["a" /* default */].getSpecialsById(id, page, perPage).then(function (data) {
            var specials = data.specials, meta = data.meta;
            returnDispatch(dispatch, getState(), specials, meta, __WEBPACK_IMPORTED_MODULE_7__helpers_data__["a" /* ResourceType */].special);
        });
    };
}
function fetchUserFollowing(id, page, perPage) {
    if (page === void 0) { page = null; }
    if (perPage === void 0) { perPage = 10; }
    return function (dispatch, getState) {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__actions__["j" /* requestUsers */])());
        __WEBPACK_IMPORTED_MODULE_2__repositories_userRepository__["a" /* default */].getFollowingUsersById(id, page, perPage).then(function (data) {
            var users_followed = data.users_followed, meta = data.meta;
            returnDispatch(dispatch, getState(), users_followed, meta, __WEBPACK_IMPORTED_MODULE_7__helpers_data__["a" /* ResourceType */].user);
        });
    };
}
function fetchShopFollowing(id, page, perPage) {
    if (page === void 0) { page = null; }
    if (perPage === void 0) { perPage = 10; }
    return function (dispatch, getState) {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__actions__["k" /* requestShops */])());
        __WEBPACK_IMPORTED_MODULE_2__repositories_userRepository__["a" /* default */].getFollowingShopsById(id, page, perPage).then(function (data) {
            var liked_salons = data.liked_salons, meta = data.meta;
            returnDispatch(dispatch, getState(), liked_salons, meta, __WEBPACK_IMPORTED_MODULE_7__helpers_data__["a" /* ResourceType */].shop);
        });
    };
}
function fetchUserFollowers(id, page, perPage) {
    if (page === void 0) { page = null; }
    if (perPage === void 0) { perPage = 10; }
    return function (dispatch, getState) {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__actions__["j" /* requestUsers */])());
        __WEBPACK_IMPORTED_MODULE_2__repositories_userRepository__["a" /* default */].getFollowersById(id, page, perPage).then(function (data) {
            var followers = data.followers, meta = data.meta;
            returnDispatch(dispatch, getState(), followers, meta, __WEBPACK_IMPORTED_MODULE_7__helpers_data__["a" /* ResourceType */].user);
        });
    };
}
function returnDispatch(dispatch, state, data, meta, resource) {
    var ids = data.map(function (x) { return x.id; });
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__data_actions__["a" /* addDataAction */])({
        resource: resource,
        data: data
    }));
    if (resource == __WEBPACK_IMPORTED_MODULE_7__helpers_data__["a" /* ResourceType */].user) {
        return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__actions__["l" /* receiveUsers */])({
            userIDs: ids,
            meta: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_class_transformer__["plainToClass"])(__WEBPACK_IMPORTED_MODULE_5__data_models_Meta__["a" /* default */], meta),
        }));
    }
    else if (resource == __WEBPACK_IMPORTED_MODULE_7__helpers_data__["a" /* ResourceType */].shop) {
        return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__actions__["m" /* receiveShops */])({
            shopIDs: ids,
            meta: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_class_transformer__["plainToClass"])(__WEBPACK_IMPORTED_MODULE_5__data_models_Meta__["a" /* default */], meta),
        }));
    }
    else if (resource == __WEBPACK_IMPORTED_MODULE_7__helpers_data__["a" /* ResourceType */].special) {
        return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__actions__["n" /* receiveSpecials */])({
            specialIDs: ids,
            meta: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_class_transformer__["plainToClass"])(__WEBPACK_IMPORTED_MODULE_5__data_models_Meta__["a" /* default */], meta),
        }));
    }
    else if (resource == __WEBPACK_IMPORTED_MODULE_7__helpers_data__["a" /* ResourceType */].style) {
        return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__actions__["o" /* receiveStyles */])({
            styleIDs: ids,
            meta: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_class_transformer__["plainToClass"])(__WEBPACK_IMPORTED_MODULE_5__data_models_Meta__["a" /* default */], meta),
        }));
    }
}
function fetchStateList() {
    return function (dispatch) {
        __WEBPACK_IMPORTED_MODULE_3__repositories_commonRepository__["a" /* default */].getStates().then(function (data) {
            var states = data.states;
            return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__actions__["p" /* commonStateAction */])(__assign({}, data, { stateList: states })));
        });
    };
}
function fetchCityList(state) {
    return function (dispatch) {
        __WEBPACK_IMPORTED_MODULE_3__repositories_commonRepository__["a" /* default */].getCities(state).then(function (data) {
            var cities = data.cities;
            return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__actions__["q" /* commonCityAction */])(__assign({}, data, { cityList: cities })));
        });
    };
}
function saveProfile(formData) {
    return function (dispatch) {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__actions__["r" /* requestUserSave */])());
        __WEBPACK_IMPORTED_MODULE_2__repositories_userRepository__["a" /* default */].saveProfile(formData).then(function (data) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__helpers_utils__["k" /* toastSuccess */])("Successfully saved Profile.");
            return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__actions__["s" /* receiveUserSave */])());
        });
    };
}
function initFollow() {
    return function (dispatch) {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__actions__["t" /* clearFollow */])());
    };
}
function changeFollow() {
    return function (dispatch) {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__actions__["u" /* clearFollowItems */])());
    };
}
function clearItems() {
    return function (dispatch) {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__actions__["v" /* requestDifferentItems */])());
    };
}
function initializeUserEdit() {
    return function (dispatch, getState) {
        dispatch(fetchUser(loggedUser.id));
        var currentUser = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__data_selectors__["c" /* userByIdSelector */])(getState(), loggedUser.id);
        dispatch(fetchStateList());
        dispatch(fetchCityList(currentUser.state));
    };
}


/***/ }),

/***/ "./app/client/user/modal/components/FollowListModalComponent.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/react.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__widgets_modal_ModalComponent__ = __webpack_require__("./app/client/_widgets/modal/ModalComponent.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_utils__ = __webpack_require__("./app/client/_helpers/utils.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__routes__ = __webpack_require__("./app/client/routes.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router__ = __webpack_require__("./node_modules/react-router/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__FollowListShopItemModalComponent__ = __webpack_require__("./app/client/user/modal/components/FollowListShopItemModalComponent.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__FollowListUserItemModalComponent__ = __webpack_require__("./app/client/user/modal/components/FollowListUserItemModalComponent.tsx");
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};







var FollowListModalComponent = function (props) {
    var history = props.history, users = props.users, shops = props.shops, showFollowing = props.showFollowing, profile = props.profile, loadUser = props.loadUser, loadShop = props.loadShop, followModalTab = props.followModalTab;
    if (users.items.size == 0 && shops.items.size == 0 && !users.loading && !shops.loading) {
        if (window.location.toString().includes(profile.name)) {
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_react_router__["b" /* Redirect */], { to: { pathname: __WEBPACK_IMPORTED_MODULE_3__routes__["g" /* UsersRoutes */].short_url(profile.name), state: { refresh: false } } });
        }
        else {
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_react_router__["b" /* Redirect */], { to: { pathname: __WEBPACK_IMPORTED_MODULE_3__routes__["g" /* UsersRoutes */].show(profile.id), state: { refresh: false } } });
        }
    }
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__widgets_modal_ModalComponent__["a" /* default */], { show: true, onExit: function () { return history.goBack(); }, size: __WEBPACK_IMPORTED_MODULE_1__widgets_modal_ModalComponent__["b" /* ModalSizes */].SMALL, className: "follow-modal" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { id: "followingModal" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "reveal-heading" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h5", null, showFollowing ? profile.followingCount + ' Following' : profile.followersCount + ' ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__helpers_utils__["t" /* prettyPrintFollower */])(profile.followersCount)),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", { className: "close-button", type: "button", onClick: function () { return history.goBack(); } },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null, "\u00D7"))),
            showFollowing && profile.usersfollowingCount < profile.followingCount && profile.usersfollowingCount > 0 &&
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("ul", { className: "tabs expanded", "data-tabs": true, id: "users" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", { className: "tabs-title text-center is-active" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { onClick: function (e) { return loadUser(profile.id, e); }, "aria-selected": followModalTab }, "Users")),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", { className: "tabs-title text-center" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { onClick: function (e) { return loadShop(profile.id, e); }, "aria-selected": !followModalTab }, "Shops"))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "tabs-content", "data-tabs-content": "users" },
                followModalTab && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__FollowListUserItemModalComponent__["a" /* default */], __assign({}, props)),
                !followModalTab && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__FollowListShopItemModalComponent__["a" /* default */], __assign({}, props))))));
};
/* harmony default export */ __webpack_exports__["a"] = (FollowListModalComponent);


/***/ }),

/***/ "./app/client/user/modal/components/FollowListShopItemModalComponent.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/react.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__widgets_follow_FollowContainer__ = __webpack_require__("./app/client/_widgets/follow/FollowContainer.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_data__ = __webpack_require__("./app/client/_helpers/data.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_infinite_scroll__ = __webpack_require__("./node_modules/redux-infinite-scroll/lib/ReduxInfiniteScroll.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_infinite_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_redux_infinite_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__widgets_loadingIndicator_LoadingIndicatorComponent__ = __webpack_require__("./app/client/_widgets/loadingIndicator/LoadingIndicatorComponent.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__widgets_user_UserRedirectContainer__ = __webpack_require__("./app/client/_widgets/user/UserRedirectContainer.tsx");






var FollowListShopItemModalComponent = function (props) {
    var shops = props.shops, loadMore = props.loadMore, profile = props.profile;
    var s = shops.items.toArray();
    if (s.length == 0) {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "tabs-panel pr-0 is-active", id: "userpanel" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__widgets_loadingIndicator_LoadingIndicatorComponent__["a" /* default */], { message: 'Loading Shops...' })));
    }
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "tabs-panel pr-0 is-active", id: "userpanel" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_redux_infinite_scroll___default.a, { loadMore: function () { return loadMore(profile.id, shops.meta, false, true); }, loadingMore: shops.loading, loader: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__widgets_loadingIndicator_LoadingIndicatorComponent__["a" /* default */], { message: "Loading Shops..." }), holderType: "ul", className: "list-block flex-container active-scroll", elementIsScrollable: true, threshold: 20 }, s.map(function (shop) {
            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", { key: shop.id },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "media-object" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "media-object-section flushed middle" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__widgets_user_UserRedirectContainer__["a" /* default */], { id: shop.id, type: __WEBPACK_IMPORTED_MODULE_2__helpers_data__["a" /* ResourceType */].shop, className: "img-wrapper small circle", element: "div" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: shop.imageUrl() }))),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "media-object-section middle" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__widgets_user_UserRedirectContainer__["a" /* default */], { id: shop.id, type: __WEBPACK_IMPORTED_MODULE_2__helpers_data__["a" /* ResourceType */].shop, className: "text-group follow-modal-text", element: "div" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null,
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("b", null,
                                    "@",
                                    shop.name)),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("small", { className: "subheader text-left" }, shop.address())))),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__widgets_follow_FollowContainer__["a" /* default */], { model: shop, className: "primary pull-right" })));
        }))));
};
/* harmony default export */ __webpack_exports__["a"] = (FollowListShopItemModalComponent);


/***/ }),

/***/ "./app/client/user/modal/components/FollowListUserItemModalComponent.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/react.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__widgets_loadingIndicator_LoadingIndicatorComponent__ = __webpack_require__("./app/client/_widgets/loadingIndicator/LoadingIndicatorComponent.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_infinite_scroll__ = __webpack_require__("./node_modules/redux-infinite-scroll/lib/ReduxInfiniteScroll.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_infinite_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_redux_infinite_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__widgets_user_UserRedirectContainer__ = __webpack_require__("./app/client/_widgets/user/UserRedirectContainer.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__widgets_follow_FollowContainer__ = __webpack_require__("./app/client/_widgets/follow/FollowContainer.tsx");





var FollowListUserItemModalComponent = function (props) {
    var users = props.users, showFollowing = props.showFollowing, loadMore = props.loadMore, profile = props.profile;
    var u = users.items.toArray();
    if (u.length == 0) {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "tabs-panel pr-0 is-active", id: "userpanel" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__widgets_loadingIndicator_LoadingIndicatorComponent__["a" /* default */], { message: 'Loading Users...' })));
    }
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "tabs-panel pr-0 is-active", id: "userpanel" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_redux_infinite_scroll___default.a, { loadMore: function () { return loadMore(profile.id, users.meta, showFollowing, false); }, loadingMore: users.loading, loader: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__widgets_loadingIndicator_LoadingIndicatorComponent__["a" /* default */], { message: "Loading Users..." }), holderType: "ul", className: "list-block flex-container active-scroll", elementIsScrollable: true, threshold: 20 }, u.map(function (user) {
            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", { key: user.id },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "media-object" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__widgets_user_UserRedirectContainer__["a" /* default */], { id: user.id, className: "media-object-section flushed middle", element: "div" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "img-wrapper small circle" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: user.profilePicture() }))),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__widgets_user_UserRedirectContainer__["a" /* default */], { id: user.id, className: "media-object-section middle", element: "div" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "text-group follow-modal-text" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null,
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("b", null,
                                    "@",
                                    user.name)),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("small", { className: "subheader text-left" }, user.displayProfession())))),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__widgets_follow_FollowContainer__["a" /* default */], { model: user, className: "primary pull-right" })));
        }))));
};
/* harmony default export */ __webpack_exports__["a"] = (FollowListUserItemModalComponent);


/***/ }),

/***/ "./app/client/user/modal/containers/FollowListModalContainer.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__("./node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_FollowListModalComponent__ = __webpack_require__("./app/client/user/modal/components/FollowListModalComponent.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__selectors__ = __webpack_require__("./app/client/user/selectors.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__middlewares__ = __webpack_require__("./app/client/user/middlewares.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__data_selectors__ = __webpack_require__("./app/client/_data/selectors.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_utils__ = __webpack_require__("./app/client/_helpers/utils.tsx");






var mapStateToProps = function (state, ownProps) {
    var u = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__selectors__["j" /* getUsersSelector */])(state);
    var s = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__selectors__["k" /* getShopsSelector */])(state);
    return {
        users: {
            items: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__helpers_utils__["s" /* createOrderedMapfromIDs */])(u.ids, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__data_selectors__["i" /* usersSelector */])(state)),
            meta: u.meta,
            loading: u.loading
        },
        shops: {
            items: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__helpers_utils__["s" /* createOrderedMapfromIDs */])(s.ids, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__data_selectors__["l" /* shopsSelector */])(state)),
            meta: s.meta,
            loading: s.loading
        },
        showFollowing: ownProps.showFollowing,
        profile: ownProps.profile,
        followModalTab: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__selectors__["l" /* followModalTabSelector */])(state)
    };
};
var mapDispatchToProps = function (dispatch, ownProps) {
    return {
        loadUser: function (id, e) {
            e.stopPropagation();
            e.preventDefault();
            dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__middlewares__["i" /* changeFollow */])());
            dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__middlewares__["c" /* fetchUserFollowing */])(id, 1));
        },
        loadShop: function (id, e) {
            e.stopPropagation();
            e.preventDefault();
            dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__middlewares__["i" /* changeFollow */])());
            dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__middlewares__["j" /* fetchShopFollowing */])(id, 1));
        },
        loadMore: function (id, meta, showFollowing, isShop) {
            if (showFollowing === void 0) { showFollowing = null; }
            if (isShop === void 0) { isShop = null; }
            if (meta && meta.hasNext()) {
                if (!isShop) {
                    if (showFollowing) {
                        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__middlewares__["c" /* fetchUserFollowing */])(id, meta.nextPage));
                    }
                    else {
                        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__middlewares__["d" /* fetchUserFollowers */])(id, meta.nextPage));
                    }
                }
                else {
                    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__middlewares__["j" /* fetchShopFollowing */])(id, meta.nextPage));
                }
            }
        },
    };
};
var FollowListModalContainer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__components_FollowListModalComponent__["a" /* default */]);
/* harmony default export */ __webpack_exports__["a"] = (FollowListModalContainer);


/***/ }),

/***/ "./app/client/user/reducers.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__("./app/client/user/actions.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__("./node_modules/redux/es/index.js");


//reducers
var userReducer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux__["b" /* combineReducers */])({
    userID: userID,
    loadingTab: loadingTab,
    loadingUser: loadingUser,
    stateList: stateList,
    cityList: cityList,
    isSaving: isSaving,
    styleLoad: styleLoad,
    likedStyleLoad: likedStyleLoad,
    followModalTab: followModalTab,
    currentUserID: currentUserID,
    users: users,
    shops: shops,
    specials: specials,
    styles: styles
});
/* harmony default export */ __webpack_exports__["a"] = (userReducer);
function userID(state, action) {
    if (state === void 0) { state = null; }
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0__actions__["e" /* receiveUser */].toString():
            return action.payload.userID;
        case __WEBPACK_IMPORTED_MODULE_0__actions__["d" /* clearUserAction */].toString():
            return null;
    }
    return state;
}
function loadingUser(state, action) {
    if (state === void 0) { state = false; }
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0__actions__["c" /* requestNewData */].toString():
            return true;
        case __WEBPACK_IMPORTED_MODULE_0__actions__["f" /* receiveNewData */].toString():
        case __WEBPACK_IMPORTED_MODULE_0__actions__["g" /* receiveUserError */].toString():
            return false;
    }
    return state;
}
function users(state, action) {
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0__actions__["l" /* receiveUsers */].toString():
            var pl = action.payload;
            return {
                ids: state.ids.concat(pl.userIDs),
                meta: pl.meta,
                loading: false
            };
        case __WEBPACK_IMPORTED_MODULE_0__actions__["j" /* requestUsers */].toString():
            return {
                ids: state.ids,
                meta: state.meta,
                loading: true
            };
        case __WEBPACK_IMPORTED_MODULE_0__actions__["d" /* clearUserAction */].toString():
        case __WEBPACK_IMPORTED_MODULE_0__actions__["t" /* clearFollow */].toString():
        case __WEBPACK_IMPORTED_MODULE_0__actions__["u" /* clearFollowItems */].toString():
        case __WEBPACK_IMPORTED_MODULE_0__actions__["m" /* receiveShops */].toString():
            return { ids: [], meta: null, loading: null };
    }
    return !state ? { ids: [], meta: null, loading: null } : state;
}
function shops(state, action) {
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0__actions__["m" /* receiveShops */].toString():
            var pl = action.payload;
            return {
                ids: state.ids.concat(pl.shopIDs),
                meta: pl.meta,
                loading: false
            };
        case __WEBPACK_IMPORTED_MODULE_0__actions__["k" /* requestShops */].toString():
            return {
                ids: state.ids,
                meta: state.meta,
                loading: true
            };
        case __WEBPACK_IMPORTED_MODULE_0__actions__["d" /* clearUserAction */].toString():
        case __WEBPACK_IMPORTED_MODULE_0__actions__["t" /* clearFollow */].toString():
        case __WEBPACK_IMPORTED_MODULE_0__actions__["u" /* clearFollowItems */].toString():
        case __WEBPACK_IMPORTED_MODULE_0__actions__["l" /* receiveUsers */].toString():
            return { ids: [], meta: null, loading: null };
    }
    return !state ? { ids: [], meta: null, loading: null } : state;
}
function styles(state, action) {
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0__actions__["o" /* receiveStyles */].toString():
            var pl = action.payload;
            return {
                ids: state.ids.concat(pl.styleIDs),
                meta: pl.meta
            };
        case __WEBPACK_IMPORTED_MODULE_0__actions__["d" /* clearUserAction */].toString():
        case __WEBPACK_IMPORTED_MODULE_0__actions__["i" /* requestSpecials */].toString():
        case __WEBPACK_IMPORTED_MODULE_0__actions__["v" /* requestDifferentItems */].toString():
            return { ids: [], meta: null };
    }
    return !state ? { ids: [], meta: null } : state;
}
function specials(state, action) {
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0__actions__["n" /* receiveSpecials */].toString():
            var pl = action.payload;
            return {
                ids: state.ids.concat(pl.specialIDs),
                meta: pl.meta,
                loading: false
            };
        case __WEBPACK_IMPORTED_MODULE_0__actions__["i" /* requestSpecials */].toString():
            return {
                ids: state.ids,
                meta: state.meta,
                loading: true
            };
        case __WEBPACK_IMPORTED_MODULE_0__actions__["d" /* clearUserAction */].toString():
        case __WEBPACK_IMPORTED_MODULE_0__actions__["h" /* requestStyles */].toString():
        case __WEBPACK_IMPORTED_MODULE_0__actions__["v" /* requestDifferentItems */].toString():
            return { ids: [], meta: null, loading: null };
    }
    return !state ? { ids: [], meta: null, loading: null } : state;
}
function styleLoad(state, action) {
    if (state === void 0) { state = false; }
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0__actions__["h" /* requestStyles */].toString():
            return action.payload.tab === "style";
        case __WEBPACK_IMPORTED_MODULE_0__actions__["i" /* requestSpecials */].toString():
            return false;
    }
    return state;
}
function likedStyleLoad(state, action) {
    if (state === void 0) { state = false; }
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0__actions__["h" /* requestStyles */].toString():
            return action.payload.tab === "likedStyle";
        case __WEBPACK_IMPORTED_MODULE_0__actions__["i" /* requestSpecials */].toString():
            return false;
    }
    return state;
}
function loadingTab(state, action) {
    if (state === void 0) { state = false; }
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0__actions__["h" /* requestStyles */].toString():
        case __WEBPACK_IMPORTED_MODULE_0__actions__["i" /* requestSpecials */].toString():
            return true;
        case __WEBPACK_IMPORTED_MODULE_0__actions__["o" /* receiveStyles */].toString():
        case __WEBPACK_IMPORTED_MODULE_0__actions__["n" /* receiveSpecials */].toString():
            return false;
    }
    return state;
}
function followModalTab(state, action) {
    if (state === void 0) { state = false; }
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0__actions__["j" /* requestUsers */].toString():
            return true;
        case __WEBPACK_IMPORTED_MODULE_0__actions__["k" /* requestShops */].toString():
            return false;
    }
    return state;
}
function currentUserID(state, action) {
    if (state === void 0) { state = null; }
    if (action.type == __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* addCurrentUserAction */].toString())
        return action.payload.id;
    return state;
}
function stateList(state, action) {
    if (state === void 0) { state = []; }
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0__actions__["p" /* commonStateAction */].toString():
            return action.payload.stateList;
    }
    return state;
}
function cityList(state, action) {
    if (state === void 0) { state = []; }
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0__actions__["q" /* commonCityAction */].toString():
            return action.payload.cityList;
    }
    return state;
}
function isSaving(state, action) {
    if (state === void 0) { state = false; }
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0__actions__["r" /* requestUserSave */].toString():
            return true;
        case __WEBPACK_IMPORTED_MODULE_0__actions__["s" /* receiveUserSave */].toString():
            return false;
    }
    return state;
}


/***/ }),

/***/ "./app/client/user/selectors.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return loadingTabSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return loadingUserSelector; });
/* unused harmony export stateListSelector */
/* unused harmony export cityListSelector */
/* unused harmony export saveSelector */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return styleLoadSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return likedStyleLoadSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return userIDSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return followModalTabSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return currentUserIdSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return currentUserSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getUsersSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getShopsSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getStylesSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getSpecialsSelector; });
var loadingTabSelector = function (state) { return state.user.loadingTab; };
var loadingUserSelector = function (state) { return state.user.loadingUser; };
var stateListSelector = function (state) { return state.user.stateList; };
var cityListSelector = function (state) { return state.user.cityList; };
var saveSelector = function (state) { return state.user.isSaving; };
var styleLoadSelector = function (state) { return state.user.styleLoad; };
var likedStyleLoadSelector = function (state) { return state.user.likedStyleLoad; };
var userIDSelector = function (state) { return state.user.userID; };
var followModalTabSelector = function (state) { return state.user.followModalTab; };
var currentUserIdSelector = function (state) { return state.user.currentUserID; };
var currentUserSelector = function (state) { return state.data.users.get(state.user.currentUserID); };
var getUsersSelector = function (state) { return state.user.users; };
var getShopsSelector = function (state) { return state.user.shops; };
var getStylesSelector = function (state) { return state.user.styles; };
var getSpecialsSelector = function (state) { return state.user.specials; };


/***/ })

},["./app/client/_packs/client.tsx"]);


// WEBPACK FOOTER //
// client-4415e65c9171e47fd9e6.js